webpackJsonp([1],{

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(1144);
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(1148);
function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(1151);
function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(1153);
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(1158);
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bs4_datepicker__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_TitleNavBar__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_DashboardTile__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Card__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DataTable__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_GoogleAutoComplete__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_SkilloChart__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_add_to_calendar__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_add_to_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_add_to_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_excel__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fullcalendar__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullcalendar__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar_dist_locale_it__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar_dist_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fullcalendar_dist_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__);

















var Components = {};

Components.install = function (Vue) {
  Vue.component('TitleNavbar', __WEBPACK_IMPORTED_MODULE_1__components_layout_TitleNavBar__["a" /* default */]);
  Vue.component('DashboardTile', __WEBPACK_IMPORTED_MODULE_2__components_layout_DashboardTile__["a" /* default */]);
  Vue.component('Card', __WEBPACK_IMPORTED_MODULE_3__components_layout_Card__["a" /* default */]);
  Vue.component('DataTable', __WEBPACK_IMPORTED_MODULE_4__components_common_DataTable__["a" /* default */]);
  Vue.component('GoogleAutocomplete', __WEBPACK_IMPORTED_MODULE_5__components_common_GoogleAutoComplete__["a" /* default */]);
  Vue.component('Datepicker', __WEBPACK_IMPORTED_MODULE_0__bs4_datepicker__["a" /* default */]);
  Vue.component('SkilloChart', __WEBPACK_IMPORTED_MODULE_6__components_common_SkilloChart__["a" /* default */]);
  Vue.component('FullCalendar', __WEBPACK_IMPORTED_MODULE_9__fullcalendar__["a" /* default */]);
  Vue.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_8_vue_json_excel__["a" /* default */]);
  Vue.use(__WEBPACK_IMPORTED_MODULE_7_vue_add_to_calendar___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (Components);

/***/ }),

/***/ 1164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DatetimePickerPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_vue__ = __webpack_require__(1165);
/* unused harmony reexport component */


var DatetimePickerPlugin = function DatetimePickerPlugin(Vue, params) {
  var name = 'date-picker';
  /* istanbul ignore else */
  if (typeof params === 'string') name = params;

  Vue.component(name, __WEBPACK_IMPORTED_MODULE_0__component_vue__["a" /* default */]);
};

__WEBPACK_IMPORTED_MODULE_0__component_vue__["a" /* default */].install = DatetimePickerPlugin;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__component_vue__["a" /* default */]);


/***/ }),

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ecf417_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__ = __webpack_require__(1194);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ecf417_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, jQuery, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


!function (e) {
  "use strict";
  if ("function" == typeof define && __webpack_require__(1192)) define(["jquery", "moment"], e);else if ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports))) module.exports = e(__webpack_require__(85), __webpack_require__(0));else {
    if ("undefined" == typeof jQuery) throw "bootstrap-datetimepicker requires jQuery to be loaded first";if ("undefined" == typeof moment) throw "bootstrap-datetimepicker requires Moment.js to be loaded first";e(jQuery, moment);
  }
}(function (e, t) {
  "use strict";
  if (!t) throw new Error("bootstrap-datetimepicker requires Moment.js to be loaded first");var a = function a(_a, n) {
    var r,
        i,
        o,
        s,
        d,
        l,
        p,
        c = {},
        u = !0,
        f = !1,
        m = !1,
        h = 0,
        y = [{ clsName: "days", navFnc: "M", navStep: 1 }, { clsName: "months", navFnc: "y", navStep: 1 }, { clsName: "years", navFnc: "y", navStep: 10 }, { clsName: "decades", navFnc: "y", navStep: 100 }],
        w = ["days", "months", "years", "decades"],
        b = ["top", "bottom", "auto"],
        g = ["left", "right", "auto"],
        v = ["default", "top", "bottom"],
        k = { up: 38, 38: "up", down: 40, 40: "down", left: 37, 37: "left", right: 39, 39: "right", tab: 9, 9: "tab", escape: 27, 27: "escape", enter: 13, 13: "enter", pageUp: 33, 33: "pageUp", pageDown: 34, 34: "pageDown", shift: 16, 16: "shift", control: 17, 17: "control", space: 32, 32: "space", t: 84, 84: "t", delete: 46, 46: "delete" },
        D = {},
        C = function C() {
      return void 0 !== t.tz && void 0 !== n.timeZone && null !== n.timeZone && "" !== n.timeZone;
    },
        x = function x(e) {
      var a;return a = void 0 === e || null === e ? t() : t.isDate(e) || t.isMoment(e) ? t(e) : C() ? t.tz(e, l, n.useStrict, n.timeZone) : t(e, l, n.useStrict), C() && a.tz(n.timeZone), a;
    },
        T = function T(e) {
      if ("string" != typeof e || e.length > 1) throw new TypeError("isEnabled expects a single character string parameter");switch (e) {case "y":
          return -1 !== d.indexOf("Y");case "M":
          return -1 !== d.indexOf("M");case "d":
          return -1 !== d.toLowerCase().indexOf("d");case "h":case "H":
          return -1 !== d.toLowerCase().indexOf("h");case "m":
          return -1 !== d.indexOf("m");case "s":
          return -1 !== d.indexOf("s");default:
          return !1;}
    },
        M = function M() {
      return T("h") || T("m") || T("s");
    },
        S = function S() {
      return T("y") || T("M") || T("d");
    },
        O = function O() {
      var t = e("<thead>").append(e("<tr>").append(e("<th>").addClass("prev").attr("data-action", "previous").append(e("<i>").addClass(n.icons.previous))).append(e("<th>").addClass("picker-switch").attr("data-action", "pickerSwitch").attr("colspan", n.calendarWeeks ? "6" : "5")).append(e("<th>").addClass("next").attr("data-action", "next").append(e("<i>").addClass(n.icons.next)))),
          a = e("<tbody>").append(e("<tr>").append(e("<td>").attr("colspan", n.calendarWeeks ? "8" : "7")));return [e("<div>").addClass("datepicker-days").append(e("<table>").addClass("table-condensed").append(t).append(e("<tbody>"))), e("<div>").addClass("datepicker-months").append(e("<table>").addClass("table-condensed").append(t.clone()).append(a.clone())), e("<div>").addClass("datepicker-years").append(e("<table>").addClass("table-condensed").append(t.clone()).append(a.clone())), e("<div>").addClass("datepicker-decades").append(e("<table>").addClass("table-condensed").append(t.clone()).append(a.clone()))];
    },
        P = function P() {
      var t = e("<tr>"),
          a = e("<tr>"),
          r = e("<tr>");return T("h") && (t.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.incrementHour }).addClass("btn").attr("data-action", "incrementHours").append(e("<i>").addClass(n.icons.up)))), a.append(e("<td>").append(e("<span>").addClass("timepicker-hour").attr({ "data-time-component": "hours", title: n.tooltips.pickHour }).attr("data-action", "showHours"))), r.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.decrementHour }).addClass("btn").attr("data-action", "decrementHours").append(e("<i>").addClass(n.icons.down))))), T("m") && (T("h") && (t.append(e("<td>").addClass("separator")), a.append(e("<td>").addClass("separator").html(":")), r.append(e("<td>").addClass("separator"))), t.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.incrementMinute }).addClass("btn").attr("data-action", "incrementMinutes").append(e("<i>").addClass(n.icons.up)))), a.append(e("<td>").append(e("<span>").addClass("timepicker-minute").attr({ "data-time-component": "minutes", title: n.tooltips.pickMinute }).attr("data-action", "showMinutes"))), r.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.decrementMinute }).addClass("btn").attr("data-action", "decrementMinutes").append(e("<i>").addClass(n.icons.down))))), T("s") && (T("m") && (t.append(e("<td>").addClass("separator")), a.append(e("<td>").addClass("separator").html(":")), r.append(e("<td>").addClass("separator"))), t.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.incrementSecond }).addClass("btn").attr("data-action", "incrementSeconds").append(e("<i>").addClass(n.icons.up)))), a.append(e("<td>").append(e("<span>").addClass("timepicker-second").attr({ "data-time-component": "seconds", title: n.tooltips.pickSecond }).attr("data-action", "showSeconds"))), r.append(e("<td>").append(e("<a>").attr({ href: "#", tabindex: "-1", title: n.tooltips.decrementSecond }).addClass("btn").attr("data-action", "decrementSeconds").append(e("<i>").addClass(n.icons.down))))), s || (t.append(e("<td>").addClass("separator")), a.append(e("<td>").append(e("<button>").addClass("btn btn-primary").attr({ "data-action": "togglePeriod", tabindex: "-1", title: n.tooltips.togglePeriod }))), r.append(e("<td>").addClass("separator"))), e("<div>").addClass("timepicker-picker").append(e("<table>").addClass("table-condensed").append([t, a, r]));
    },
        E = function E() {
      var t = e("<div>").addClass("timepicker-hours").append(e("<table>").addClass("table-condensed")),
          a = e("<div>").addClass("timepicker-minutes").append(e("<table>").addClass("table-condensed")),
          n = e("<div>").addClass("timepicker-seconds").append(e("<table>").addClass("table-condensed")),
          r = [P()];return T("h") && r.push(t), T("m") && r.push(a), T("s") && r.push(n), r;
    },
        H = function H() {
      var t = [];return n.showTodayButton && t.push(e("<td>").append(e("<a>").attr({ "data-action": "today", title: n.tooltips.today }).append(e("<i>").addClass(n.icons.today)))), !n.sideBySide && S() && M() && t.push(e("<td>").append(e("<a>").attr({ "data-action": "togglePicker", title: n.tooltips.selectTime }).append(e("<i>").addClass(n.icons.time)))), n.showClear && t.push(e("<td>").append(e("<a>").attr({ "data-action": "clear", title: n.tooltips.clear }).append(e("<i>").addClass(n.icons.clear)))), n.showClose && t.push(e("<td>").append(e("<a>").attr({ "data-action": "close", title: n.tooltips.close }).append(e("<i>").addClass(n.icons.close)))), e("<table>").addClass("table-condensed").append(e("<tbody>").append(e("<tr>").append(t)));
    },
        I = function I() {
      var t = e("<div>").addClass("bootstrap-datetimepicker-widget dropdown-menu"),
          a = e("<div>").addClass("datepicker").append(O()),
          r = e("<div>").addClass("timepicker").append(E()),
          i = e("<ul>").addClass("list-unstyled"),
          o = e("<li>").addClass("picker-switch" + (n.collapse ? " accordion-toggle" : "")).append(H());return n.inline && t.removeClass("dropdown-menu"), s && t.addClass("usetwentyfour"), T("s") && !s && t.addClass("wider"), n.sideBySide && S() && M() ? (t.addClass("timepicker-sbs"), "top" === n.toolbarPlacement && t.append(o), t.append(e("<div>").addClass("row").append(a.addClass("col-md-6")).append(r.addClass("col-md-6"))), "bottom" === n.toolbarPlacement && t.append(o), t) : ("top" === n.toolbarPlacement && i.append(o), S() && i.append(e("<li>").addClass(n.collapse && M() ? "collapse show" : "").append(a)), "default" === n.toolbarPlacement && i.append(o), M() && i.append(e("<li>").addClass(n.collapse && S() ? "collapse" : "").append(r)), "bottom" === n.toolbarPlacement && i.append(o), t.append(i));
    },
        Y = function Y() {
      var t,
          r = (f || _a).position(),
          i = (f || _a).offset(),
          o = n.widgetPositioning.vertical,
          s = n.widgetPositioning.horizontal;if (n.widgetParent) t = n.widgetParent.append(m);else if (_a.is("input")) t = _a.after(m).parent();else {
        if (n.inline) return void (t = _a.append(m));t = _a, _a.children().first().after(m);
      }if ("auto" === o && (o = i.top + 1.5 * m.height() >= e(window).height() + e(window).scrollTop() && m.height() + _a.outerHeight() < i.top ? "top" : "bottom"), "auto" === s && (s = t.width() < i.left + m.outerWidth() / 2 && i.left + m.outerWidth() > e(window).width() ? "right" : "left"), "top" === o ? m.addClass("top").removeClass("bottom") : m.addClass("bottom").removeClass("top"), "right" === s ? m.addClass("pull-right") : m.removeClass("pull-right"), "static" === t.css("position") && (t = t.parents().filter(function () {
        return "static" !== e(this).css("position");
      }).first()), 0 === t.length) throw new Error("datetimepicker component should be placed within a non-static positioned container");m.css({ top: "top" === o ? "auto" : r.top + _a.outerHeight(), bottom: "top" === o ? t.outerHeight() - (t === _a ? 0 : r.top) : "auto", left: "left" === s ? t === _a ? 0 : r.left : "auto", right: "left" === s ? "auto" : t.outerWidth() - _a.outerWidth() - (t === _a ? 0 : r.left) });
    },
        q = function q(e) {
      "dp.change" === e.type && (e.date && e.date.isSame(e.oldDate) || !e.date && !e.oldDate) || _a.trigger(e);
    },
        B = function B(e) {
      "y" === e && (e = "YYYY"), q({ type: "dp.update", change: e, viewDate: i.clone() });
    },
        j = function j(e) {
      m && (e && (p = Math.max(h, Math.min(3, p + e))), m.find(".datepicker > div").hide().filter(".datepicker-" + y[p].clsName).show());
    },
        A = function A() {
      var t = e("<tr>"),
          a = i.clone().startOf("w").startOf("d");for (!0 === n.calendarWeeks && t.append(e("<th>").addClass("cw").text("#")); a.isBefore(i.clone().endOf("w"));) {
        t.append(e("<th>").addClass("dow").text(a.format("dd"))), a.add(1, "d");
      }m.find(".datepicker-days thead").append(t);
    },
        F = function F(e) {
      return !0 === n.disabledDates[e.format("YYYY-MM-DD")];
    },
        L = function L(e) {
      return !0 === n.enabledDates[e.format("YYYY-MM-DD")];
    },
        W = function W(e) {
      return !0 === n.disabledHours[e.format("H")];
    },
        z = function z(e) {
      return !0 === n.enabledHours[e.format("H")];
    },
        N = function N(t, a) {
      if (!t.isValid()) return !1;if (n.disabledDates && "d" === a && F(t)) return !1;if (n.enabledDates && "d" === a && !L(t)) return !1;if (n.minDate && t.isBefore(n.minDate, a)) return !1;if (n.maxDate && t.isAfter(n.maxDate, a)) return !1;if (n.daysOfWeekDisabled && "d" === a && -1 !== n.daysOfWeekDisabled.indexOf(t.day())) return !1;if (n.disabledHours && ("h" === a || "m" === a || "s" === a) && W(t)) return !1;if (n.enabledHours && ("h" === a || "m" === a || "s" === a) && !z(t)) return !1;if (n.disabledTimeIntervals && ("h" === a || "m" === a || "s" === a)) {
        var r = !1;if (e.each(n.disabledTimeIntervals, function () {
          if (t.isBetween(this[0], this[1])) return r = !0, !1;
        }), r) return !1;
      }return !0;
    },
        V = function V() {
      for (var t = [], a = i.clone().startOf("y").startOf("d"); a.isSame(i, "y");) {
        t.push(e("<span>").attr("data-action", "selectMonth").addClass("month").text(a.format("MMM"))), a.add(1, "M");
      }m.find(".datepicker-months td").empty().append(t);
    },
        Z = function Z() {
      var t = m.find(".datepicker-months"),
          a = t.find("th"),
          o = t.find("tbody").find("span");a.eq(0).find("span").attr("title", n.tooltips.prevYear), a.eq(1).attr("title", n.tooltips.selectYear), a.eq(2).find("span").attr("title", n.tooltips.nextYear), t.find(".disabled").removeClass("disabled"), N(i.clone().subtract(1, "y"), "y") || a.eq(0).addClass("disabled"), a.eq(1).text(i.year()), N(i.clone().add(1, "y"), "y") || a.eq(2).addClass("disabled"), o.removeClass("active"), r.isSame(i, "y") && !u && o.eq(r.month()).addClass("active"), o.each(function (t) {
        N(i.clone().month(t), "M") || e(this).addClass("disabled");
      });
    },
        R = function R() {
      var e = m.find(".datepicker-years"),
          t = e.find("th"),
          a = i.clone().subtract(5, "y"),
          o = i.clone().add(6, "y"),
          s = "";for (t.eq(0).find("span").attr("title", n.tooltips.prevDecade), t.eq(1).attr("title", n.tooltips.selectDecade), t.eq(2).find("span").attr("title", n.tooltips.nextDecade), e.find(".disabled").removeClass("disabled"), n.minDate && n.minDate.isAfter(a, "y") && t.eq(0).addClass("disabled"), t.eq(1).text(a.year() + "-" + o.year()), n.maxDate && n.maxDate.isBefore(o, "y") && t.eq(2).addClass("disabled"); !a.isAfter(o, "y");) {
        s += '<span data-action="selectYear" class="year' + (a.isSame(r, "y") && !u ? " active" : "") + (N(a, "y") ? "" : " disabled") + '">' + a.year() + "</span>", a.add(1, "y");
      }e.find("td").html(s);
    },
        Q = function Q() {
      var e,
          a = m.find(".datepicker-decades"),
          o = a.find("th"),
          s = t({ y: i.year() - i.year() % 100 - 1 }),
          d = s.clone().add(100, "y"),
          l = s.clone(),
          p = !1,
          c = !1,
          u = "";for (o.eq(0).find("span").attr("title", n.tooltips.prevCentury), o.eq(2).find("span").attr("title", n.tooltips.nextCentury), a.find(".disabled").removeClass("disabled"), (s.isSame(t({ y: 1900 })) || n.minDate && n.minDate.isAfter(s, "y")) && o.eq(0).addClass("disabled"), o.eq(1).text(s.year() + "-" + d.year()), (s.isSame(t({ y: 2e3 })) || n.maxDate && n.maxDate.isBefore(d, "y")) && o.eq(2).addClass("disabled"); !s.isAfter(d, "y");) {
        e = s.year() + 12, p = n.minDate && n.minDate.isAfter(s, "y") && n.minDate.year() <= e, c = n.maxDate && n.maxDate.isAfter(s, "y") && n.maxDate.year() <= e, u += '<span data-action="selectDecade" class="decade' + (r.isAfter(s) && r.year() <= e ? " active" : "") + (N(s, "y") || p || c ? "" : " disabled") + '" data-selection="' + (s.year() + 6) + '">' + (s.year() + 1) + " - " + (s.year() + 12) + "</span>", s.add(12, "y");
      }u += "<span></span><span></span><span></span>", a.find("td").html(u), o.eq(1).text(l.year() + 1 + "-" + s.year());
    },
        U = function U() {
      var t,
          a,
          o,
          s = m.find(".datepicker-days"),
          d = s.find("th"),
          l = [],
          p = [];if (S()) {
        for (d.eq(0).find("span").attr("title", n.tooltips.prevMonth), d.eq(1).attr("title", n.tooltips.selectMonth), d.eq(2).find("span").attr("title", n.tooltips.nextMonth), s.find(".disabled").removeClass("disabled"), d.eq(1).text(i.format(n.dayViewHeaderFormat)), N(i.clone().subtract(1, "M"), "M") || d.eq(0).addClass("disabled"), N(i.clone().add(1, "M"), "M") || d.eq(2).addClass("disabled"), t = i.clone().startOf("M").startOf("w").startOf("d"), o = 0; o < 42; o++) {
          0 === t.weekday() && (a = e("<tr>"), n.calendarWeeks && a.append('<td class="cw">' + t.week() + "</td>"), l.push(a)), p = ["day"], t.isBefore(i, "M") && p.push("old"), t.isAfter(i, "M") && p.push("new"), t.isSame(r, "d") && !u && p.push("active"), N(t, "d") || p.push("disabled"), t.isSame(x(), "d") && p.push("today"), 0 !== t.day() && 6 !== t.day() || p.push("weekend"), q({ type: "dp.classify", date: t, classNames: p }), a.append('<td data-action="selectDay" data-day="' + t.format("L") + '" class="' + p.join(" ") + '">' + t.date() + "</td>"), t.add(1, "d");
        }s.find("tbody").empty().append(l), Z(), R(), Q();
      }
    },
        G = function G() {
      var t = m.find(".timepicker-hours table"),
          a = i.clone().startOf("d"),
          n = [],
          r = e("<tr>");for (i.hour() > 11 && !s && a.hour(12); a.isSame(i, "d") && (s || i.hour() < 12 && a.hour() < 12 || i.hour() > 11);) {
        a.hour() % 4 == 0 && (r = e("<tr>"), n.push(r)), r.append('<td data-action="selectHour" class="hour' + (N(a, "h") ? "" : " disabled") + '">' + a.format(s ? "HH" : "hh") + "</td>"), a.add(1, "h");
      }t.empty().append(n);
    },
        J = function J() {
      for (var t = m.find(".timepicker-minutes table"), a = i.clone().startOf("h"), r = [], o = e("<tr>"), s = 1 === n.stepping ? 5 : n.stepping; i.isSame(a, "h");) {
        a.minute() % (4 * s) == 0 && (o = e("<tr>"), r.push(o)), o.append('<td data-action="selectMinute" class="minute' + (N(a, "m") ? "" : " disabled") + '">' + a.format("mm") + "</td>"), a.add(s, "m");
      }t.empty().append(r);
    },
        K = function K() {
      for (var t = m.find(".timepicker-seconds table"), a = i.clone().startOf("m"), n = [], r = e("<tr>"); i.isSame(a, "m");) {
        a.second() % 20 == 0 && (r = e("<tr>"), n.push(r)), r.append('<td data-action="selectSecond" class="second' + (N(a, "s") ? "" : " disabled") + '">' + a.format("ss") + "</td>"), a.add(5, "s");
      }t.empty().append(n);
    },
        X = function X() {
      var e,
          t,
          a = m.find(".timepicker span[data-time-component]");s || (e = m.find(".timepicker [data-action=togglePeriod]"), t = r.clone().add(r.hours() >= 12 ? -12 : 12, "h"), e.text(r.format("A")), N(t, "h") ? e.removeClass("disabled") : e.addClass("disabled")), a.filter("[data-time-component=hours]").text(r.format(s ? "HH" : "hh")), a.filter("[data-time-component=minutes]").text(r.format("mm")), a.filter("[data-time-component=seconds]").text(r.format("ss")), G(), J(), K();
    },
        $ = function $() {
      m && (U(), X());
    },
        _ = function _(e) {
      var t = u ? null : r;if (!e) return u = !0, o.val(""), _a.data("date", ""), q({ type: "dp.change", date: !1, oldDate: t }), void $();if (e = e.clone().locale(n.locale), C() && e.tz(n.timeZone), 1 !== n.stepping) for (e.minutes(Math.round(e.minutes() / n.stepping) * n.stepping).seconds(0); n.minDate && e.isBefore(n.minDate);) {
        e.add(n.stepping, "minutes");
      }N(e) ? (i = (r = e).clone(), o.val(r.format(d)), _a.data("date", r.format(d)), u = !1, $(), q({ type: "dp.change", date: r.clone(), oldDate: t })) : (n.keepInvalid ? q({ type: "dp.change", date: e, oldDate: t }) : o.val(u ? "" : r.format(d)), q({ type: "dp.error", date: e, oldDate: t }));
    },
        ee = function ee() {
      var t = !1;return m ? (m.find(".collapse").each(function () {
        var a = e(this).data("collapse");return !a || !a.transitioning || (t = !0, !1);
      }), t ? c : (f && f.hasClass("btn") && f.toggleClass("active"), m.hide(), e(window).off("resize", Y), m.off("click", "[data-action]"), m.off("mousedown", !1), m.remove(), m = !1, q({ type: "dp.hide", date: r.clone() }), o.blur(), i = r.clone(), c)) : c;
    },
        te = function te() {
      _(null);
    },
        ae = function ae(e) {
      return void 0 === n.parseInputDate ? (!t.isMoment(e) || e instanceof Date) && (e = x(e)) : e = n.parseInputDate(e), e;
    },
        ne = { next: function next() {
        var e = y[p].navFnc;i.add(y[p].navStep, e), U(), B(e);
      }, previous: function previous() {
        var e = y[p].navFnc;i.subtract(y[p].navStep, e), U(), B(e);
      }, pickerSwitch: function pickerSwitch() {
        j(1);
      }, selectMonth: function selectMonth(t) {
        var a = e(t.target).closest("tbody").find("span").index(e(t.target));i.month(a), p === h ? (_(r.clone().year(i.year()).month(i.month())), n.inline || ee()) : (j(-1), U()), B("M");
      }, selectYear: function selectYear(t) {
        var a = parseInt(e(t.target).text(), 10) || 0;i.year(a), p === h ? (_(r.clone().year(i.year())), n.inline || ee()) : (j(-1), U()), B("YYYY");
      }, selectDecade: function selectDecade(t) {
        var a = parseInt(e(t.target).data("selection"), 10) || 0;i.year(a), p === h ? (_(r.clone().year(i.year())), n.inline || ee()) : (j(-1), U()), B("YYYY");
      }, selectDay: function selectDay(t) {
        var a = i.clone();e(t.target).is(".old") && a.subtract(1, "M"), e(t.target).is(".new") && a.add(1, "M"), _(a.date(parseInt(e(t.target).text(), 10))), M() || n.keepOpen || n.inline || ee();
      }, incrementHours: function incrementHours() {
        var e = r.clone().add(1, "h");N(e, "h") && _(e);
      }, incrementMinutes: function incrementMinutes() {
        var e = r.clone().add(n.stepping, "m");N(e, "m") && _(e);
      }, incrementSeconds: function incrementSeconds() {
        var e = r.clone().add(1, "s");N(e, "s") && _(e);
      }, decrementHours: function decrementHours() {
        var e = r.clone().subtract(1, "h");N(e, "h") && _(e);
      }, decrementMinutes: function decrementMinutes() {
        var e = r.clone().subtract(n.stepping, "m");N(e, "m") && _(e);
      }, decrementSeconds: function decrementSeconds() {
        var e = r.clone().subtract(1, "s");N(e, "s") && _(e);
      }, togglePeriod: function togglePeriod() {
        _(r.clone().add(r.hours() >= 12 ? -12 : 12, "h"));
      }, togglePicker: function togglePicker(t) {
        var a,
            r = e(t.target),
            i = r.closest("ul"),
            o = i.find(".show"),
            s = i.find(".collapse:not(.show)");if (o && o.length) {
          if ((a = o.data("collapse")) && a.transitioning) return;o.collapse ? (o.collapse("hide"), s.collapse("show")) : (o.removeClass("show"), s.addClass("show")), r.is("i") ? r.toggleClass(n.icons.time + " " + n.icons.date) : r.find("i").toggleClass(n.icons.time + " " + n.icons.date);
        }
      }, showPicker: function showPicker() {
        m.find(".timepicker > div:not(.timepicker-picker)").hide(), m.find(".timepicker .timepicker-picker").show();
      }, showHours: function showHours() {
        m.find(".timepicker .timepicker-picker").hide(), m.find(".timepicker .timepicker-hours").show();
      }, showMinutes: function showMinutes() {
        m.find(".timepicker .timepicker-picker").hide(), m.find(".timepicker .timepicker-minutes").show();
      }, showSeconds: function showSeconds() {
        m.find(".timepicker .timepicker-picker").hide(), m.find(".timepicker .timepicker-seconds").show();
      }, selectHour: function selectHour(t) {
        var a = parseInt(e(t.target).text(), 10);s || (r.hours() >= 12 ? 12 !== a && (a += 12) : 12 === a && (a = 0)), _(r.clone().hours(a)), ne.showPicker.call(c);
      }, selectMinute: function selectMinute(t) {
        _(r.clone().minutes(parseInt(e(t.target).text(), 10))), ne.showPicker.call(c);
      }, selectSecond: function selectSecond(t) {
        _(r.clone().seconds(parseInt(e(t.target).text(), 10))), ne.showPicker.call(c);
      }, clear: te, today: function today() {
        var e = x();N(e, "d") && _(e);
      }, close: ee },
        re = function re(t) {
      return !e(t.currentTarget).is(".disabled") && (ne[e(t.currentTarget).data("action")].apply(c, arguments), !1);
    },
        ie = function ie() {
      var t,
          a = { year: function year(e) {
          return e.month(0).date(1).hours(0).seconds(0).minutes(0);
        }, month: function month(e) {
          return e.date(1).hours(0).seconds(0).minutes(0);
        }, day: function day(e) {
          return e.hours(0).seconds(0).minutes(0);
        }, hour: function hour(e) {
          return e.seconds(0).minutes(0);
        }, minute: function minute(e) {
          return e.seconds(0);
        } };return o.prop("disabled") || !n.ignoreReadonly && o.prop("readonly") || m ? c : (void 0 !== o.val() && 0 !== o.val().trim().length ? _(ae(o.val().trim())) : u && n.useCurrent && (n.inline || o.is("input") && 0 === o.val().trim().length) && (t = x(), "string" == typeof n.useCurrent && (t = a[n.useCurrent](t)), _(t)), m = I(), A(), V(), m.find(".timepicker-hours").hide(), m.find(".timepicker-minutes").hide(), m.find(".timepicker-seconds").hide(), $(), j(), e(window).on("resize", Y), m.on("click", "[data-action]", re), m.on("mousedown", !1), f && f.hasClass("btn") && f.toggleClass("active"), Y(), m.show(), n.focusOnShow && !o.is(":focus") && o.focus(), q({ type: "dp.show" }), c);
    },
        oe = function oe() {
      return m ? ee() : ie();
    },
        se = function se(e) {
      var t,
          a,
          r,
          i,
          o = null,
          s = [],
          d = {},
          l = e.which;D[l] = "p";for (t in D) {
        D.hasOwnProperty(t) && "p" === D[t] && (s.push(t), parseInt(t, 10) !== l && (d[t] = !0));
      }for (t in n.keyBinds) {
        if (n.keyBinds.hasOwnProperty(t) && "function" == typeof n.keyBinds[t] && (r = t.split(" ")).length === s.length && k[l] === r[r.length - 1]) {
          for (i = !0, a = r.length - 2; a >= 0; a--) {
            if (!(k[r[a]] in d)) {
              i = !1;break;
            }
          }if (i) {
            o = n.keyBinds[t];break;
          }
        }
      }o && (o.call(c, m), e.stopPropagation(), e.preventDefault());
    },
        de = function de(e) {
      D[e.which] = "r", e.stopPropagation(), e.preventDefault();
    },
        le = function le(t) {
      var a = e(t.target).val().trim(),
          n = a ? ae(a) : null;return _(n), t.stopImmediatePropagation(), !1;
    },
        pe = function pe() {
      o.off({ change: le, blur: blur, keydown: se, keyup: de, focus: n.allowInputToggle ? ee : "" }), _a.is("input") ? o.off({ focus: ie }) : f && (f.off("click", oe), f.off("mousedown", !1));
    },
        ce = function ce(t) {
      var a = {};return e.each(t, function () {
        var e = ae(this);e.isValid() && (a[e.format("YYYY-MM-DD")] = !0);
      }), !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(a).length && a;
    },
        ue = function ue(t) {
      var a = {};return e.each(t, function () {
        a[this] = !0;
      }), !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(a).length && a;
    },
        fe = function fe() {
      var e = n.format || "L LT";d = e.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (e) {
        return (r.localeData().longDateFormat(e) || e).replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (e) {
          return r.localeData().longDateFormat(e) || e;
        });
      }), (l = n.extraFormats ? n.extraFormats.slice() : []).indexOf(e) < 0 && l.indexOf(d) < 0 && l.push(d), s = d.toLowerCase().indexOf("a") < 1 && d.replace(/\[.*?\]/g, "").indexOf("h") < 1, T("y") && (h = 2), T("M") && (h = 1), T("d") && (h = 0), p = Math.max(h, p), u || _(r);
    };if (c.destroy = function () {
      ee(), pe(), _a.removeData("DateTimePicker"), _a.removeData("date");
    }, c.toggle = oe, c.show = ie, c.hide = ee, c.disable = function () {
      return ee(), f && f.hasClass("btn") && f.addClass("disabled"), o.prop("disabled", !0), c;
    }, c.enable = function () {
      return f && f.hasClass("btn") && f.removeClass("disabled"), o.prop("disabled", !1), c;
    }, c.ignoreReadonly = function (e) {
      if (0 === arguments.length) return n.ignoreReadonly;if ("boolean" != typeof e) throw new TypeError("ignoreReadonly () expects a boolean parameter");return n.ignoreReadonly = e, c;
    }, c.options = function (t) {
      if (0 === arguments.length) return e.extend(!0, {}, n);if (!(t instanceof Object)) throw new TypeError("options() options parameter should be an object");return e.extend(!0, n, t), e.each(n, function (e, t) {
        if (void 0 === c[e]) throw new TypeError("option " + e + " is not recognized!");c[e](t);
      }), c;
    }, c.date = function (e) {
      if (0 === arguments.length) return u ? null : r.clone();if (!(null === e || "string" == typeof e || t.isMoment(e) || e instanceof Date)) throw new TypeError("date() parameter must be one of [null, string, moment or Date]");return _(null === e ? null : ae(e)), c;
    }, c.format = function (e) {
      if (0 === arguments.length) return n.format;if ("string" != typeof e && ("boolean" != typeof e || !1 !== e)) throw new TypeError("format() expects a string or boolean:false parameter " + e);return n.format = e, d && fe(), c;
    }, c.timeZone = function (e) {
      if (0 === arguments.length) return n.timeZone;if ("string" != typeof e) throw new TypeError("newZone() expects a string parameter");return n.timeZone = e, c;
    }, c.dayViewHeaderFormat = function (e) {
      if (0 === arguments.length) return n.dayViewHeaderFormat;if ("string" != typeof e) throw new TypeError("dayViewHeaderFormat() expects a string parameter");return n.dayViewHeaderFormat = e, c;
    }, c.extraFormats = function (e) {
      if (0 === arguments.length) return n.extraFormats;if (!1 !== e && !(e instanceof Array)) throw new TypeError("extraFormats() expects an array or false parameter");return n.extraFormats = e, l && fe(), c;
    }, c.disabledDates = function (t) {
      if (0 === arguments.length) return n.disabledDates ? e.extend({}, n.disabledDates) : n.disabledDates;if (!t) return n.disabledDates = !1, $(), c;if (!(t instanceof Array)) throw new TypeError("disabledDates() expects an array parameter");return n.disabledDates = ce(t), n.enabledDates = !1, $(), c;
    }, c.enabledDates = function (t) {
      if (0 === arguments.length) return n.enabledDates ? e.extend({}, n.enabledDates) : n.enabledDates;if (!t) return n.enabledDates = !1, $(), c;if (!(t instanceof Array)) throw new TypeError("enabledDates() expects an array parameter");return n.enabledDates = ce(t), n.disabledDates = !1, $(), c;
    }, c.daysOfWeekDisabled = function (e) {
      if (0 === arguments.length) return n.daysOfWeekDisabled.splice(0);if ("boolean" == typeof e && !e) return n.daysOfWeekDisabled = !1, $(), c;if (!(e instanceof Array)) throw new TypeError("daysOfWeekDisabled() expects an array parameter");if (n.daysOfWeekDisabled = e.reduce(function (e, t) {
        return (t = parseInt(t, 10)) > 6 || t < 0 || isNaN(t) ? e : (-1 === e.indexOf(t) && e.push(t), e);
      }, []).sort(), n.useCurrent && !n.keepInvalid) {
        for (var t = 0; !N(r, "d");) {
          if (r.add(1, "d"), 31 === t) throw "Tried 31 times to find a valid date";t++;
        }_(r);
      }return $(), c;
    }, c.maxDate = function (e) {
      if (0 === arguments.length) return n.maxDate ? n.maxDate.clone() : n.maxDate;if ("boolean" == typeof e && !1 === e) return n.maxDate = !1, $(), c;"string" == typeof e && ("now" !== e && "moment" !== e || (e = x()));var t = ae(e);if (!t.isValid()) throw new TypeError("maxDate() Could not parse date parameter: " + e);if (n.minDate && t.isBefore(n.minDate)) throw new TypeError("maxDate() date parameter is before options.minDate: " + t.format(d));return n.maxDate = t, n.useCurrent && !n.keepInvalid && r.isAfter(e) && _(n.maxDate), i.isAfter(t) && (i = t.clone().subtract(n.stepping, "m")), $(), c;
    }, c.minDate = function (e) {
      if (0 === arguments.length) return n.minDate ? n.minDate.clone() : n.minDate;if ("boolean" == typeof e && !1 === e) return n.minDate = !1, $(), c;"string" == typeof e && ("now" !== e && "moment" !== e || (e = x()));var t = ae(e);if (!t.isValid()) throw new TypeError("minDate() Could not parse date parameter: " + e);if (n.maxDate && t.isAfter(n.maxDate)) throw new TypeError("minDate() date parameter is after options.maxDate: " + t.format(d));return n.minDate = t, n.useCurrent && !n.keepInvalid && r.isBefore(e) && _(n.minDate), i.isBefore(t) && (i = t.clone().add(n.stepping, "m")), $(), c;
    }, c.defaultDate = function (e) {
      if (0 === arguments.length) return n.defaultDate ? n.defaultDate.clone() : n.defaultDate;if (!e) return n.defaultDate = !1, c;"string" == typeof e && (e = "now" === e || "moment" === e ? x() : x(e));var t = ae(e);if (!t.isValid()) throw new TypeError("defaultDate() Could not parse date parameter: " + e);if (!N(t)) throw new TypeError("defaultDate() date passed is invalid according to component setup validations");return n.defaultDate = t, (n.defaultDate && n.inline || "" === o.val().trim()) && _(n.defaultDate), c;
    }, c.locale = function (e) {
      if (0 === arguments.length) return n.locale;if (!t.localeData(e)) throw new TypeError("locale() locale " + e + " is not loaded from moment locales!");return n.locale = e, r.locale(n.locale), i.locale(n.locale), d && fe(), m && (ee(), ie()), c;
    }, c.stepping = function (e) {
      return 0 === arguments.length ? n.stepping : (e = parseInt(e, 10), (isNaN(e) || e < 1) && (e = 1), n.stepping = e, c);
    }, c.useCurrent = function (e) {
      var t = ["year", "month", "day", "hour", "minute"];if (0 === arguments.length) return n.useCurrent;if ("boolean" != typeof e && "string" != typeof e) throw new TypeError("useCurrent() expects a boolean or string parameter");if ("string" == typeof e && -1 === t.indexOf(e.toLowerCase())) throw new TypeError("useCurrent() expects a string parameter of " + t.join(", "));return n.useCurrent = e, c;
    }, c.collapse = function (e) {
      if (0 === arguments.length) return n.collapse;if ("boolean" != typeof e) throw new TypeError("collapse() expects a boolean parameter");return n.collapse === e ? c : (n.collapse = e, m && (ee(), ie()), c);
    }, c.icons = function (t) {
      if (0 === arguments.length) return e.extend({}, n.icons);if (!(t instanceof Object)) throw new TypeError("icons() expects parameter to be an Object");return e.extend(n.icons, t), m && (ee(), ie()), c;
    }, c.tooltips = function (t) {
      if (0 === arguments.length) return e.extend({}, n.tooltips);if (!(t instanceof Object)) throw new TypeError("tooltips() expects parameter to be an Object");return e.extend(n.tooltips, t), m && (ee(), ie()), c;
    }, c.useStrict = function (e) {
      if (0 === arguments.length) return n.useStrict;if ("boolean" != typeof e) throw new TypeError("useStrict() expects a boolean parameter");return n.useStrict = e, c;
    }, c.sideBySide = function (e) {
      if (0 === arguments.length) return n.sideBySide;if ("boolean" != typeof e) throw new TypeError("sideBySide() expects a boolean parameter");return n.sideBySide = e, m && (ee(), ie()), c;
    }, c.viewMode = function (e) {
      if (0 === arguments.length) return n.viewMode;if ("string" != typeof e) throw new TypeError("viewMode() expects a string parameter");if (-1 === w.indexOf(e)) throw new TypeError("viewMode() parameter must be one of (" + w.join(", ") + ") value");return n.viewMode = e, p = Math.max(w.indexOf(e), h), j(), c;
    }, c.toolbarPlacement = function (e) {
      if (0 === arguments.length) return n.toolbarPlacement;if ("string" != typeof e) throw new TypeError("toolbarPlacement() expects a string parameter");if (-1 === v.indexOf(e)) throw new TypeError("toolbarPlacement() parameter must be one of (" + v.join(", ") + ") value");return n.toolbarPlacement = e, m && (ee(), ie()), c;
    }, c.widgetPositioning = function (t) {
      if (0 === arguments.length) return e.extend({}, n.widgetPositioning);if ("[object Object]" !== {}.toString.call(t)) throw new TypeError("widgetPositioning() expects an object variable");if (t.horizontal) {
        if ("string" != typeof t.horizontal) throw new TypeError("widgetPositioning() horizontal variable must be a string");if (t.horizontal = t.horizontal.toLowerCase(), -1 === g.indexOf(t.horizontal)) throw new TypeError("widgetPositioning() expects horizontal parameter to be one of (" + g.join(", ") + ")");n.widgetPositioning.horizontal = t.horizontal;
      }if (t.vertical) {
        if ("string" != typeof t.vertical) throw new TypeError("widgetPositioning() vertical variable must be a string");if (t.vertical = t.vertical.toLowerCase(), -1 === b.indexOf(t.vertical)) throw new TypeError("widgetPositioning() expects vertical parameter to be one of (" + b.join(", ") + ")");n.widgetPositioning.vertical = t.vertical;
      }return $(), c;
    }, c.calendarWeeks = function (e) {
      if (0 === arguments.length) return n.calendarWeeks;if ("boolean" != typeof e) throw new TypeError("calendarWeeks() expects parameter to be a boolean value");return n.calendarWeeks = e, $(), c;
    }, c.showTodayButton = function (e) {
      if (0 === arguments.length) return n.showTodayButton;if ("boolean" != typeof e) throw new TypeError("showTodayButton() expects a boolean parameter");return n.showTodayButton = e, m && (ee(), ie()), c;
    }, c.showClear = function (e) {
      if (0 === arguments.length) return n.showClear;if ("boolean" != typeof e) throw new TypeError("showClear() expects a boolean parameter");return n.showClear = e, m && (ee(), ie()), c;
    }, c.widgetParent = function (t) {
      if (0 === arguments.length) return n.widgetParent;if ("string" == typeof t && (t = e(t)), null !== t && "string" != typeof t && !(t instanceof e)) throw new TypeError("widgetParent() expects a string or a jQuery object parameter");return n.widgetParent = t, m && (ee(), ie()), c;
    }, c.keepOpen = function (e) {
      if (0 === arguments.length) return n.keepOpen;if ("boolean" != typeof e) throw new TypeError("keepOpen() expects a boolean parameter");return n.keepOpen = e, c;
    }, c.focusOnShow = function (e) {
      if (0 === arguments.length) return n.focusOnShow;if ("boolean" != typeof e) throw new TypeError("focusOnShow() expects a boolean parameter");return n.focusOnShow = e, c;
    }, c.inline = function (e) {
      if (0 === arguments.length) return n.inline;if ("boolean" != typeof e) throw new TypeError("inline() expects a boolean parameter");return n.inline = e, c;
    }, c.clear = function () {
      return te(), c;
    }, c.keyBinds = function (e) {
      return 0 === arguments.length ? n.keyBinds : (n.keyBinds = e, c);
    }, c.getMoment = function (e) {
      return x(e);
    }, c.debug = function (e) {
      if ("boolean" != typeof e) throw new TypeError("debug() expects a boolean parameter");return n.debug = e, c;
    }, c.allowInputToggle = function (e) {
      if (0 === arguments.length) return n.allowInputToggle;if ("boolean" != typeof e) throw new TypeError("allowInputToggle() expects a boolean parameter");return n.allowInputToggle = e, c;
    }, c.showClose = function (e) {
      if (0 === arguments.length) return n.showClose;if ("boolean" != typeof e) throw new TypeError("showClose() expects a boolean parameter");return n.showClose = e, c;
    }, c.keepInvalid = function (e) {
      if (0 === arguments.length) return n.keepInvalid;if ("boolean" != typeof e) throw new TypeError("keepInvalid() expects a boolean parameter");return n.keepInvalid = e, c;
    }, c.datepickerInput = function (e) {
      if (0 === arguments.length) return n.datepickerInput;if ("string" != typeof e) throw new TypeError("datepickerInput() expects a string parameter");return n.datepickerInput = e, c;
    }, c.parseInputDate = function (e) {
      if (0 === arguments.length) return n.parseInputDate;if ("function" != typeof e) throw new TypeError("parseInputDate() sholud be as function");return n.parseInputDate = e, c;
    }, c.disabledTimeIntervals = function (t) {
      if (0 === arguments.length) return n.disabledTimeIntervals ? e.extend({}, n.disabledTimeIntervals) : n.disabledTimeIntervals;if (!t) return n.disabledTimeIntervals = !1, $(), c;if (!(t instanceof Array)) throw new TypeError("disabledTimeIntervals() expects an array parameter");return n.disabledTimeIntervals = t, $(), c;
    }, c.disabledHours = function (t) {
      if (0 === arguments.length) return n.disabledHours ? e.extend({}, n.disabledHours) : n.disabledHours;if (!t) return n.disabledHours = !1, $(), c;if (!(t instanceof Array)) throw new TypeError("disabledHours() expects an array parameter");if (n.disabledHours = ue(t), n.enabledHours = !1, n.useCurrent && !n.keepInvalid) {
        for (var a = 0; !N(r, "h");) {
          if (r.add(1, "h"), 24 === a) throw "Tried 24 times to find a valid date";a++;
        }_(r);
      }return $(), c;
    }, c.enabledHours = function (t) {
      if (0 === arguments.length) return n.enabledHours ? e.extend({}, n.enabledHours) : n.enabledHours;if (!t) return n.enabledHours = !1, $(), c;if (!(t instanceof Array)) throw new TypeError("enabledHours() expects an array parameter");if (n.enabledHours = ue(t), n.disabledHours = !1, n.useCurrent && !n.keepInvalid) {
        for (var a = 0; !N(r, "h");) {
          if (r.add(1, "h"), 24 === a) throw "Tried 24 times to find a valid date";a++;
        }_(r);
      }return $(), c;
    }, c.viewDate = function (e) {
      if (0 === arguments.length) return i.clone();if (!e) return i = r.clone(), c;if (!("string" == typeof e || t.isMoment(e) || e instanceof Date)) throw new TypeError("viewDate() parameter must be one of [string, moment or Date]");return i = ae(e), B(), c;
    }, _a.is("input")) o = _a;else if (0 === (o = _a.find(n.datepickerInput)).length) o = _a.find("input");else if (!o.is("input")) throw new Error('CSS class "' + n.datepickerInput + '" cannot be applied to non input element');if (_a.hasClass("input-group") && (f = 0 === _a.find(".datepickerbutton").length ? _a.find(".input-group-addon") : _a.find(".datepickerbutton")), !n.inline && !o.is("input")) throw new Error("Could not initialize DateTimePicker without an input element");return r = x(), i = r.clone(), e.extend(!0, n, function () {
      var t,
          r = {};return (t = _a.is("input") || n.inline ? _a.data() : _a.find("input").data()).dateOptions && t.dateOptions instanceof Object && (r = e.extend(!0, r, t.dateOptions)), e.each(n, function (e) {
        var a = "date" + e.charAt(0).toUpperCase() + e.slice(1);void 0 !== t[a] && (r[e] = t[a]);
      }), r;
    }()), c.options(n), fe(), o.on({ change: le, blur: n.debug ? "" : ee, keydown: se, keyup: de, focus: n.allowInputToggle ? ie : "" }), _a.is("input") ? o.on({ focus: ie }) : f && (f.on("click", oe), f.on("mousedown", !1)), o.prop("disabled") && c.disable(), o.is("input") && 0 !== o.val().trim().length ? _(ae(o.val().trim())) : n.defaultDate && void 0 === o.attr("placeholder") && _(n.defaultDate), n.inline && ie(), c;
  };return e.fn.datetimepicker = function (t) {
    t = t || {};var n,
        r = Array.prototype.slice.call(arguments, 1),
        i = !0,
        o = ["destroy", "hide", "show", "toggle"];if ("object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(t))) return this.each(function () {
      var n,
          r = e(this);r.data("DateTimePicker") || (n = e.extend(!0, {}, e.fn.datetimepicker.defaults, t), r.data("DateTimePicker", a(r, n)));
    });if ("string" == typeof t) return this.each(function () {
      var a = e(this).data("DateTimePicker");if (!a) throw new Error('bootstrap-datetimepicker("' + t + '") method was called on an element that is not using DateTimePicker');n = a[t].apply(a, r), i = n === a;
    }), i || e.inArray(t, o) > -1 ? this : n;throw new TypeError("Invalid arguments for DateTimePicker: " + t);
  }, e.fn.datetimepicker.defaults = { timeZone: "", format: !1, dayViewHeaderFormat: "MMMM YYYY", extraFormats: !1, stepping: 1, minDate: !1, maxDate: !1, useCurrent: !0, collapse: !0, locale: t.locale(), defaultDate: !1, disabledDates: !1, enabledDates: !1, icons: { time: "fa fa-clock-o", date: "fa fa-calendar", up: "fa fa-chevron-up", down: "fa fa-chevron-down", previous: "fa fa-chevron-left", next: "fa fa-chevron-right", today: "fa fa-crosshairs", clear: "fa fa-trash-o", close: "fa fa-times" }, tooltips: { today: "Go to today", clear: "Clear selection", close: "Close the picker", selectMonth: "Select Month", prevMonth: "Previous Month", nextMonth: "Next Month", selectYear: "Select Year", prevYear: "Previous Year", nextYear: "Next Year", selectDecade: "Select Decade", prevDecade: "Previous Decade", nextDecade: "Next Decade", prevCentury: "Previous Century", nextCentury: "Next Century", pickHour: "Pick Hour", incrementHour: "Increment Hour", decrementHour: "Decrement Hour", pickMinute: "Pick Minute", incrementMinute: "Increment Minute", decrementMinute: "Decrement Minute", pickSecond: "Pick Second", incrementSecond: "Increment Second", decrementSecond: "Decrement Second", togglePeriod: "Toggle Period", selectTime: "Select Time" }, useStrict: !1, sideBySide: !1, daysOfWeekDisabled: !1, calendarWeeks: !1, viewMode: "days", toolbarPlacement: "default", showTodayButton: !1, showClear: !1, showClose: !1, widgetPositioning: { horizontal: "auto", vertical: "auto" }, widgetParent: null, ignoreReadonly: !1, keepOpen: !1, focusOnShow: !0, inline: !1, keepInvalid: !1, datepickerInput: ".datepickerinput", keyBinds: { up: function up(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") ? this.date(t.clone().subtract(7, "d")) : this.date(t.clone().add(this.stepping(), "m"));
        }
      }, down: function down(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") ? this.date(t.clone().add(7, "d")) : this.date(t.clone().subtract(this.stepping(), "m"));
        } else this.show();
      }, "control up": function controlUp(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") ? this.date(t.clone().subtract(1, "y")) : this.date(t.clone().add(1, "h"));
        }
      }, "control down": function controlDown(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") ? this.date(t.clone().add(1, "y")) : this.date(t.clone().subtract(1, "h"));
        }
      }, left: function left(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") && this.date(t.clone().subtract(1, "d"));
        }
      }, right: function right(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") && this.date(t.clone().add(1, "d"));
        }
      }, pageUp: function pageUp(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") && this.date(t.clone().subtract(1, "M"));
        }
      }, pageDown: function pageDown(e) {
        if (e) {
          var t = this.date() || this.getMoment();e.find(".datepicker").is(":visible") && this.date(t.clone().add(1, "M"));
        }
      }, enter: function enter() {
        this.hide();
      }, escape: function escape() {
        this.hide();
      }, "control space": function controlSpace(e) {
        e && e.find(".timepicker").is(":visible") && e.find('.btn[data-action="togglePeriod"]').click();
      }, t: function t() {
        this.date(this.getMoment());
      }, delete: function _delete() {
        this.clear();
      } }, debug: !1, allowInputToggle: !1, disabledTimeIntervals: !1, disabledHours: !1, enabledHours: !1, viewDate: !1 }, e.fn.datetimepicker;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1167)(module), __webpack_require__(85), __webpack_require__(0)))

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.inline)?_c('div',{staticClass:"datetimepicker-inline"}):_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_TitleNavBar_js__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c274f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleNavBar_vue__ = __webpack_require__(1197);
function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var normalizeComponent = __webpack_require__(11)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c274f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_TitleNavBar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c274f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleNavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"cat__core__top-sidebar cat__core__top-sidebar--bg"},[_c('span',{staticClass:"cat__core__title d-block mb-2"},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("placeholder")(_vm.prev,'Home'))+" ·")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.desc)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTile_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa4d510_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTile_vue__ = __webpack_require__(1200);
function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fa4d510"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa4d510_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cat__core__step mb-4",class:[ ("cat__core__step--" + _vm.color) ]},[_c('span',{staticClass:"cat__core__step__digit"},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('div',{staticClass:"cat__core__step__desc"},[_c('span',{staticClass:"h3 font-weight-bold mb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6251a85c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(1203);
function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6251a85c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6251a85c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[(_vm.title)?_c('h5',{staticClass:"mb-0 text-black"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40db29cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(1208);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40db29cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_vm._t("header"),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.simple)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"horizontalclass":"mb-0"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Cerca..."},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Reset")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_vm._t("filters")],2),_vm._v(" "),_c('b-col',[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":"","label":"Ordine"}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("-- Predefinito --")])]),_vm._v(" "),_c('b-input-group-button',[_c('b-form-select',{attrs:{"disabled":!_vm.sortBy},model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-table',{attrs:{"show-empty":"","striped":"","hover":"","stacked":"md","small":_vm.small,"fixed":_vm.fixed,"items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.onRowClicked},scopedSlots:_vm._u([{key:"radio_id",fn:function(row){return [_c('b-form-radio',{model:{value:(row.item.checked),callback:function ($$v) {_vm.$set(row.item, "checked", $$v)},expression:"row.item.checked"}}),_vm._v("\n      "+_vm._s()+"\n    ")]}},{key:"checkbox_id",fn:function(row){return [_c('b-form-checkbox',{model:{value:(row.item.checked),callback:function ($$v) {_vm.$set(row.item, "checked", $$v)},expression:"row.item.checked"}}),_vm._v("\n      "+_vm._s()+"\n    ")]}}])}),_vm._v(" "),(!_vm.simple)?_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","offset-md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.currentPerPage),callback:function ($$v) {_vm.currentPerPage=$$v},expression:"currentPerPage"}},[_c('option',{attrs:{"slot":"first","disabled":""},domProps:{"value":null},slot:"first"},[_vm._v("-- Num. per pagina --")])])],1)],1)],1):_vm._e(),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAutoComplete_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607e6d51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAutoComplete_vue__ = __webpack_require__(1210);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAutoComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607e6d51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAutoComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteText),expression:"autocompleteText"}],ref:"autocomplete",class:_vm.classname,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":(_vm.autocompleteText)},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteText=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkilloChart_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311de152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkilloChart_vue__ = __webpack_require__(1212);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkilloChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311de152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkilloChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"chart",attrs:{"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b49418aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(1230);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b49418aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FullCalendar__ = __webpack_require__(1232);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FullCalendar__["a" /* default */]);

/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a763fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__(1241);
function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a763fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function mergeDefaults(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, mergeDefaults);
  return apply(mergeWith, undefined, args);
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with seven arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = defaultsDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35), __webpack_require__(81)(module)))

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 498,
	"./af.js": 498,
	"./ar": 499,
	"./ar-dz": 500,
	"./ar-dz.js": 500,
	"./ar-kw": 501,
	"./ar-kw.js": 501,
	"./ar-ly": 502,
	"./ar-ly.js": 502,
	"./ar-ma": 503,
	"./ar-ma.js": 503,
	"./ar-sa": 504,
	"./ar-sa.js": 504,
	"./ar-tn": 505,
	"./ar-tn.js": 505,
	"./ar.js": 499,
	"./az": 506,
	"./az.js": 506,
	"./be": 507,
	"./be.js": 507,
	"./bg": 508,
	"./bg.js": 508,
	"./bm": 509,
	"./bm.js": 509,
	"./bn": 510,
	"./bn.js": 510,
	"./bo": 511,
	"./bo.js": 511,
	"./br": 512,
	"./br.js": 512,
	"./bs": 513,
	"./bs.js": 513,
	"./ca": 514,
	"./ca.js": 514,
	"./cs": 515,
	"./cs.js": 515,
	"./cv": 516,
	"./cv.js": 516,
	"./cy": 517,
	"./cy.js": 517,
	"./da": 518,
	"./da.js": 518,
	"./de": 519,
	"./de-at": 520,
	"./de-at.js": 520,
	"./de-ch": 521,
	"./de-ch.js": 521,
	"./de.js": 519,
	"./dv": 522,
	"./dv.js": 522,
	"./el": 523,
	"./el.js": 523,
	"./en-au": 524,
	"./en-au.js": 524,
	"./en-ca": 525,
	"./en-ca.js": 525,
	"./en-gb": 526,
	"./en-gb.js": 526,
	"./en-ie": 527,
	"./en-ie.js": 527,
	"./en-il": 528,
	"./en-il.js": 528,
	"./en-nz": 529,
	"./en-nz.js": 529,
	"./eo": 530,
	"./eo.js": 530,
	"./es": 531,
	"./es-do": 532,
	"./es-do.js": 532,
	"./es-us": 533,
	"./es-us.js": 533,
	"./es.js": 531,
	"./et": 534,
	"./et.js": 534,
	"./eu": 535,
	"./eu.js": 535,
	"./fa": 536,
	"./fa.js": 536,
	"./fi": 537,
	"./fi.js": 537,
	"./fo": 538,
	"./fo.js": 538,
	"./fr": 539,
	"./fr-ca": 540,
	"./fr-ca.js": 540,
	"./fr-ch": 541,
	"./fr-ch.js": 541,
	"./fr.js": 539,
	"./fy": 542,
	"./fy.js": 542,
	"./gd": 543,
	"./gd.js": 543,
	"./gl": 544,
	"./gl.js": 544,
	"./gom-latn": 545,
	"./gom-latn.js": 545,
	"./gu": 546,
	"./gu.js": 546,
	"./he": 547,
	"./he.js": 547,
	"./hi": 548,
	"./hi.js": 548,
	"./hr": 549,
	"./hr.js": 549,
	"./hu": 550,
	"./hu.js": 550,
	"./hy-am": 551,
	"./hy-am.js": 551,
	"./id": 552,
	"./id.js": 552,
	"./is": 553,
	"./is.js": 553,
	"./it": 554,
	"./it.js": 554,
	"./ja": 555,
	"./ja.js": 555,
	"./jv": 556,
	"./jv.js": 556,
	"./ka": 557,
	"./ka.js": 557,
	"./kk": 558,
	"./kk.js": 558,
	"./km": 559,
	"./km.js": 559,
	"./kn": 560,
	"./kn.js": 560,
	"./ko": 561,
	"./ko.js": 561,
	"./ky": 562,
	"./ky.js": 562,
	"./lb": 563,
	"./lb.js": 563,
	"./lo": 564,
	"./lo.js": 564,
	"./lt": 565,
	"./lt.js": 565,
	"./lv": 566,
	"./lv.js": 566,
	"./me": 567,
	"./me.js": 567,
	"./mi": 568,
	"./mi.js": 568,
	"./mk": 569,
	"./mk.js": 569,
	"./ml": 570,
	"./ml.js": 570,
	"./mn": 571,
	"./mn.js": 571,
	"./mr": 572,
	"./mr.js": 572,
	"./ms": 573,
	"./ms-my": 574,
	"./ms-my.js": 574,
	"./ms.js": 573,
	"./mt": 575,
	"./mt.js": 575,
	"./my": 576,
	"./my.js": 576,
	"./nb": 577,
	"./nb.js": 577,
	"./ne": 578,
	"./ne.js": 578,
	"./nl": 579,
	"./nl-be": 580,
	"./nl-be.js": 580,
	"./nl.js": 579,
	"./nn": 581,
	"./nn.js": 581,
	"./pa-in": 582,
	"./pa-in.js": 582,
	"./pl": 583,
	"./pl.js": 583,
	"./pt": 584,
	"./pt-br": 585,
	"./pt-br.js": 585,
	"./pt.js": 584,
	"./ro": 586,
	"./ro.js": 586,
	"./ru": 587,
	"./ru.js": 587,
	"./sd": 588,
	"./sd.js": 588,
	"./se": 589,
	"./se.js": 589,
	"./si": 590,
	"./si.js": 590,
	"./sk": 591,
	"./sk.js": 591,
	"./sl": 592,
	"./sl.js": 592,
	"./sq": 593,
	"./sq.js": 593,
	"./sr": 594,
	"./sr-cyrl": 595,
	"./sr-cyrl.js": 595,
	"./sr.js": 594,
	"./ss": 596,
	"./ss.js": 596,
	"./sv": 597,
	"./sv.js": 597,
	"./sw": 598,
	"./sw.js": 598,
	"./ta": 599,
	"./ta.js": 599,
	"./te": 600,
	"./te.js": 600,
	"./tet": 601,
	"./tet.js": 601,
	"./tg": 602,
	"./tg.js": 602,
	"./th": 603,
	"./th.js": 603,
	"./tl-ph": 604,
	"./tl-ph.js": 604,
	"./tlh": 605,
	"./tlh.js": 605,
	"./tr": 606,
	"./tr.js": 606,
	"./tzl": 607,
	"./tzl.js": 607,
	"./tzm": 608,
	"./tzm-latn": 609,
	"./tzm-latn.js": 609,
	"./tzm.js": 608,
	"./ug-cn": 610,
	"./ug-cn.js": 610,
	"./uk": 611,
	"./uk.js": 611,
	"./ur": 612,
	"./ur.js": 612,
	"./uz": 613,
	"./uz-latn": 614,
	"./uz-latn.js": 614,
	"./uz.js": 613,
	"./vi": 615,
	"./vi.js": 615,
	"./x-pseudo": 616,
	"./x-pseudo.js": 616,
	"./yo": 617,
	"./yo.js": 617,
	"./zh-cn": 618,
	"./zh-cn.js": 618,
	"./zh-hk": 619,
	"./zh-hk.js": 619,
	"./zh-tw": 620,
	"./zh-tw.js": 620
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1240;

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toastr = __webpack_require__(1244);
__webpack_require__(1246);

var VueToastr = {};

VueToastr.install = function (Vue) {
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-bottom-right',
    preventDuplicates: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  };
  Vue.prototype.$toastr = toastr;
};

/* harmony default export */ __webpack_exports__["a"] = (VueToastr);

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Note that this is toastr v2.1.3, the "latest" version in url has no more maintenance,
 * please go to https://cdnjs.com/libraries/toastr.js and pick a certain version you want to use,
 * make sure you copy the url from the website since the url may change between versions.
 * */
!function (e) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (e) {
    return function () {
      function t(e, t, n) {
        return g({ type: O.error, iconClass: m().iconClasses.error, message: e, optionsOverride: n, title: t });
      }function n(t, n) {
        return t || (t = m()), v = e("#" + t.containerId), v.length ? v : (n && (v = d(t)), v);
      }function o(e, t, n) {
        return g({ type: O.info, iconClass: m().iconClasses.info, message: e, optionsOverride: n, title: t });
      }function s(e) {
        C = e;
      }function i(e, t, n) {
        return g({ type: O.success, iconClass: m().iconClasses.success, message: e, optionsOverride: n, title: t });
      }function a(e, t, n) {
        return g({ type: O.warning, iconClass: m().iconClasses.warning, message: e, optionsOverride: n, title: t });
      }function r(e, t) {
        var o = m();v || n(o), u(e, o, t) || l(o);
      }function c(t) {
        var o = m();return v || n(o), t && 0 === e(":focus", t).length ? void h(t) : void (v.children().length && v.remove());
      }function l(t) {
        for (var n = v.children(), o = n.length - 1; o >= 0; o--) {
          u(e(n[o]), t);
        }
      }function u(t, n, o) {
        var s = !(!o || !o.force) && o.force;return !(!t || !s && 0 !== e(":focus", t).length) && (t[n.hideMethod]({ duration: n.hideDuration, easing: n.hideEasing, complete: function complete() {
            h(t);
          } }), !0);
      }function d(t) {
        return v = e("<div/>").attr("id", t.containerId).addClass(t.positionClass), v.appendTo(e(t.target)), v;
      }function p() {
        return { tapToDismiss: !0, toastClass: "toast", containerId: "toast-container", debug: !1, showMethod: "fadeIn", showDuration: 300, showEasing: "swing", onShown: void 0, hideMethod: "fadeOut", hideDuration: 1e3, hideEasing: "swing", onHidden: void 0, closeMethod: !1, closeDuration: !1, closeEasing: !1, closeOnHover: !0, extendedTimeOut: 1e3, iconClasses: { error: "toast-error", info: "toast-info", success: "toast-success", warning: "toast-warning" }, iconClass: "toast-info", positionClass: "toast-top-right", timeOut: 5e3, titleClass: "toast-title", messageClass: "toast-message", escapeHtml: !1, target: "body", closeHtml: '<button type="button">&times;</button>', closeClass: "toast-close-button", newestOnTop: !0, preventDuplicates: !1, progressBar: !1, progressClass: "toast-progress", rtl: !1 };
      }function f(e) {
        C && C(e);
      }function g(t) {
        function o(e) {
          return null == e && (e = ""), e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }function s() {
          c(), u(), d(), p(), g(), C(), l(), i();
        }function i() {
          var e = "";switch (t.iconClass) {case "toast-success":case "toast-info":
              e = "polite";break;default:
              e = "assertive";}I.attr("aria-live", e);
        }function a() {
          E.closeOnHover && I.hover(H, D), !E.onclick && E.tapToDismiss && I.click(b), E.closeButton && j && j.click(function (e) {
            e.stopPropagation ? e.stopPropagation() : void 0 !== e.cancelBubble && e.cancelBubble !== !0 && (e.cancelBubble = !0), E.onCloseClick && E.onCloseClick(e), b(!0);
          }), E.onclick && I.click(function (e) {
            E.onclick(e), b();
          });
        }function r() {
          I.hide(), I[E.showMethod]({ duration: E.showDuration, easing: E.showEasing, complete: E.onShown }), E.timeOut > 0 && (k = setTimeout(b, E.timeOut), F.maxHideTime = parseFloat(E.timeOut), F.hideEta = new Date().getTime() + F.maxHideTime, E.progressBar && (F.intervalId = setInterval(x, 10)));
        }function c() {
          t.iconClass && I.addClass(E.toastClass).addClass(y);
        }function l() {
          E.newestOnTop ? v.prepend(I) : v.append(I);
        }function u() {
          if (t.title) {
            var e = t.title;E.escapeHtml && (e = o(t.title)), M.append(e).addClass(E.titleClass), I.append(M);
          }
        }function d() {
          if (t.message) {
            var e = t.message;E.escapeHtml && (e = o(t.message)), B.append(e).addClass(E.messageClass), I.append(B);
          }
        }function p() {
          E.closeButton && (j.addClass(E.closeClass).attr("role", "button"), I.prepend(j));
        }function g() {
          E.progressBar && (q.addClass(E.progressClass), I.prepend(q));
        }function C() {
          E.rtl && I.addClass("rtl");
        }function O(e, t) {
          if (e.preventDuplicates) {
            if (t.message === w) return !0;w = t.message;
          }return !1;
        }function b(t) {
          var n = t && E.closeMethod !== !1 ? E.closeMethod : E.hideMethod,
              o = t && E.closeDuration !== !1 ? E.closeDuration : E.hideDuration,
              s = t && E.closeEasing !== !1 ? E.closeEasing : E.hideEasing;if (!e(":focus", I).length || t) return clearTimeout(F.intervalId), I[n]({ duration: o, easing: s, complete: function complete() {
              h(I), clearTimeout(k), E.onHidden && "hidden" !== P.state && E.onHidden(), P.state = "hidden", P.endTime = new Date(), f(P);
            } });
        }function D() {
          (E.timeOut > 0 || E.extendedTimeOut > 0) && (k = setTimeout(b, E.extendedTimeOut), F.maxHideTime = parseFloat(E.extendedTimeOut), F.hideEta = new Date().getTime() + F.maxHideTime);
        }function H() {
          clearTimeout(k), F.hideEta = 0, I.stop(!0, !0)[E.showMethod]({ duration: E.showDuration, easing: E.showEasing });
        }function x() {
          var e = (F.hideEta - new Date().getTime()) / F.maxHideTime * 100;q.width(e + "%");
        }var E = m(),
            y = t.iconClass || E.iconClass;if ("undefined" != typeof t.optionsOverride && (E = e.extend(E, t.optionsOverride), y = t.optionsOverride.iconClass || y), !O(E, t)) {
          T++, v = n(E, !0);var k = null,
              I = e("<div/>"),
              M = e("<div/>"),
              B = e("<div/>"),
              q = e("<div/>"),
              j = e(E.closeHtml),
              F = { intervalId: null, hideEta: null, maxHideTime: null },
              P = { toastId: T, state: "visible", startTime: new Date(), options: E, map: t };return s(), r(), a(), f(P), E.debug && console && console.log(P), I;
        }
      }function m() {
        return e.extend({}, p(), b.options);
      }function h(e) {
        v || (v = n()), e.is(":visible") || (e.remove(), e = null, 0 === v.children().length && (v.remove(), w = void 0));
      }var v,
          C,
          w,
          T = 0,
          O = { error: "error", info: "info", success: "success", warning: "warning" },
          b = { clear: r, remove: c, error: t, getContainer: n, info: o, options: {}, subscribe: s, success: i, version: "2.1.3", warning: a };return b;
    }();
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(1245));
//# sourceMappingURL=toastr.js.map

/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
// import swal from 'bootstrap-sweetalert';

__webpack_require__(1249);

var VueSwal = {};

VueSwal.install = function (Vue) {
  Vue.prototype.$swal = __WEBPACK_IMPORTED_MODULE_0_sweetalert___default.a;
};

/* harmony default export */ __webpack_exports__["a"] = (VueSwal);

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utilities = {
  /**
   * Open new dialog
   * @param uri
   * @param name
   * @param options
   * @param closeCallback
   * @returns {Window}
   */
  openDialog: function openDialog(uri, name, options, closeCallback) {
    var win = window.open(uri, name, options);
    var interval = window.setInterval(function () {
      try {
        if (win == null || win.closed) {
          window.clearInterval(interval);
          closeCallback(win);
        }
      } catch (e) {
        console.warn('error into openDialog', e);
      }
    }, 1000);

    return win;
  }
};

var Utils = {};

Utils.install = function (Vue) {
  Vue.prototype.$utils = utilities;
};

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userValidator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiClient__ = __webpack_require__(623);






var phoneUtil = __webpack_require__(89).PhoneNumberUtil.getInstance();

var Validators = {};

Validators.register = function register(VeeValidate) {
  var _this = this;

  console.log('Loading custom validators');

  VeeValidate.Validator.extend('customer_unique_email', {
    // getMessage: 'Esite già un cliente con l\'indirizzo email specificato.',
    getMessage: function getMessage(field) {
      return 'Esite gi\xE0 un cliente con l\'indirizzo email ' + field + '.';
    },

    validate: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__apiClient__["a" /* default */].calls(__WEBPACK_IMPORTED_MODULE_3_vue__["default"]).checkCustomer('email', value);

              case 3:
                return _context.abrupt('return', { valid: true });

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', { valid: false });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }));

      return function validate(_x) {
        return _ref.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('customer_unique_piva', {
    getMessage: function getMessage(field) {
      return 'Esite gi\xE0 un cliente con lo stesso codice fiscale o partita iva.';
    },

    validate: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__apiClient__["a" /* default */].calls(__WEBPACK_IMPORTED_MODULE_3_vue__["default"]).checkCustomer('piva_cfisc', value);

              case 3:
                return _context2.abrupt('return', { valid: true });

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', { valid: false });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 6]]);
      }));

      return function validate(_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('user_unique_email', {
    // messages: {
    //   en: (field, args) => 'A user with the same email address already exists.',
    //   it: (field, args) => 'Esite già un utente con l\'indirizzo email specificato.',
    // },
    getMessage: function getMessage(field) {
      return 'Esite già un utente con l\'indirizzo email specificato.';
    },

    validate: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__apiClient__["a" /* default */].calls(__WEBPACK_IMPORTED_MODULE_3_vue__["default"]).checkUser('email', value);

              case 3:
                return _context3.abrupt('return', { valid: true });

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', { valid: false });

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[0, 6]]);
      }));

      return function validate(_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('user_unique_phone_number', {
    getMessage: function getMessage(field) {
      return 'Esite già un utente con il numero telefonico specificato.';
    },

    validate: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__apiClient__["a" /* default */].calls(__WEBPACK_IMPORTED_MODULE_3_vue__["default"]).checkUser('phone_number', value);

              case 3:
                return _context4.abrupt('return', { valid: true });

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);
                return _context4.abrupt('return', { valid: false });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[0, 6]]);
      }));

      return function validate(_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('piva_cfisc', {
    getMessage: function getMessage(field) {
      return 'Inserisci un codice fiscale o una partita iva valide.';
    },

    validate: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(value) {
        var pattern, valid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                pattern = /^((?:[B-DF-HJ-NP-TV-Z](?:[AEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z])|([0-9]{11})$/i;
                valid = value.search(pattern) > -1;
                return _context5.abrupt('return', { valid: valid });

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this);
      }));

      return function validate(_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('phone_number', {
    getMessage: function getMessage(field) {
      return 'Numero di telefono non valido';
    },

    validate: function validate(value) {
      var phone = phoneUtil.parse(value);
      return { valid: phoneUtil.isValidNumber(phone) };
    }
  });

  VeeValidate.Validator.extend('ip_subnet_block', {
    getMessage: function getMessage(field) {
      return 'E\' stato inserito un IP o una sottorete non valida.';
    },

    validate: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(values) {
        var regexIp, regexCidr, addresses, valid, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                regexIp = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
                regexCidr = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))$/g;
                addresses = values.split('\n');
                valid = true;
                i = 0;

              case 5:
                if (!(i < addresses.length)) {
                  _context6.next = 13;
                  break;
                }

                addresses[i] = addresses[i].trim();

                if (addresses[i].indexOf('/') >= 0) {
                  valid = addresses[i].search(regexCidr) > -1;
                } else if (addresses[i] !== '') {
                  valid = addresses[i].search(regexIp) > -1;
                }

                if (valid) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt('break', 13);

              case 10:
                i++;
                _context6.next = 5;
                break;

              case 13:
                return _context6.abrupt('return', { valid: valid });

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this);
      }));

      return function validate(_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  });

  VeeValidate.Validator.extend('verify_password', {
    getMessage: function getMessage(field) {
      return 'La password deve contenere almeno: 1 maiuscola, 1 minuscola, 1 numero ed un carattere speciale. (ad esempio: , . _ & ? ecc..)';
    },
    validate: function validate(value) {
      var strongRegex = new RegExp('^.*(?=.{8,})((?=.*[!?@#$%^&*()\\-_=+{};:,<.>]){1})(?=.*\\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$');
      return strongRegex.test(value);
    }
  });
};

var userValidator = new __WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */]({
  email: 'email|user_unique_email',
  phone_number: 'phone_number|user_unique_phone_number',
  first_name: 'alpha_spaces',
  last_name: 'alpha_spaces',
  plan: 'required'
});

/* harmony default export */ __webpack_exports__["a"] = (Validators);


/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8e1988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1271);
function injectStyle (ssrContext) {
  __webpack_require__(1270)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8e1988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{staticClass:"custom-toolbar",attrs:{"toggleable":"md","type":"dark"}},[_c('b-container',[_c('b-navbar-brand',{attrs:{"href":"/"}},[_c('h4',{staticClass:"m-0 p-0 font-size-20 font-weight-bold"},[_vm._v("CWM "),_c('small',{staticClass:"hidden-lg-down"},[_c('em',[_vm._v("Cloud Workplace Management")])])])]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{attrs:{"href":"/#/download"}},[_vm._v("SCARICA L'APP")]),_vm._v(" "),(_vm.isLogged)?_c('b-nav-item',{attrs:{"href":"/#/area-riservata/piani"}},[_vm._v("AREA RISERVATA")]):_vm._e(),_vm._v(" "),(_vm.isLogged)?_c('b-nav-item',{staticClass:"ml-3 text-azure",attrs:{"href":"/#/logout"}},[_vm._v("Logout ("+_vm._s(_vm.beUser.full_name)+")\n          ")]):_c('b-nav-item',{staticClass:"ml-3 text-azure",attrs:{"href":"/#/login"}},[_vm._v("Accedi")])],1)],1)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),(false)?_c('b-container',{staticClass:"mt-5",attrs:{"fluid":""}},[_c('b-container',{staticClass:"py-4 font-size-12"},[_c('b-row',[_c('b-col',[_c('p',[_c('strong',[_vm._v("CWM")]),_vm._v(" - Cloud Workplace Management"),_c('br'),_vm._v("\n            Copyright © 2018 Ennova"),_c('br')])])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Index__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Attiva__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Login__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Recover__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Logout__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Download__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AreaRiservata_Base__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_AreaRiservata_Conferma__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_AreaRiservata_Profilo__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_AreaRiservata_Piani__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_AreaRiservata_Richieste__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_AreaRiservata_Tickets__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__authManager__ = __webpack_require__(238);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'cat__menu-left__item--active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Index__["a" /* default */]
  }, {
    path: '/attiva',
    name: 'Attiva',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Attiva__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Login__["a" /* default */]
  }, {
    path: '/recover',
    name: 'Recupera password',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Recover__["a" /* default */]
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Logout__["a" /* default */]
  }, {
    path: '/download',
    name: 'Download',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Download__["a" /* default */]
  }, {
    path: '/area-riservata',
    name: 'Area Riservata',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_AreaRiservata_Base__["a" /* default */],
    children: [{
      path: '/area-riservata/conferma',
      name: 'Profilo',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_AreaRiservata_Conferma__["a" /* default */],
      meta: {
        title: 'Conferma Dati',
        requiresAuth: true,
        skip_redirect: true
      }
    }, {
      path: '/area-riservata/profilo',
      name: 'Profilo',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_AreaRiservata_Profilo__["a" /* default */],
      meta: {
        title: 'Profilo',
        requiresAuth: true
      }
    }, {
      path: '/area-riservata/piani',
      name: 'Piani',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_AreaRiservata_Piani__["a" /* default */],
      meta: {
        title: 'Piani',
        requiresAuth: true
      }
    }, {
      path: '/area-riservata/richieste',
      name: 'Richieste',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_AreaRiservata_Richieste__["a" /* default */],
      props: true,
      meta: {
        title: 'Richieste',
        requiresAuth: true
      }
    }, {
      path: '/area-riservata/tickets',
      name: 'Tickets',
      component: __WEBPACK_IMPORTED_MODULE_13__pages_AreaRiservata_Tickets__["a" /* default */],
      props: true,
      meta: {
        title: 'Richieste',
        requiresAuth: true
      }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.title) document.title = 'CWM - ' + to.meta.title;

  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_14__authManager__["a" /* default */].isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else if (!__WEBPACK_IMPORTED_MODULE_14__authManager__["a" /* default */].isProfileConfirmed() && !to.meta.skip_redirect) {
      return next({
        path: '/area-riservata/conferma'
      });
    }
  }

  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355c3980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1276);
function injectStyle (ssrContext) {
  __webpack_require__(1275)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-355c3980"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355c3980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',[_c('img',{staticClass:"float-left mr-3",attrs:{"src":__webpack_require__(627),"fluid":"","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"mt-3"},[_vm._v("Cloud Workplace Management")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"lead",attrs:{"cols":"","lg":"8"}},[_c('p',{staticClass:"lead"},[_vm._v("Con CWM hai la tranquillità di avere una squadra di tecnici altamente qualificati,\n          in grado di gestire i dispositivi digitali della tua azienda e risolvere tutte le problematiche:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Prima configurazione")]),_vm._v(" "),_c('li',[_vm._v("Assistenza in caso di malfunzionamenti software o hardware")]),_vm._v(" "),_c('li',[_vm._v("Fleet management")])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Disegna il servizio a misura delle tue esigenze!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_c('b-btn',{attrs:{"variant":"danger","size":"lg","to":'download'}},[_c('i',{staticClass:"fas fa-cloud-download-alt mr-2"}),_vm._v("\n            Scarica l'applicazione\n          ")])],1)]),_vm._v(" "),_c('b-col',[_c('b-jumbotron',[_c('template',{slot:"lead"},[_vm._v("\n            Se sei già un utente "),_c('strong',[_vm._v("CWM")]),_vm._v(", accedi all'area riservata per controllare e gestire il tuo\n            servizio.\n          ")]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('p',[_vm._v("\n            Accedi con le credenziali che hai ricevuto tramite mail o SMS. "),_c('a',{attrs:{"href":"/#/recover"}},[_vm._v("Non ricordi le tue\n            credenziali?")])]),_vm._v(" "),(_vm.isLogged)?_c('b-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":'area-riservata/piani'}},[_c('i',{staticClass:"fas fa-sign-in-alt mr-2"}),_vm._v("\n            Accedi all'Area Riservata\n          ")]):_c('b-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":'login'}},[_vm._v("Accedi all'Area Riservata")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attiva_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb325044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attiva_vue__ = __webpack_require__(1279);
function injectStyle (ssrContext) {
  __webpack_require__(1278)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb325044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attiva_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb325044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attiva_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',[_vm._v("Attiva il tuo pacchetto")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f3ad06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72f3ad06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f3ad06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('b-container',{staticClass:"pb-5"},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"lg":"6","offset-lg":"3"}},[_c('h1',[_vm._v("Accedi all'Area Riservata")]),_vm._v(" "),_c('p',{staticClass:"text-secondary"},[_vm._v("\n          Inserisci il tuo nome utente e password e premi su accedi.\n        ")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.checkAuth($event)}}},[_c('b-form-group',{attrs:{"label":"Username"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","label":"Username","required":"","placeholder":"Inserisci username","data-vv-name":"username"},model:{value:(_vm.login.username),callback:function ($$v) {_vm.$set(_vm.login, "username", $$v)},expression:"login.username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"password","label":"Password","required":"","placeholder":"Inserisci password","data-vv-name":"username"},model:{value:(_vm.login.password),callback:function ($$v) {_vm.$set(_vm.login, "password", $$v)},expression:"login.password"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',[_c('b-button',{staticClass:"mr-2",attrs:{"size":"lg","type":"submit","variant":"primary","disabled":!_vm.formFilled}},[_vm._v("Accedi")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","type":"button","variant":"outline-danger","to":'recover'}},[_vm._v("Recupera password")])],1)],1),_vm._v(" "),(_vm.error)?_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":""}},[_vm._v("Attenzione! "+_vm._s(_vm.error))]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36992fe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__ = __webpack_require__(1286);
function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36992fe2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36992fe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('b-container',{staticClass:"pb-5"},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"lg":"6","offset-lg":"3"}},[_c('h1',[_vm._v("Recupera la tua password")]),_vm._v(" "),_c('p',{staticClass:"text-secondary"},[_vm._v("Inserisci il tuo nome utente e premi recupera.")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('b-form-group',{attrs:{"label":"Username"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","label":"Username","required":"","placeholder":"Inserisci username","data-vv-name":"username"},model:{value:(_vm.login.username),callback:function ($$v) {_vm.$set(_vm.login, "username", $$v)},expression:"login.username"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-button',{staticClass:"mr-2",attrs:{"size":"lg","type":"submit","variant":"primary"}},[_vm._v("Recupera")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","type":"button","variant":"outline-danger","to":'login'}},[_vm._v("Torna al login")])],1),_vm._v(" "),(_vm.error)?_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":""}},[_vm._v("Attenzione! "+_vm._s(_vm.error))]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1e92aca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(1289);
function injectStyle (ssrContext) {
  __webpack_require__(1288)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1e92aca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1e92aca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3843ad14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__ = __webpack_require__(1292);
function injectStyle (ssrContext) {
  __webpack_require__(1291)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3843ad14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3843ad14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',[_c('img',{staticClass:"float-left mr-3",attrs:{"src":__webpack_require__(627),"fluid":"","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"mt-3"},[_vm._v("Cloud Workplace Management")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"lead"},[_c('p',{staticClass:"lead"},[_vm._v("CWM è disponibile per tutte le maggiori piattaforme:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Android")]),_vm._v(" "),_c('li',[_vm._v("Apple iOS")]),_vm._v(" "),_c('li',[_vm._v("Microsoft Windows")]),_vm._v(" "),_c('li',[_vm._v("Apple Mac OSX")])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Usa il badge qui in basso per scaricare quella di tuo interesse.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=it.ennova.cwm&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}},[_c('img',{attrs:{"alt":"Disponibile su Google Play","src":"https://play.google.com/intl/en_gb/badges/images/generic/it_badge_web_generic.png","width":"240"}})])]),_vm._v(" "),_c('b-col',[_c('a',{staticStyle:{"display":"inline-block","overflow":"hidden","background":"url(https://linkmaker.itunes.apple.com/assets/shared/badges/it-it/appstore-lrg.svg) no-repeat","width":"230px","height":"90px","margin":"15px","background-size":"contain"},attrs:{"href":"https://itunes.apple.com/it/app/cloud-workplace-management/id1405656312?mt=8"}})])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('img',{attrs:{"src":__webpack_require__(1293),"alt":"CWM","width":"300"}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smartmockups_jjty2ofs.08723bc.jpg";

/***/ }),

/***/ 1294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797f56b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__ = __webpack_require__(1296);
function injectStyle (ssrContext) {
  __webpack_require__(1295)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-797f56b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797f56b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('b-container',{staticClass:"header pt-5 mb-3",attrs:{"fluid":""}},[_c('b-container',{staticClass:"pt-5"},[_c('b-nav',{attrs:{"tabs":"","fill":""}},[_c('b-nav-item',{attrs:{"to":'/area-riservata/piani',"disabled":!_vm.isProfileConfirmed}},[_vm._v("Il mio piano")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":'/area-riservata/richieste',"disabled":!_vm.isProfileConfirmed}},[_vm._v("Le mie richieste")]),_vm._v(" "),(_vm.isAdmin)?_c('b-nav-item',{attrs:{"to":'/area-riservata/tickets',"disabled":!_vm.isProfileConfirmed}},[_vm._v("Le richieste dei dipendenti")]):_vm._e(),_vm._v(" "),_c('b-nav-item',{attrs:{"to":'/area-riservata/profilo',"disabled":!_vm.isProfileConfirmed}},[_vm._v("Il mio profilo")])],1)],1)],1),_vm._v(" "),_c('b-container',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conferma_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295b9710_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conferma_vue__ = __webpack_require__(1299);
function injectStyle (ssrContext) {
  __webpack_require__(1298)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-295b9710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conferma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295b9710_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conferma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-5"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateUser($event)}}},[_c('h3',[_vm._v("Conferma Dati")]),_vm._v(" "),_c('b-alert',{staticClass:"my-4",attrs:{"show":"","variant":"info"}},[_vm._v("\n        Gentile utente,"),_c('br'),_vm._v("\n        prima di proseguire è necessario confermare i dati del proprio profilo, e sostituire la password di accesso temporenea.\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('last_name') },attrs:{"label":"Cognome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"alpha_spaces|required","data-vv-as":"Cognome","name":"last_name","type":"text","required":"","placeholder":"Cognome"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('first_name') },attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"alpha_spaces|required","data-vv-as":"Nome","name":"first_name","type":"text","placeholder":"Nome"},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('email') },attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"email|required|user_unique_email","data-vv-as":"Email","type":"email","name":"email","data-vv-validate-on":"change","placeholder":"La tua mail"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('phone_number') },attrs:{"label":"Numero Cellulare"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"phone_number|user_unique_phone_number","data-vv-delay":"500","data-vv-as":"Cellulare","name":"phone_number","data-vv-validate-on":"change","type":"tel","formatter":_vm.phoneNumberFormatter,"lazy-formatter":"","placeholder":"Il tuo numero"},model:{value:(_vm.user.phone_number),callback:function ($$v) {_vm.$set(_vm.user, "phone_number", $$v)},expression:"user.phone_number"}})],1)],1)],1),_vm._v(" "),(_vm.user.users_group)?_c('b-row',{staticClass:"mt-3 mb-5"},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v("Gruppo di appartenza"),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.user.users_group.name))])])])],1):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("Password accesso")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{class:{'has-danger': _vm.errors.has('password') },attrs:{"label":"Password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required|min:8|verify_password","data-vv-as":"Password","name":"password","type":"password","required":"","placeholder":"password"},model:{value:(_vm.pass.password),callback:function ($$v) {_vm.$set(_vm.pass, "password", $$v)},expression:"pass.password"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{class:{'has-danger': _vm.errors.has('password_confirm') },attrs:{"label":"Conferma password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required|confirmed:password","data-vv-as":"Conferma password","name":"password_confirm","type":"password","required":"","placeholder":"Conferma password"},model:{value:(_vm.pass.password_confirm),callback:function ($$v) {_vm.$set(_vm.pass, "password_confirm", $$v)},expression:"pass.password_confirm"}})],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.errors.any()}},[_c('i',{staticClass:"fas fa-check mr-3"}),_vm._v(" "),_c('strong',[_vm._v("Conferma i Dati")])])])],1)],1),_vm._v(" "),(_vm.errors.any())?_c('hr'):_vm._e(),_vm._v(" "),_vm._l((_vm.errors.all()),function(error){return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("\n        "+_vm._s(error)+"\n      ")])],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilo_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9b0a996_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profilo_vue__ = __webpack_require__(1302);
function injectStyle (ssrContext) {
  __webpack_require__(1301)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9b0a996"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9b0a996_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profilo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-5"},[_c('b-form',{attrs:{"data-vv-scope":"profile"},on:{"submit":function($event){$event.preventDefault();return _vm.updateUser($event)}}},[_c('h3',[_vm._v("Il mio Profilo")]),_vm._v(" "),(!_vm.isProfileConfirmed)?_c('b-alert',{attrs:{"show":"","variant":"info"}},[_vm._v("\n        Per accedere alle altre sezioni, è necessario confermare i propri dati di profilo e modificare la password di accesso.\n      ")]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('last_name') },attrs:{"label":"Cognome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"alpha_spaces|required","data-vv-as":"Cognome","name":"last_name","type":"text","required":"","placeholder":"Cognome"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('first_name') },attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"alpha_spaces|required","data-vv-as":"Nome","name":"first_name","type":"text","placeholder":"Nome"},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('email') },attrs:{"label":"Email","description":"La tua mail"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"email|required|user_unique_email","data-vv-as":"Email","type":"email","name":"email","data-vv-validate-on":"change","placeholder":"La tua mail"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('phone_number') },attrs:{"label":"Numero Cellulare","description":"Il tuo numero principale, che puoi usare come login alternativo"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"phone_number|user_unique_phone_number","data-vv-delay":"500","data-vv-as":"Cellulare","name":"phone_number","data-vv-validate-on":"change","type":"tel","formatter":_vm.phoneNumberFormatter,"lazy-formatter":"","placeholder":"Il tuo numero"},model:{value:(_vm.user.phone_number),callback:function ($$v) {_vm.$set(_vm.user, "phone_number", $$v)},expression:"user.phone_number"}})],1)],1)],1),_vm._v(" "),(_vm.user.users_group)?_c('b-row',{staticClass:"mt-3 mb-5"},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v("Gruppo di appartenza"),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.user.users_group.name))])])])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-3 mb-5"},[_c('b-col',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.errors.any()},on:{"click":function($event){_vm.updateUser()}}},[_c('strong',[_vm._v("Aggiorna dettagli")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.resetProfile()}}},[_vm._v("\n            Annulla\n          ")])])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form',{attrs:{"data-vv-scope":"password"},on:{"submit":function($event){$event.preventDefault();return _vm.updateUser($event)}}},[_c('h5',{staticClass:"mt-3"},[_vm._v("Aggiorna password")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('password') },attrs:{"label":"Password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required|min:8|verify_password","data-vv-as":"Password","name":"password","type":"password","required":"","placeholder":"password"},model:{value:(_vm.pass.password),callback:function ($$v) {_vm.$set(_vm.pass, "password", $$v)},expression:"pass.password"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{class:{'has-danger': _vm.errors.has('password_confirm') },attrs:{"label":"Conferma password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required|confirmed:password","data-vv-as":"Conferma password","name":"password_confirm","type":"password","required":"","placeholder":"Conferma password"},model:{value:(_vm.pass.password_confirm),callback:function ($$v) {_vm.$set(_vm.pass, "password_confirm", $$v)},expression:"pass.password_confirm"}})],1)],1),_vm._v(" "),_c('b-col')],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.errors.any()},on:{"click":function($event){_vm.updatePassword()}}},[_c('strong',[_vm._v("Aggiorna password")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.resetPassword()}}},[_vm._v("\n            Annulla\n          ")])])],1)],1),_vm._v(" "),(_vm.errors.any())?_c('hr'):_vm._e(),_vm._v(" "),_vm._l((_vm.errors.all()),function(error){return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("\n        "+_vm._s(error)+"\n      ")])],1)})],2),_vm._v(" "),_c('b-card',{staticClass:"mt-5",attrs:{"title":"Piani Sottoscritti"}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.plans,"fields":_vm.plansFields}})],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5",attrs:{"title":"Dispositivi"}},[(!_vm.devices.length)?_c('p',{staticClass:"text-center p3"},[_vm._v("\n      Non hai ancora installato l'app Skillo? Cosa aspetti, "),_c('a',{attrs:{"href":"https://www.skillo.it/it/scarica-app"}},[_vm._v("clicca qui\n      per scaricare")]),_vm._v(" quella più giusta per la tua piattaforma.\n    ")]):_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.devices,"fields":_vm.devicesFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Piani_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233e0e5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Piani_vue__ = __webpack_require__(1315);
function injectStyle (ssrContext) {
  __webpack_require__(1304)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-233e0e5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Piani_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233e0e5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Piani_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"schedule"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"px-5"},[(_vm.currentStep(0) && _vm.schedule.category === 'Tutor' )?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Su quale strumento desideri essere informato?"}},[_c('ul',{staticClass:"list-inline my-5"},_vm._l((_vm.services),function(prop,key){return _c('li',{key:prop.name,staticClass:"list-inline-item step1-list-item px-4 py-2 text-center",class:{ active: key === _vm.schedule.product },on:{"click":function($event){_vm.schedule.product=key}}},[_c('img',{staticClass:"img img-fluid m-2",attrs:{"src":("/static/img/collaboration/" + (prop.icon)),"alt":key}}),_vm._v(" "),_c('br'),_vm._v("\n              "+_vm._s(prop.name)+"\n            ")])})),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.nextStep}},[_vm._v("Avanti")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":function($event){_vm.show=false}}},[_vm._v("Indietro")])],1)]):_vm._e(),_vm._v(" "),(_vm.currentStep(0) && _vm.schedule.category === 'Collaboration' )?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Da quale sistema vuoi migrare i tuoi dati?"}},[_c('ul',{staticClass:"list-inline my-5"},_vm._l((_vm.collaborationServices),function(prop,key){return _c('li',{key:prop.name,staticClass:"list-inline-item step1-list-item px-4 py-2 text-center",class:{ active: key === _vm.schedule.product },on:{"click":function($event){_vm.schedule.product=key}}},[_c('img',{staticClass:"img img-fluid m-2",attrs:{"src":("/static/img/collaboration/" + (prop.icon)),"alt":key}}),_vm._v(" "),_c('br'),_vm._v("\n              "+_vm._s(prop.name)+"\n            ")])})),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.nextStep}},[_vm._v("Avanti")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":function($event){_vm.show=false}}},[_vm._v("Indietro")])],1)]):_vm._e(),_vm._v(" "),(_vm.currentStep(1) && _vm.schedule.category === 'Tutor')?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Tematiche di interesse"}},[_c('p',{staticClass:"mt-3 mb-2"},[_vm._v("Indicati una o più tematiche di interesse")]),_vm._v(" "),_c('multiselect',{staticClass:"mb-3",attrs:{"options":_vm.services[_vm.schedule.product].options,"multiple":true,"close-on-select":false,"placeholder":"Seleziona una o più voci"},model:{value:(_vm.schedule.options),callback:function ($$v) {_vm.$set(_vm.schedule, "options", $$v)},expression:"schedule.options"}}),_vm._v(" "),_c('p',{staticClass:"mt-3 mb-2"},[_vm._v("Hai esigenze particolari?")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"placeholder":"Inserisci le tue note aggiuntive","rows":5,"max-rows":5},model:{value:(_vm.schedule.customer_notes),callback:function ($$v) {_vm.$set(_vm.schedule, "customer_notes", $$v)},expression:"schedule.customer_notes"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.nextStep}},[_vm._v("Avanti")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":_vm.prevStep}},[_vm._v("Indietro")])],1)],1):_vm._e(),_vm._v(" "),(_vm.currentStep(1) && _vm.schedule.category === 'Collaboration' )?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Verso quale sistema vuoi migrare i tuoi dati?"}},[_c('ul',{staticClass:"list-inline my-5"},_vm._l((_vm.collaborationServices),function(prop,key){return _c('li',{key:prop.name,staticClass:"list-inline-item step1-list-item px-4 py-2 text-center",class:{ active: key === _vm.schedule.product_dest },on:{"click":function($event){_vm.schedule.product_dest=key}}},[_c('img',{staticClass:"img img-fluid m-2",attrs:{"src":("/static/img/collaboration/" + (prop.icon)),"alt":key}}),_vm._v(" "),_c('br'),_vm._v("\n              "+_vm._s(prop.name)+"\n            ")])})),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.nextStep}},[_vm._v("Avanti")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":function($event){_vm.show=false}}},[_vm._v("Indietro")])],1)]):_vm._e(),_vm._v(" "),(_vm.currentStep(2))?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Quando vuoi essere ricontattato?"}},[_c('p',{staticClass:"mt-5"},[_vm._v("Scegli il giorno")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-2 mb-5"},[_c('li',{staticClass:"list-inline-item text-center"},[_c('btn',{staticClass:"my-5 mx-3",on:{"click":_vm.prevWeek}},[_c('h1',[_c('i',{staticClass:"fas fa-chevron-circle-left my-3 text-secondary"})])])],1),_vm._v(" "),_vm._l((_vm.calendarDays),function(day){return _c('li',{staticClass:"list-inline-item step2-list-item text-center",class:{ active: day.isSame(_vm.schedule.day) },on:{"click":function($event){_vm.schedule.day = day}}},[_c('small',{staticClass:"font-size-12"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(day,'dddd'))))]),_vm._v(" "),_c('h1',[_vm._v(" "+_vm._s(_vm._f("moment")(day,'DD'))+" ")]),_vm._v(" "),_c('small',{staticClass:"font-size-14"},[_vm._v(_vm._s(_vm._f("uppercase")(_vm._f("moment")(day,'MMMM'))))])])}),_vm._v(" "),_c('li',{staticClass:"list-inline-item text-center"},[_c('btn',{staticClass:"my-5 mx-3",on:{"click":_vm.nextWeek}},[_c('h1',[_c('i',{staticClass:"fas fa-chevron-circle-right my-3 text-secondary font-size-18"})])])],1)],2),_vm._v(" "),_c('p',{staticClass:"mt-5"},[_vm._v("Scegli l'ora")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-2 mb-5"},_vm._l((_vm.hours),function(h){return _c('li',{staticClass:"list-inline-item step2-list2-item text-center",class:{ active: h === _vm.schedule.hour },on:{"click":function($event){_vm.schedule.hour = h}}},[_vm._v(_vm._s(h)+"\n            ")])})),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.nextStep}},[_vm._v("Avanti")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":_vm.prevStep}},[_vm._v("Indietro")])],1)]):_vm._e(),_vm._v(" "),(_vm.currentStep(3))?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Come vuoi essere ricontattato?"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('p',{staticClass:"mt-3 mb-2"},[_vm._v("Numero di telefono")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"tel","placeholder":"Inserisci il tuo numero di telefono"},model:{value:(_vm.schedule.phone_number),callback:function ($$v) {_vm.$set(_vm.schedule, "phone_number", $$v)},expression:"schedule.phone_number"}}),_vm._v(" "),_c('p',{staticClass:"mt-3 mb-2"},[_vm._v("Indirizzo email")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"email","placeholder":"Inserisci il tuo indirizzo email"},model:{value:(_vm.schedule.email),callback:function ($$v) {_vm.$set(_vm.schedule, "email", $$v)},expression:"schedule.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_c('b-btn',{attrs:{"variant":"success","disabled":!_vm.schedule.phone_number || !_vm.schedule.email},on:{"click":_vm.nextStep}},[_vm._v("\n              Avanti\n            ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":_vm.prevStep}},[_vm._v("Indietro")])],1)],1):_vm._e(),_vm._v(" "),(_vm.currentStep(4))?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"title":"Riepilogo"}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"1"}},[_c('img',{staticClass:"img img-responsive",attrs:{"src":("/static/img/collaboration/" + (_vm.services[_vm.schedule.product].icon))}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_vm._v("\n              Strumento"),_c('br'),_vm._v(" "),_c('h4',[_c('strong',[_vm._v(_vm._s(_vm.services[_vm.schedule.product].name))])])]),_vm._v(" "),(_vm.schedule.category === 'Collaboration')?_c('b-col',{attrs:{"cols":"1"}},[_c('img',{staticClass:"my-3 img img-responsive",attrs:{"src":__webpack_require__(1313)}})]):_vm._e(),_vm._v(" "),(_vm.schedule.category === 'Collaboration')?_c('b-col',{staticClass:"text-center",attrs:{"cols":"1"}},[_c('img',{staticClass:"img img-responsive",attrs:{"src":("/static/img/collaboration/" + (_vm.services[_vm.schedule.product_dest].icon))}})]):_vm._e(),_vm._v(" "),(_vm.schedule.category === 'Collaboration')?_c('b-col',{attrs:{"cols":"3"}},[_vm._v("\n              Strumento destinazione"),_c('br'),_vm._v(" "),_c('h4',[_c('strong',[_vm._v(_vm._s(_vm.services[_vm.schedule.product_dest].name))])])]):_vm._e()],1),_vm._v(" "),(_vm.schedule.category === 'Tutor')?_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('p',[_vm._v("Tematiche di interesse")]),_vm._v(" "),_c('h3',_vm._l((_vm.schedule.options),function(value){return _c('b-badge',{key:value,staticClass:"mr-2",attrs:{"variant":"success"}},[_vm._v(_vm._s(value))])}))])],1):_vm._e(),_vm._v(" "),(_vm.schedule.category === 'Tutor')?_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('p',[_vm._v("Esigenze particolari")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm._f("placeholder")(_vm._f("nl2br")(_vm.schedule.customer_notes),'Nessuna nota inserita')))])])])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('p',[_vm._v("Contatti")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('h4',[_c('i',{staticClass:"fas fa-phone mr-2 text-secondary"}),_vm._v(" "+_vm._s(_vm.schedule.phone_number))])]),_vm._v(" "),_c('b-col',[_c('h4',[_c('i',{staticClass:"far fa-envelope mr-2 text-secondary"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.schedule.email))])])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('p',[_vm._v("Appuntamento")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('h4',[_c('i',{staticClass:"far fa-calendar-alt mr-2"}),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.schedule.day,'dddd DD MMMM')))])]),_vm._v(" "),_c('b-col',[_c('h4',[_c('i',{staticClass:"far fa-clock mr-2 text-secondary"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.schedule.hour)+":00")])])])],1),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_c('b-btn',{attrs:{"variant":"warning","size":"lg"},on:{"click":_vm.sendRequest}},[_vm._v("INVIA RICHIESTA")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-default"},on:{"click":_vm.prevStep}},[_vm._v("Indietro")])],1)],1):_vm._e(),_vm._v(" "),(_vm.success)?_c('b-card',{staticClass:"mb-3 py-2 px-3",attrs:{"bg-variant":"primary"}},[_c('b-btn',{staticClass:"float-right text-white",attrs:{"variant":"link"},on:{"click":function($event){_vm.success=false; _vm.show=false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"3","align-v":"center"}},[_c('img',{staticClass:"my-5",attrs:{"src":__webpack_require__(1314)}})]),_vm._v(" "),_c('b-col',{staticClass:"text-white",attrs:{"align-v":"center"}},[_c('h1',{staticClass:"mt-3"},[_vm._v("Grazie "+_vm._s(_vm.schedule.name)+",")]),_vm._v(" "),(_vm.schedule.category === 'Tutor')?_c('h3',[_vm._v("\n                La tua sessione di formazione su "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm.services[_vm.schedule.product].name))])]),_vm._v("\n                è stata confermata per il giorno "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm._f("moment")(_vm.schedule.day,'dddd DD MMMM')))])]),_vm._v("\n                alle ore "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm.schedule.hour)+":00")])]),_vm._v(".\n              ")]):_c('h3',[_vm._v("\n                La tua migrazione da "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm.services[_vm.schedule.product].name))])]),_vm._v("\n                verso "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm.services[_vm.schedule.product_dest].name))])]),_vm._v("\n                è stata confermata per il giorno "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm._f("moment")(_vm.schedule.day,'dddd DD MMMM')))])]),_vm._v("\n                alle ore "),_c('strong',[_c('u',[_vm._v(_vm._s(_vm.schedule.hour)+":00")])]),_vm._v(".\n              ")]),_vm._v(" "),_c('add-to-calendar',{staticClass:"mt-5 mb-2",attrs:{"title":_vm.eventTitle,"start":_vm.eventStart,"end":_vm.eventEnd},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-calendar',{staticClass:"btn btn-outline-light",attrs:{"id":"google-calendar"}},[_c('i',{staticClass:"fab fa-google mr-2"}),_vm._v(" Aggiungi a Google Calendar\n                  ")]),_vm._v(" "),_c('microsoft-calendar',{staticClass:"btn btn-outline-light",attrs:{"id":"microsoft-calendar"}},[_c('i',{staticClass:"fab fa-microsoft mr-2"}),_vm._v(" Aggiungi a Live Calendar\n                  ")])],1)},staticRenderFns:[]}})],1)],1)],1):_vm._e()],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDQzIDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0zLTEzaDQ4djQ4SC0zeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0uMiAyLjhMMyAwbDEyIDEyTDMgMjQgLjIgMjEuMiA5LjQgMTJ6IiBvcGFjaXR5PSIuMTUiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMDAwIiBkPSJNMTQuMiAyLjhMMTcgMGwxMiAxMi0xMiAxMi0yLjgtMi44IDkuMi05LjJ6IiBvcGFjaXR5PSIuMyIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0yOC4yIDIuOEwzMSAwbDEyIDEyLTEyIDEyLTIuOC0yLjggOS4yLTkuMnoiIG9wYWNpdHk9Ii41NCIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v(_vm._s(_vm.user.first_name)+", "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-gray-dark"},[_vm._v("benvenuto in CWM!")])])]),_vm._v(" "),_c('b-coL',[_c('b-img',{attrs:{"src":_vm.user.customer.logo_url,"height":"100","right":""}})],1)],1),_vm._v(" "),(_vm.otherPlans.length)?_c('b-card',{staticClass:"mt-5",attrs:{"no-body":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"text-center align-middle p-3",staticStyle:{"background-color":"hsl(1,100%,60%)"},attrs:{"cols":"1"}},[_c('img',{staticClass:"my-3",attrs:{"src":__webpack_require__(1316)}})]),_vm._v(" "),_c('b-col',{staticClass:"p-3 border-bottom",attrs:{"align-v":"center"}},[_c('h3',{staticClass:"m-0"},[_vm._v("Assistenza")]),_vm._v(" "),_c('span',{staticClass:"m-0",staticStyle:{"color":"#939393"}},[_vm._v("\n          Assistenza tecnica evoluta per i tuoi dispositivi digitali.\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-3 border-bottom",attrs:{"align-v":"center","align":"right"}},[_c('b-btn',{staticClass:"mt-2",attrs:{"variant":"outline-danger","size":"lg","to":{ name: 'Richieste', params: { create: true } }}},[_c('i',{staticClass:"fas fa-file-alt mr-2"}),_vm._v(" Nuova Richiesta\n        ")])],1)],1),_vm._v(" "),_vm._l((_vm.otherPlans),function(sub){return _c('b-row',{key:sub.id,attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"text-center align-middle p-3",staticStyle:{"background-color":"hsla(24,100%,54%,0.50)"},attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{staticClass:"p-3",attrs:{"cols":"7"}},[_c('strong',[_vm._v("\n          "+_vm._s(sub.plan.name)+"\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"m-0",staticStyle:{"color":"#939393"}},[_vm._v("\n          "+_vm._s(sub.plan.description)+"\n        ")]),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[(sub.plan.has_assistance)?_c('b-badge',[_vm._v("ASSISTENZA")]):_vm._e(),_vm._v(" "),(sub.plan.has_mdm)?_c('b-badge',[_vm._v("MDM")]):_vm._e(),_vm._v(" "),(sub.plan.has_kasko)?_c('b-badge',[_vm._v("KASKO")]):_vm._e(),_vm._v(" "),(sub.plan.has_security)?_c('b-badge',[_vm._v("SICUREZZA")]):_vm._e(),_vm._v(" "),(sub.plan.has_onsite)?_c('b-badge',[_vm._v("ONSITE")]):_vm._e()],1)]),_vm._v(" "),_c('b-col',{staticClass:"p-3"},[_c('p',[_vm._v("\n          Validità: "),_c('br'),_vm._v("\n          "+_vm._s(_vm._f("moment")(sub.date_start,'DD MMMM YYYY'))+"\n          "),_c('span',[_vm._v("→")]),_vm._v("\n          "+_vm._s(_vm._f("moment")(sub.date_expiration,'DD MMMM YYYY'))+"\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-3"},[_vm._v("\n        Stato\n        "),_c('h2',[_vm._v("\n          "+_vm._s(_vm._f("uppercase")(sub.status))+"\n        ")])])],1)})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTUiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA1NSA0MiI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iYSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB4PSIzMC4yNSIgcng9IjEyIi8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0tMS0xaDU2djQ4SC0xeiIvPgogICAgICAgIDxnPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMi4wMTYgNDEuMjVDLjgwMiA0MS4yNS4yNSA0MC42OTMuMjUgMzkuNDY5VjE0LjkyN2MwLS4zMzQuMTEtLjc4LjIyLTEuMDAyIDAgMCAxOC4xMDcgMTUuNjQ3IDIwLjMxNiAxNy41NCAxLjEwNCAxLjExMyAxLjg3Ni41NTcgMi40MjggMCAuMjIxLS4yMjMgMjAuMzE1LTE3LjU0IDIwLjMxNS0xNy41NC4xMS4zMzQuMjIxLjU1Ny4yMjEuODl2MjQuNTQyYy0uMTEgMS4yMjUtLjc3MyAxLjg5My0xLjk4NyAxLjg5M0gyLjAxNnptLS4zMjUtMjguNWg0MC4zOTdjLjExIDAgLjIyLjExMS4zMzEuMTExIDAgMC0xOS4wOTQgMTUuOTItMTkuMzE1IDE2LjE0My0uNDQyLjMzNC0xLjIxNCAxLjU1OC0yLjQyOSAwQzE2LjQ4IDI1LjEwNyAxLjQ3MSAxMi43NSAxLjQ3MSAxMi43NWguMjJ6Ii8+CiAgICAgICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiMyOTc5RkYiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0zMy40NjYgMTEuODQ4aDEuNDk3di41MDdjMCAzLjk0NCAzLjMwOCA3LjE0NSA3LjMyNiA3LjE0NSAxLjY5NCAwIDMuMjY5LS42MjUgNC40OS0xLjZMNDUuNCAxNS45ODVjLS44NjYuNzQyLTEuOTMgMS4xNzItMy4xMTEgMS4xNzItMi43NTcgMC00LjkyNC0yLjIyNi00LjkyNC00Ljg0MnYtLjUwN0gzOS4xcy4zNTQtLjE1Ni4xNTctLjQzYy0uNTktLjgyLTEuODUxLTIuNjU0LTIuNTItMy42My0uNDM0LS41MDgtLjg2NyAwLS44NjcgMHMtMS44MTIgMi41NzYtMi41MjEgMy42M2MtLjI3Ni4zMTMuMTE4LjQ2OS4xMTguNDY5em04Ljc4NC00LjI5NWMyLjc1NyAwIDQuOTYyIDIuMjI2IDQuOTYyIDQuODAydi4xMThINDUuNDhzLS4zOTQuMTU2LS4xOTcuNDNjLjc0OSAxLjA1MyAyLjUyMSAzLjYzIDIuNTIxIDMuNjNzLjM5NC41MDcuODY3IDBjLjY3LS45MzcgMS45NjktMi43NzIgMi41Mi0zLjYzLjE5Ny0uMjc0LS4xNTctLjQzLS4xNTctLjQzaC0xLjQ5N3YtLjExOGMwLTMuOTgyLTMuMzA4LTcuMTA1LTcuMjg2LTcuMTA1LTEuNjE1IDAtMy4xMTIuNTg2LTQuMzMzIDEuNDg0bDEuMyAxLjg3NGMuODY2LS43MDMgMS44OS0xLjA1NSAzLjAzMy0xLjA1NXoiIG1hc2s9InVybCgjYikiIG9wYWNpdHk9Ii43Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 1317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Richieste_vue__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c3d197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Richieste_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Richieste_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c3d197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Richieste_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mt-5",attrs:{"title":"Apri nuova richiesta"}},[_c('b-row',[_c('b-col',[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.createTicket($event)}}},[(_vm.ticket.num)?_c('h5',[_vm._v("Richiesta #"+_vm._s(_vm.ticket.num))]):_vm._e(),_vm._v(" "),(_vm.ticketTypes.length > 1)?_c('b-form-group',{attrs:{"label":"Seleziona Calendario"}},[_c('b-form-select',{attrs:{"options":_vm.ticketTypes,"value-field":"id","text-field":"code"},on:{"change":_vm.updateAgenda},model:{value:(_vm.ticket.type),callback:function ($$v) {_vm.$set(_vm.ticket, "type", $$v)},expression:"ticket.type"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Seleziona agenda --")])])],2)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{class:{ 'has-danger': _vm.errors.has('day') },attrs:{"label":"Seleziona giorno"}},[_c('b-select',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required","data-vv-as":"Data Intervento","name":"slot","type":"text","options":_vm.slots,"value-field":"day","text-field":"day","required":"","placeholder":"Seleziona giorno"},on:{"change":_vm.onDaySelected},model:{value:(_vm.selected.day),callback:function ($$v) {_vm.$set(_vm.selected, "day", $$v)},expression:"selected.day"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Seleziona giorno --")])])],2)],1),_vm._v(" "),_c('b-form-group',{class:{ 'has-danger': _vm.errors.has('slot') },attrs:{"label":"Seleziona fascia oraria"}},[_c('b-select',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"data-vv-rules":"required","data-vv-as":"Data Intervento","options":_vm.selected.slots,"value-field":"id","text-field":"start","placeholder":"Seleziona fascia oraria"},model:{value:(_vm.ticket.slot_id),callback:function ($$v) {_vm.$set(_vm.ticket, "slot_id", $$v)},expression:"ticket.slot_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- Seleziona fascia oraria --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Note"}},[_c('b-form-textarea',{attrs:{"placeholder":"Inserisci note","rows":4},model:{value:(_vm.ticket.customer_notes),callback:function ($$v) {_vm.$set(_vm.ticket, "customer_notes", $$v)},expression:"ticket.customer_notes"}})],1),_vm._v(" "),(_vm.ticket.type === 'Onsite')?_c('b-form-group',{class:{ 'has-danger': _vm.errors.has('site_address') },attrs:{"label":"Indirizzo"}},[_c('gmap-autocomplete',{staticClass:"input form-control",attrs:{"autocomplete":"off"},on:{"place_changed":_vm.getAddressData}})],1):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"type":"submit","disabled":_vm.errors.any()}},[_vm._v("\n          Invia Richiesta\n        ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline"},on:{"click":_vm.undoCreation}},[_vm._v("\n          Annulla\n        ")]),_vm._v(" "),(_vm.errors.any())?_c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":"danger"}},[_vm._v("\n          Attenzione, assicurati di aver inserito tutti i dati richiesti!\n        ")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.create)?_c('CreateTicket',{attrs:{"edit":this.ticketToEdit},on:{"ticket-created":_vm.onTicketCreated}}):_vm._e()],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5",attrs:{"title":"Le mie Richieste"}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('p',[_vm._v("Segui lo stato di avanzamento delle tue richieste.")])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"outline-danger"},on:{"click":_vm.createTicket}},[_c('i',{staticClass:"fas fa-file-alt mr-2"}),_vm._v(" Nuova Richiesta\n        ")])],1)],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.tickets,"fields":_vm.fields},scopedSlots:_vm._u([{key:"category",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.value))])]}},{key:"subcategory",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.value))]),_c('br'),_vm._v(" "),(data.item.tickets_extra)?_c('span',{staticClass:"font-size-12"},[_vm._v("\n          Prodotto di interesse:\n          "+_vm._s(_vm._f("placeholder")(_vm._f("capitalize")(data.item.tickets_extra.extra.product),'-'))+"\n        ")]):_vm._e()]}},{key:"slot",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("moment")(data.value.start,'DD/MM/YYYY HH:mm'))+"\n      ")]}},{key:"created_at",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("moment")(data.value,'DD/MM/YYYY HH:mm'))+"\n      ")]}},{key:"closed_at",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("placeholder")(_vm._f("moment")(data.value,'DD/MM/YYYY HH:mm'),'-'))+"\n      ")]}},{key:"id",fn:function(data){return [_c('b-btn',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#schedule'),expression:"'#schedule'"}],attrs:{"variant":"link","disabled":_vm.checkDisabled(data.item)},on:{"click":function($event){_vm.undoTicket(data.item)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])]}}])}),_vm._v(" "),(!_vm.tickets.length)?_c('p',{staticClass:"text-center p3"},[_vm._v("\n      Non risultano richieste aperte associate al tuo account."),_c('br'),_vm._v("\n      Creane una da questa pagina web oppure\n      "),_c('a',{attrs:{"href":"/#/download"}},[_vm._v("scarica l'applicazione")]),_vm._v(" per la tua piattaforma.\n    ")]):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('Schedule')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tickets_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55206efe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tickets_vue__ = __webpack_require__(1324);
function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55206efe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-5",attrs:{"title":"Le richieste dei dipendenti"}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('p',[_vm._v("L'elenco dei ticket aperti dai tuoi dipendenti.")])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('download-excel',{staticClass:"btn btn-outline-danger",attrs:{"data":_vm.tickets_export}},[_c('i',{staticClass:"fas fa-file-download mr-2"}),_vm._v(" Export Elenco\n        ")])],1)],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.tickets,"fields":_vm.fields},scopedSlots:_vm._u([{key:"user",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.value.full_name))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-secondary"},[_vm._v(_vm._s(data.value.phone_number)+" / "+_vm._s(data.value.email))])]}},{key:"category",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.value))])]}},{key:"subcategory",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.value))]),_c('br'),_vm._v(" "),(data.item.tickets_extra)?_c('span',{staticClass:"font-size-12"},[_vm._v("\n          Prodotto di interesse:\n          "+_vm._s(_vm._f("placeholder")(_vm._f("capitalize")(data.item.tickets_extra.extra.product),'-'))+"\n        ")]):_vm._e()]}},{key:"slot",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("moment")(data.value.start,'DD/MM/YYYY HH:mm'))+"\n      ")]}},{key:"created_at",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("moment")(data.value,'DD/MM/YYYY HH:mm'))+"\n      ")]}},{key:"closed_at",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("placeholder")(_vm._f("moment")(data.value,'DD/MM/YYYY HH:mm'),'-'))+"\n      ")]}},{key:"managed_at",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("placeholder")(_vm._f("moment")(data.value,'DD/MM/YYYY HH:mm'),'-'))+"\n      ")]}},{key:"sla",fn:function(data){return [_vm._v("\n        KPI1: "),_c('strong',[_vm._v(_vm._s(data.value.sla_1))]),_c('br'),_vm._v("\n        KPI2: "),_c('strong',[_vm._v(_vm._s(data.value.sla_2))])]}}])}),_vm._v(" "),(!_vm.tickets.length)?_c('p',{staticClass:"text-center p3"},[_vm._v("\n      Non risultano richieste aperte associate al tuo account."),_c('br')]):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('Schedule')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PNF = __webpack_require__(89).PhoneNumberFormat;
var phoneUtil = __webpack_require__(89).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  capitalize: function capitalize(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  convertSec2hhmmss: function convertSec2hhmmss(sec) {
    var totalSeconds = parseInt(sec);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    var seconds = totalSeconds - hours * 3600 - minutes * 60;

    // round seconds
    seconds = Math.round(seconds * 100) / 100;

    var result = hours < 10 ? '0' + hours : hours;
    result += ':' + (minutes < 10 ? '0' + minutes : minutes);
    result += ':' + (seconds < 10 ? '0' + seconds : seconds);
    return result;
  },

  dashIfNull: function dashIfNull(value) {
    if (value === null || value === '') {
      return '-';
    }

    return value;
  },

  formatParagraph: function formatParagraph(text) {
    var result = void 0;
    result = '<p>' + text + '</p>';
    result = result.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
    result = result.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');

    return result;
  },

  formatPhoneNumber: function formatPhoneNumber(value) {
    if (!value) return '-';

    console.log('format numeber', value);

    var phoneNumber = phoneUtil.parse(value, 'IT');
    return phoneUtil.format(phoneNumber, PNF.INTERNATIONAL);
  }
});

/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prod__ = __webpack_require__(1328);



var config = __WEBPACK_IMPORTED_MODULE_1__prod__["a" /* default */];

if (false) {
  config = dev;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  API_BASE_URL: 'http://localhost:8843'
});

/***/ }),

/***/ 1328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  API_BASE_URL: ''
});

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  g: {
    common_name: 'Ragione Sociale',
    customer_type: 'Segmento',
    full_name: 'Ragione Sociale',
    first_name: 'Nome',
    last_name: 'Cognome',
    piva_cf: 'PIVA / C.Fisc',
    email: 'Email',
    work_phone: 'Tel. Lavoro',
    mobile_phone: 'Cellulare',
    address: 'Indirizzo',
    city: 'Città',
    cap: 'CAP',
    region: 'Provincia',
    state: 'Nazione',
    created: 'Creato',
    updated: 'Aggiornato',
    removed: 'Rimosso',
    remove: 'Rimuovi',
    details: 'Dettagli',
    go_to_details: 'Vedi dettagli',
    actions: 'Azioni',
    view: 'Vedi',
    edit: 'Edita',
    delete: 'Rimuovi',
    manage: 'Gestisci',
    cancel: 'Cancella',
    id: '#',
    status: 'Stato',
    ok: 'Ok',
    proced: 'Procedi',
    confirm: 'Confermo',
    devices: 'Dispositivi',
    tickets: 'Tickets',
    customer: 'Cliente',
    platform: 'Piattaforma',
    plan: 'Piano',
    plan_type: 'Tipo Piano',
    type: 'Tipo',
    os: 'OS',
    device: 'Dispositivo',
    phone_number: 'Num. telefono',
    imei: 'IMEI',
    last_access: 'Ultimo Accesso',
    mode: 'Modalità',
    activity: 'Actività',
    category: 'Categoria',
    subcategory: 'Sotto categoria',
    schedule_date: 'Data appuntamento',
    manage_date: 'Gestito',
    managed_by: 'Gestito da',
    closing_date: 'Chiuso',
    user: 'Utente',
    users: 'Utenti',
    email_desc: 'L\'indirizzo email del cliente viene usato per il login.',
    phone_number_desc: 'Il numero di telefono del cliente. Può essere usato come login alternativo.',
    description: 'Descrizione',
    resolution: 'Esito',
    valid_until: 'Valido fino',
    date_creation: 'Data Creazione',
    date_opening: 'Data Apertura',
    date_activity: 'Data Attività',
    duration: 'Durata',
    start_manage: 'Avvia Intervento',
    resume_mange: 'Riprendi Intervento',
    end_manage: 'Concludi Intervento',

    assign_ticket: 'Assegna Ticket',
    reassign_ticket: 'Riassegna Ticket',
    close_ticket: 'Chidi ticket',
    reschedule_ticket: 'Ripianifica Ticket',
    cancel_ticket: 'Annulla Ticket',

    brand_model: 'Marca e Modello',
    status_change: 'Cambia stato',
    resolution_change: 'Cambia Esito',

    send: 'Invia',
    start: 'Avvia',
    stop: 'Stop',
    remote_access: 'Accesso remoto',
    push_notification: 'Notifica push',

    subscriptions: 'Piani sottoscritti',
    payment_method: 'Metodo Pagamento',
    date_start: 'Data Avvio',
    date_expiration: 'Data termine',
    date_next_payment: 'Prossimo pagamento',
    reset_password: 'Reimposta password',
    add_users: 'Aggiungi degli utenti a questo cliente.',

    serial: 'Seriale',
    model: 'Modello',
    version: 'Versione',
    last_login_at: 'Ultimo accesso',
    last_activity_at: 'Ultima attività',
    installed_at: 'Data installazione',
    has_error: 'In Errore',
    referent: 'Referente',

    name: 'Nominativo',
    provider: 'Provider',
    profile: 'Profilo Linea',
    line_number: 'Numero Linea',
    updated_at: 'Ultimo aggiornamento',
    online_since: 'Online Da',
    last_activity: 'Ultima attività',
    last_startup: 'Ultima accensione',
    sim_iccid: 'ICCID SIM',
    has_warning: 'In allarme',
    logged_at: 'Registrato',
    level: 'Livello',
    event: 'Evento',
    events: 'Eventi',
    open_ticket: 'Apri Ticket',
    monitored: 'Monitorato',
    warning: 'Attenzione',
    loading_message: 'Caricamento dati in corso... Si prega di attendere.',
    choice_lang: 'Cambia lingua',
    is_online: 'Online',
    search: 'Cerca',
    filter: 'Filtra',

    level_low: 'Basso',
    level_medium: 'Medio',
    level_high: 'Alto'
  }
});

/***/ }),

/***/ 1330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  g: {
    common_name: 'Common Name',
    customer_type: 'Customer type',
    full_name: 'Full Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    piva_cf: 'PIVA / C.Fisc',
    email: 'Email',
    work_phone: 'Work Phone',
    mobile_phone: 'Mobile Phone',
    address: 'Address',
    city: 'City',
    cap: 'ZIP',
    region: 'Region',
    state: 'Sate',
    created: 'Created',
    updated: 'Updated',
    removed: 'Removed',
    remove: 'Remove',
    details: 'Details',
    go_to_details: 'Go to Details',
    actions: 'Actions',
    manage: 'Manage',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    id: '#',
    status: 'Status',
    ok: 'Ok',
    proced: 'Proced',
    confirm: 'Confirm',
    devices: 'Devices',
    tickets: 'Tickets',
    customer: 'Customer',
    platform: 'Platform',
    plan: 'Plan',
    plan_type: 'Plan Type',
    type: 'Type',
    os: 'OS',
    device: 'Device',
    phone_number: 'Phone Number',
    imei: 'IMEI',
    last_access: 'Last Access',
    mode: 'Mode',
    activity: 'Activity',
    category: 'Category',
    subcategory: 'Subcategory',
    schedule_date: 'Schedule Date',
    manage_date: 'Managed',
    managed_by: 'Managed by',
    closing_date: 'Closed',
    user: 'User',
    users: 'Users',
    email_desc: 'The email address used by the user for the login.',
    phone_number_desc: 'The customer phone number. Can be used as alternative username.',
    description: 'Description',

    valid_until: 'Valido until',
    date_creation: 'Creation date',
    date_opening: 'Opening date',
    date_activity: 'Activity date',
    duration: 'Duration',
    start_manage: 'Start assistance',
    resume_mange: 'Resume assistance',
    end_manage: 'Close assistance',

    assign_ticket: 'Assegn Ticket',
    reassign_ticket: 'Reassegn Ticket',
    close_ticket: 'Close ticket',
    reschedule_ticket: 'Reschedule Ticket',
    cancel_ticket: 'Cancel Ticket',
    resolution: 'Resolution',
    status_change: 'Update status',
    resolution_change: 'Update resolution',
    brand_model: 'Brand and Model',
    send: 'Send',
    start: 'Start',
    stop: 'Stop',
    remote_access: 'Remote Access',
    push_notification: 'Push Notification',

    subscriptions: 'Subscriptions',
    payment_method: 'Payment Method',
    date_start: 'Date start',
    date_expiration: 'Date expiration',
    date_next_payment: 'Next payment',
    reset_password: 'Reset password',
    add_users: 'Add users to current customer.',

    serial: 'Serial',
    model: 'Model',
    version: 'Version',
    last_login_at: 'Last access',
    last_activity_at: 'Last activity',
    installed_at: 'Installation date',
    has_error: 'In alarm',
    referent: 'Contact Person',

    name: 'Contact Person',
    provider: 'Provider',
    profile: 'Connectivity Profile',
    line_number: 'Landline num.',
    updated_at: 'Last update',
    online_since: 'Online since',
    last_activity: 'Last Activity',
    last_startup: 'Last Startup',
    sim_iccid: 'SIM ICCID',
    has_warning: 'Has Warning',

    logged_at: 'Logged',
    level: 'Level',
    event: 'Event',
    events: 'Events',
    open_ticket: 'Open Ticket',
    monitored: 'Monitored',
    warning: 'Warning',
    loading_message: 'Loading Data... Please wait.',
    choice_lang: 'Change Lang',
    is_online: 'Online',
    search: 'Search',
    filter: 'Filter',

    level_low: 'Low',
    level_medium: 'Medium',
    level_high: 'High'
  }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(94);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(239);


var login = function login() {};

var logout = function logout() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].dispatch('logoutUser');
};

var getToken = function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user ? __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user.auth_token : null;
};

var getUser = function getUser() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user;
};

var getRole = function getRole() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.permissions.role;
};

var isLoggedIn = function isLoggedIn() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.logged;
};

var isProfileConfirmed = function isProfileConfirmed() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user && __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user.extra ? __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.auth.user.extra.profile_confirmed : false;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  login: login,
  logout: logout,
  isLoggedIn: isLoggedIn,
  isProfileConfirmed: isProfileConfirmed,
  getToken: getToken,
  getUser: getUser,
  getRole: getRole
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutationTypes__ = __webpack_require__(240);





var _mutations;






__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var state = {
  auth: {
    logged: false,
    user: null,
    redirect: null
  },
  user: {},
  plans: [],
  devices: [],
  tickets: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["a" /* LOGIN_USER */], function (state, userData, redirect) {
  state.auth.logged = true;
  state.auth.user = userData;
  state.auth.redirect = redirect;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["c" /* UPDATE_USER */], function (state, userData) {
  state.auth.user = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state.auth.user, userData);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["b" /* LOGOUT_USER */], function (state) {
  state.auth.logged = false;
  state.auth.user = {};
  state.auth.plans = [];
  state.auth.devices = [];
  state.auth.tickets = [];
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["f" /* USER_PROFILE */], function (state, user) {
  state.user = user;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["e" /* USER_PLANS */], function (state, plans) {
  state.plans = plans;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["d" /* USER_DEVICES */], function (state, devices) {
  state.devices = devices;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutationTypes__["g" /* USER_TICKETS */], function (state, tickets) {
  state.tickets = tickets;
}), _mutations);

var getters = {
  beUser: function beUser(state) {
    return state.auth.user;
  },
  isLogged: function isLogged(state) {
    return state.auth.logged;
  },
  hasSentinel: function hasSentinel(state) {
    return state.plans.some(function (p) {
      return p.plan.has_sentinel;
    });
  },
  isAdmin: function isAdmin(state) {
    return state.user.is_admin;
  },
  isProfileConfirmed: function isProfileConfirmed(state) {
    return state.auth.user && state.auth.user.extra ? state.auth.user.extra.profile_confirmed : false;
  }
};

var actions = {
  loginByUsernamePassword: function loginByUsernamePassword(context, logindata, redirect) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var session;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this._vm.$apiclient.loginWithUsernamePassword(logindata);

            case 2:
              session = _context.sent;

              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["a" /* LOGIN_USER */], session, redirect);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  logout: function logout(context) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["b" /* LOGOUT_USER */]);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getProfile: function getProfile(context) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3._vm.$apiclient.getProfile();

            case 2:
              data = _context3.sent;

              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["f" /* USER_PROFILE */], data);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getPlans: function getPlans(context) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4._vm.$apiclient.getPlans();

            case 2:
              data = _context4.sent;

              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["e" /* USER_PLANS */], data.plans);

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDevices: function getDevices(context) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5._vm.$apiclient.getDevices();

            case 2:
              data = _context5.sent;

              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["d" /* USER_DEVICES */], data);

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getTickets: function getTickets(context) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6._vm.$apiclient.getTickets();

            case 2:
              data = _context6.sent;

              context.commit(__WEBPACK_IMPORTED_MODULE_7__mutationTypes__["g" /* USER_TICKETS */], data);

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SOCKET_CONNECT */
/* unused harmony export SOCKET_AUTHENTICATED */
/* unused harmony export UPDATE_OT_SESSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_TICKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_DEVICES; });
var SOCKET_CONNECT = 'SOCKET_CONNECT';
var SOCKET_AUTHENTICATED = 'SOCKET_AUTHENTICATED';
var UPDATE_OT_SESSION = 'UPDATE_OT_SESSION';

var LOGIN_USER = 'LOGIN_USER';
var UPDATE_USER = 'UPDATE_USER';
var LOGOUT_USER = 'LOGOUT_USER';

var USER_PROFILE = 'USER_PROFILE';
var USER_PLANS = 'USER_PLANS';
var USER_TICKETS = 'USER_TICKETS';
var USER_DEVICES = 'USER_DEVICES';

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686b08bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__(1312);
function injectStyle (ssrContext) {
  __webpack_require__(1309)
  __webpack_require__(1310)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-686b08bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686b08bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_vendors_bs4_datepicker_js_bootstrap_datetimepicker_min__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_vendors_bs4_datepicker_css_bootstrap_datetimepicker_css__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_vendors_bs4_datepicker_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_vendors_bs4_datepicker_css_bootstrap_datetimepicker_css__);
//
//
//
//
//

var moment = window.moment || __webpack_require__(0);
var jQuery = __webpack_provided_window_dot_jQuery || __webpack_require__(85);




// Events list without prefix
// http://eonasdan.github.io/bootstrap-datetimepicker/Events/
var events = ['hide', 'show', 'change', 'error', 'update'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DatePicker',
  props: {
    value: {
      default: null,
      required: true,
      validator: function validator(value) {
        return value === null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof moment;
      }
    },
    placeholder: {
      default: 'Seleziona data',
      required: false,
      type: String
    },

    // http://eonasdan.github.io/bootstrap-datetimepicker/Options/
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /**
     * You can set this to true when component is wrapped in input-group
     * Note: inline and wrap mode wont work together
     */
    wrap: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dp: null,
      // jQuery DOM
      elem: null
    };
  },
  mounted: function mounted() {
    // Return early if date-picker is already loaded
    /* istanbul ignore if */
    if (this.dp) return;
    // Handle wrapped input
    this.elem = jQuery(this.wrap ? this.$el.parentNode : this.$el);
    // Init date-picker
    this.elem.datetimepicker(this.config);
    // Store data control
    this.dp = this.elem.data('DateTimePicker');
    // Set initial value
    this.dp.date(this.value);
    // Watch for changes
    this.elem.on('dp.change', this.onChange);
    // Register remaining events
    this.registerEvents();
  },

  watch: {
    /**
     * Listen to change from outside of component and update DOM
     *
     * @param newValue
     */
    value: function value(newValue) {
      this.dp && this.dp.date(newValue || null);
    },


    /**
     * Watch for any change in options and set them
     *
     * @param newConfig Object
     */
    config: {
      deep: true,
      handler: function handler(newConfig) {
        this.dp && this.dp.options(newConfig);
      }
    }
  },
  methods: {
    /**
     * Update v-model upon change triggered by date-picker itself
     *
     * @param event
     */
    onChange: function onChange(event) {
      var formattedDate = event.date ? event.date.format(this.dp.format()) : null;
      this.$emit('input', formattedDate);
    },


    /**
     * Emit all available events
     */
    registerEvents: function registerEvents() {
      var _this = this;

      events.forEach(function (name) {
        _this.elem.on('dp.' + name, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this.$emit.apply(_this, ['dp-' + name].concat(args));
        });
      });
    }
  },
  /**
   * Free up memory
   */
  beforeDestroy: function beforeDestroy() {
    /* istanbul ignore else */
    if (this.dp) {
      this.dp.destroy();
      this.dp = null;
      this.elem = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(85)))

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TitleNavBar',
  props: {
    title: { type: String, required: true },
    desc: { type: String, required: true },
    prev: { type: String }
  },
  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard-tile',
  props: ['title', 'desc', 'icon', 'color']
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Card',
  props: {
    title: {
      type: String,
      required: false,
      default: null
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _props$i18n$mounted$d;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (_props$i18n$mounted$d = {
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false
    },
    opts: {
      type: Object,
      required: false
    },
    onRowClicked: {
      type: Function,
      required: false
    }
  },
  i18n: {
    messages: {
      it: {
        sortby: 'Ordina per',
        error: 'In errore',
        offline: 'Offline',
        active: 'Attivo',
        false: 'Falso',
        true: 'Vero'
      },
      en: {
        sortby: 'Sort by',
        error: 'In error',
        offline: 'Offline',
        active: 'Active',
        false: 'False',
        true: 'True'
      }
    }
  },
  mounted: function mounted() {
    this.totalRows = this.items.length;
  },

  data: function data() {
    return {
      totalRows: 0,
      currentPage: 1,
      currentPerPage: 10,
      pageOptions: [5, 10, 15, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: { title: '', content: '' }
    };
  },
  computed: {
    perPage: function perPage() {
      return this.simple ? this.items.length : this.currentPerPage;
    },
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$i18n$mounted$d, 'mounted', function mounted() {
  if (this.opts) {
    this.currentPerPage = this.opts.currentPerPage;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$i18n$mounted$d, 'methods', {
  filterSentinels: function filterSentinels(sentinel) {
    var filterMatch = new RegExp(this.filter.query, 'i');

    if (this.filter.query) {
      var match = filterMatch.test(sentinel.agent_serial) || filterMatch.test(sentinel.agent_model) || filterMatch.test(sentinel.agent_version) || filterMatch.test(sentinel.customer.common_name) || filterMatch.test(sentinel.user.first_name) || filterMatch.test(sentinel.user.last_name);

      if (!match) return false;
    }

    if (this.filter.errors !== '' && sentinel.has_error !== this.filter.errors) {
      return false;
    }

    if (this.filter.status !== '' && sentinel.status !== this.filter.status) {
      return false;
    }

    return true;
  },
  onFiltered: function onFiltered(filteredItems) {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }
}), _props$i18n$mounted$d);

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global google*/

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GoogleAutocomplete',

  props: {
    id: {
      type: String,
      required: true
    },

    classname: String,

    preset: {
      type: String
    },

    placeholder: {
      type: String,
      default: 'Start typing'
    },

    types: {
      type: String,
      default: 'address'
    },

    country: {
      type: [String, Array],
      default: null
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      /**
       * The Autocomplete object.
       *
       * @type {Autocomplete}
       * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
       */
      autocomplete: null,

      /**
       * Autocomplete input text
       * @type {String}
       */
      autocompleteText: ''
    };
  },

  watch: {
    autocompleteText: function autocompleteText(newVal, oldVal) {
      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal });
    },

    preset: function preset(newval) {
      console.log("New preset", newval);
      this.autocompleteText = newval;
    }
  },

  mounted: function mounted() {
    var _this = this;

    var options = {};

    if (this.preset) {
      this.autocompleteText = this.preset;
    }

    if (this.types) {
      options.types = [this.types];
    }

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

    this.autocomplete.addListener('place_changed', function () {
      var place = _this.autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        _this.$emit('no-results-found', place);
        return;
      }

      var addressComponents = {
        formatted_address: 'formatted_address',
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };

      var returnData = {};

      returnData.formatted_address = place.formatted_address;

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData['latitude'] = place.geometry.location.lat();
        returnData['longitude'] = place.geometry.location.lng();

        // return returnData object and PlaceResult object
        _this.$emit('placechanged', returnData, place, _this.id);

        // update autocompleteText then emit change event
        _this.autocompleteText = document.getElementById(_this.id).value;
        _this.onChange();
      }
    });
  },

  methods: {
    /**
     * When the input gets focus
     */
    onFocus: function onFocus() {
      this.geolocate();
      this.$emit('focus');
    },


    /**
     * When the input loses focus
     */
    onBlur: function onBlur() {
      this.$emit('blur');
    },


    /**
     * When the input got changed
     */
    onChange: function onChange() {
      this.$emit('change', this.autocompleteText);
    },


    /**
     * When a key gets pressed
     * @param  {Event} event A keypress event
     */
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },


    /**
     * Clear the input
     */
    clear: function clear() {
      this.autocompleteText = '';
    },


    /**
     * Focus the input
     */
    focus: function focus() {
      this.$refs.autocomplete.focus();
    },


    /**
     * Blur the input
     */
    blur: function blur() {
      this.$refs.autocomplete.blur();
    },


    /**
     * Update the value of the input
     * @param  {String} value
     */
    update: function update(value) {
      this.autocompleteText = value;
    },


    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate: function geolocate() {
      var _this2 = this;

      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            _this2.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SkilloChart',

  props: {
    type: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: [Object, Array]
    },
    options: Object,
    width: Number,
    height: Number
  },

  data: function data() {
    return {
      chart: ''
    };
  },

  watch: {
    'data.labels': function dataLabels() {
      console.log('dataset aggiornato');
      this.chart.update();
    },
    'data.datasets': function dataDatasets() {
      console.log('dataset aggiornato');
      this.chart.update();
    }
  },

  methods: {
    createChart: function createChart() {
      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$refs.chart, {
        type: this.type,
        data: this.data,
        options: this.options
      });
    }
  },

  mounted: function mounted() {
    this.createChart();
  },
  beforeDestroy: function beforeDestroy() {
    this.chart.destroy();
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);





//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // mime type [xls, csv]
    type: {
      type: String,
      default: "xls"
    },
    // Json to download
    data: {
      type: Array,
      required: false,
      default: null
    },
    // fields inside the Json Object that you want to export
    // if no given, all the properties in the Json are exported
    fields: {
      type: Object,
      required: false
    },
    // this prop is used to fix the problem with other components that use the
    // variable fields, like vee-validate. exportFields works exactly like fields
    exportFields: {
      type: Object,
      required: false
    },
    // Use as fallback when the row has no field values
    defaultValue: {
      type: String,
      required: false,
      default: ""
    },
    // Title(s) for the data, could be a string or an array of strings (multiple titles)
    title: {
      default: null
    },
    // Footer(s) for the data, could be a string or an array of strings (multiple footers)
    footer: {
      default: null
    },
    // filename to export
    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    // unique identifier
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, json;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.data;

                if (!(typeof _this.fetch === 'function' || !data)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.fetch();

              case 4:
                data = _context.sent;

              case 5:
                if (!(!data || !data.length)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                json = _this.getProcessedJson(data, _this.downloadFields);

                if (!(_this.type === "html")) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

              case 12:
                if (!(_this.type === "csv")) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

              case 14:
                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    /*
    Use downloadjs to generate the download link
    */
    export: function _export(data, filename, mime) {
      var blob = this.base64ToBlob(data, mime);
      __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, filename, mime);
    },

    /*
    jsonToXLS
    ---------------
    Transform json data into an xml document with MS Excel format, sadly
    it shows a prompt when it opens, that is a default behavior for
    Microsoft office and cannot be avoided. It's recommended to use CSV format instead.
    */
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;

      //Header
      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      //Fields
      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      //Data
      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + item[_key] + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      //Footer
      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData);
    },

    /*
    jsonToCSV
    ---------------
    Transform json data into an CSV file.
    */
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];
      //Header
      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }
      //Fields
      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");
      //Data
      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = item[_key2] + ""; // cast Numbers to string
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });
      //Footer
      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },

    /*
    getProcessedJson
    ---------------
    Get only the data to export, if no fields are set return all the data
    */
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },

    /*
    parseExtraData
    ---------------
    Parse title and footer attribute to the csv format
    */
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } // end methods
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fullcalendar__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullcalendar_dist_locale_it__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullcalendar_dist_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fullcalendar_dist_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css__);

//
//
//
//
//
//
//
//
//
//







// import 'fullcalendar-scheduler/dist/scheduler';
// import 'fullcalendar-scheduler/dist/scheduler.css';


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    events: {
      default: function _default() {
        return [];
      }
    },

    eventSources: {
      default: function _default() {
        return [];
      }
    },

    editable: {
      default: function _default() {
        return true;
      }
    },

    selectable: {
      default: function _default() {
        return true;
      }
    },

    selectHelper: {
      default: function _default() {
        return true;
      }
    },

    header: {
      default: function _default() {
        return {
          left: 'prev,next today',
          center: 'title',
          right: 'month,agendaWeek,agendaTreGiorni,agendaDay,listWeek'
        };
      }
    },

    defaultView: {
      default: function _default() {
        return 'agendaWeek';
      }
    },

    sync: {
      default: function _default() {
        return false;
      }
    },

    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  computed: {
    defaultConfig: function defaultConfig() {
      var self = this;

      return {
        themeSystem: 'bootstrap4',
        locale: 'it',
        timezone: 'Europe/Rome',
        allDaySlot: false,
        scrollTime: '09:00',
        minTime: '09:00',
        maxTime: '19:00',

        header: this.header,
        defaultView: this.defaultView,
        editable: this.editable,
        selectable: this.selectable,
        selectHelper: this.selectHelper,
        timeFormat: 'HH:mm',
        events: this.events,
        eventSources: this.eventSources,

        views: {
          agendaTreGiorni: {
            type: 'agenda',
            duration: { days: 3 },
            groupByResource: true
          }
        },

        eventRender: function eventRender() {
          if (this.sync) {
            self.events = cal.fullCalendar('clientEvents');
          }

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
        },
        eventDestroy: function eventDestroy(event) {
          if (this.sync) {
            self.events = cal.fullCalendar('clientEvents');
          }
        },
        eventClick: function eventClick() {
          $('.selected-slot').removeClass('selected-slot');
          $(this).addClass('selected-slot');

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
        },
        eventDrop: function eventDrop() {
          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
        },
        eventResize: function eventResize() {
          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
        },
        dayClick: function dayClick() {
          for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
        },
        select: function select(start, end, jsEvent, view, resource) {
          self.$emit('event-created', {
            start: start,
            end: end,
            allDay: !start.hasTime() && !end.hasTime(),
            view: view,
            resource: resource
          });
        }
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    var cal = $(this.$el),
        self = this;

    this.$on('remove-event', function (event) {
      if (event && event.hasOwnProperty('id')) {
        $(_this.$el).fullCalendar('removeEvents', event.id);
      } else {
        $(_this.$el).fullCalendar('removeEvents', event);
      }
    });

    this.$on('rerender-events', function () {
      $(_this.$el).fullCalendar('rerenderEvents');
    });

    this.$on('refetch-events', function () {
      $(_this.$el).fullCalendar('refetchEvents');
    });

    this.$on('render-event', function (event) {
      $(_this.$el).fullCalendar('renderEvent', event);
    });

    this.$on('reload-events', function () {
      $(_this.$el).fullCalendar('removeEvents');
      $(_this.$el).fullCalendar('addEventSource', _this.events);
    });

    this.$on('rebuild-sources', function () {
      $(_this.$el).fullCalendar('removeEventSources');
      _this.eventSources.map(function (event) {
        $(_this.$el).fullCalendar('addEventSource', event);
      });
    });

    cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
  },


  methods: {
    fireMethod: function fireMethod() {
      var _$;

      return (_$ = $(this.$el)).fullCalendar.apply(_$, arguments);
    }
  },

  watch: {
    events: {
      deep: true,
      handler: function handler(val) {
        $(this.$el).fullCalendar('removeEvents');
        $(this.$el).fullCalendar('addEventSource', this.events);
      }
    },
    eventSources: {
      deep: true,
      handler: function handler(val) {
        this.$emit('rebuild-sources');
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('remove-event');
    this.$off('rerender-events');
    this.$off('refetch-events');
    this.$off('render-event');
    this.$off('reload-events');
    this.$off('rebuild-sources');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(85)))

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(NProgress) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authManager__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index__ = __webpack_require__(239);







var apiClient = {
  /**
   * this object contains all the endpoints available from apis
   */
  calls: function calls(context) {
    var _this = this;

    var makeCall = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(verb, endpoint, data, config) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                response = null;
                _context.t0 = verb;
                _context.next = _context.t0 === 'GET' ? 4 : _context.t0 === 'POST' ? 8 : _context.t0 === 'PUT' ? 12 : _context.t0 === 'DELETE' ? 16 : 20;
                break;

              case 4:
                _context.next = 6;
                return context.axios.get(endpoint, data, config);

              case 6:
                response = _context.sent;
                return _context.abrupt('break', 23);

              case 8:
                _context.next = 10;
                return context.axios.post(endpoint, data, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  withCredentials: true,
                  xsrfCookieName: 'XSRF-TOKEN',
                  xsrfHeaderName: 'X-XSRF-TOKEN'
                }, config));

              case 10:
                response = _context.sent;
                return _context.abrupt('break', 23);

              case 12:
                _context.next = 14;
                return context.axios.put(endpoint, data);

              case 14:
                response = _context.sent;
                return _context.abrupt('break', 23);

              case 16:
                _context.next = 18;
                return context.axios.delete(endpoint);

              case 18:
                response = _context.sent;
                return _context.abrupt('break', 23);

              case 20:
                _context.next = 22;
                return context.axios.get(endpoint);

              case 22:
                response = _context.sent;

              case 23:
                return _context.abrupt('return', response.data ? response.data.data : null);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function makeCall(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      getLoginData: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt('return', makeCall('GET', '/auth/login'));

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function getLoginData() {
          return _ref2.apply(this, arguments);
        };
      }(),
      loginWithUsernamePassword: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt('return', makeCall('POST', '/auth/login', data));

                case 1:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this);
        }));

        return function loginWithUsernamePassword(_x5) {
          return _ref3.apply(this, arguments);
        };
      }(),
      recoverPassword: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt('return', makeCall('POST', '/auth/recover', data));

                case 1:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this);
        }));

        return function recoverPassword(_x6) {
          return _ref4.apply(this, arguments);
        };
      }(),
      getProfile: function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt('return', makeCall('GET', '/profile'));

                case 1:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this);
        }));

        return function getProfile() {
          return _ref5.apply(this, arguments);
        };
      }(),
      updateProfile: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt('return', makeCall('POST', '/profile', data));

                case 1:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this);
        }));

        return function updateProfile(_x7) {
          return _ref6.apply(this, arguments);
        };
      }(),
      getDevices: function () {
        var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt('return', makeCall('GET', '/profile/devices'));

                case 1:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this);
        }));

        return function getDevices() {
          return _ref7.apply(this, arguments);
        };
      }(),
      getPlans: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.abrupt('return', makeCall('GET', '/profile/plans'));

                case 1:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, _this);
        }));

        return function getPlans() {
          return _ref8.apply(this, arguments);
        };
      }(),
      checkUser: function () {
        var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(field, value) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  return _context9.abrupt('return', makeCall('POST', '/profile/check', { field: field, value: value }));

                case 1:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, _this);
        }));

        return function checkUser(_x8, _x9) {
          return _ref9.apply(this, arguments);
        };
      }(),

      // tickets
      getTickets: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.abrupt('return', makeCall('GET', '/tickets'));

                case 1:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, _this);
        }));

        return function getTickets() {
          return _ref10.apply(this, arguments);
        };
      }(),
      getCustomerTickets: function () {
        var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.abrupt('return', makeCall('GET', '/tickets/customer'));

                case 1:
                case 'end':
                  return _context11.stop();
              }
            }
          }, _callee11, _this);
        }));

        return function getCustomerTickets() {
          return _ref11.apply(this, arguments);
        };
      }(),
      createTicket: function () {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  return _context12.abrupt('return', makeCall('POST', '/tickets', data));

                case 1:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, _this);
        }));

        return function createTicket(_x10) {
          return _ref12.apply(this, arguments);
        };
      }(),
      updateTicket: function () {
        var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13(id, data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  return _context13.abrupt('return', makeCall('PUT', '/tickets/' + id, data));

                case 1:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, _this);
        }));

        return function updateTicket(_x11, _x12) {
          return _ref13.apply(this, arguments);
        };
      }(),
      getAgendas: function () {
        var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14(type_id, start, end) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  return _context14.abrupt('return', makeCall('GET', '/tickets/slots'));

                case 1:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, _this);
        }));

        return function getAgendas(_x13, _x14, _x15) {
          return _ref14.apply(this, arguments);
        };
      }(),
      getSlots: function () {
        var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15(type_id, start, end) {
          var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'slot';
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  return _context15.abrupt('return', makeCall('GET', '/tickets/slots/' + type_id, {
                    params: { start: start, end: end, format: format }
                  }));

                case 1:
                case 'end':
                  return _context15.stop();
              }
            }
          }, _callee15, _this);
        }));

        return function getSlots(_x16, _x17, _x18) {
          return _ref15.apply(this, arguments);
        };
      }(),

      // sentinel
      getSentinels: function () {
        var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  return _context16.abrupt('return', makeCall('GET', '/sentinels'));

                case 1:
                case 'end':
                  return _context16.stop();
              }
            }
          }, _callee16, _this);
        }));

        return function getSentinels() {
          return _ref16.apply(this, arguments);
        };
      }(),
      getSentinel: function () {
        var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  return _context17.abrupt('return', makeCall('GET', '/sentinels/' + id));

                case 1:
                case 'end':
                  return _context17.stop();
              }
            }
          }, _callee17, _this);
        }));

        return function getSentinel(_x20) {
          return _ref17.apply(this, arguments);
        };
      }(),

      getAdditionalnfo: function () {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18(id, key) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  return _context18.abrupt('return', makeCall('GET', '/sentinels/' + id + '/additional_info/' + key));

                case 1:
                case 'end':
                  return _context18.stop();
              }
            }
          }, _callee18, _this);
        }));

        return function getAdditionalnfo(_x21, _x22) {
          return _ref18.apply(this, arguments);
        };
      }(),
      setAdditionalnfo: function () {
        var _ref19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19(id, key, value) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  return _context19.abrupt('return', makeCall('POST', '/sentinels/' + id + '/additional_info', { key: key, value: value }));

                case 1:
                case 'end':
                  return _context19.stop();
              }
            }
          }, _callee19, _this);
        }));

        return function setAdditionalnfo(_x23, _x24, _x25) {
          return _ref19.apply(this, arguments);
        };
      }(),
      getSentinelSpeedtest: function () {
        var _ref20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  return _context20.abrupt('return', makeCall('GET', '/sentinels/' + id + '/speedtests'));

                case 1:
                case 'end':
                  return _context20.stop();
              }
            }
          }, _callee20, _this);
        }));

        return function getSentinelSpeedtest(_x26) {
          return _ref20.apply(this, arguments);
        };
      }(),
      getSentinelPings: function () {
        var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  return _context21.abrupt('return', makeCall('GET', '/sentinels/' + id + '/pings'));

                case 1:
                case 'end':
                  return _context21.stop();
              }
            }
          }, _callee21, _this);
        }));

        return function getSentinelPings(_x27) {
          return _ref21.apply(this, arguments);
        };
      }(),
      getSentinelTraffic: function () {
        var _ref22 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  return _context22.abrupt('return', makeCall('GET', '/sentinels/' + id + '/traffic'));

                case 1:
                case 'end':
                  return _context22.stop();
              }
            }
          }, _callee22, _this);
        }));

        return function getSentinelTraffic(_x28) {
          return _ref22.apply(this, arguments);
        };
      }(),

      getSentinelDevicesOverall: function () {
        var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  return _context23.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/overall'));

                case 1:
                case 'end':
                  return _context23.stop();
              }
            }
          }, _callee23, _this);
        }));

        return function getSentinelDevicesOverall(_x29) {
          return _ref23.apply(this, arguments);
        };
      }(),
      getSentinelDevices: function () {
        var _ref24 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  return _context24.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices'));

                case 1:
                case 'end':
                  return _context24.stop();
              }
            }
          }, _callee24, _this);
        }));

        return function getSentinelDevices(_x30) {
          return _ref24.apply(this, arguments);
        };
      }(),
      getSentinelDevicesDiscoveries: function () {
        var _ref25 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  return _context25.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/discoveries'));

                case 1:
                case 'end':
                  return _context25.stop();
              }
            }
          }, _callee25, _this);
        }));

        return function getSentinelDevicesDiscoveries(_x31) {
          return _ref25.apply(this, arguments);
        };
      }(),
      getSentinelDevice: function () {
        var _ref26 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26(id, device_id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  return _context26.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/' + device_id));

                case 1:
                case 'end':
                  return _context26.stop();
              }
            }
          }, _callee26, _this);
        }));

        return function getSentinelDevice(_x32, _x33) {
          return _ref26.apply(this, arguments);
        };
      }(),
      updateSentinelDevice: function () {
        var _ref27 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27(id, device_id, data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  return _context27.abrupt('return', makeCall('POST', '/sentinels/' + id + '/devices/' + device_id, data));

                case 1:
                case 'end':
                  return _context27.stop();
              }
            }
          }, _callee27, _this);
        }));

        return function updateSentinelDevice(_x34, _x35, _x36) {
          return _ref27.apply(this, arguments);
        };
      }(),

      getSentinelDeviceMonitoringSettings: function () {
        var _ref28 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28(id, device_id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  return _context28.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/' + device_id + '/monitoring'));

                case 1:
                case 'end':
                  return _context28.stop();
              }
            }
          }, _callee28, _this);
        }));

        return function getSentinelDeviceMonitoringSettings(_x37, _x38) {
          return _ref28.apply(this, arguments);
        };
      }(),
      updateSentinelDeviceMonitoringSettings: function () {
        var _ref29 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29(id, device_id, data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  return _context29.abrupt('return', makeCall('POST', '/sentinels/' + id + '/devices/' + device_id + '/monitoring', data));

                case 1:
                case 'end':
                  return _context29.stop();
              }
            }
          }, _callee29, _this);
        }));

        return function updateSentinelDeviceMonitoringSettings(_x39, _x40, _x41) {
          return _ref29.apply(this, arguments);
        };
      }(),

      getSentinelDeviceTraffic: function () {
        var _ref30 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30(id, device_id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  return _context30.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/' + device_id + '/trafficaggregate'));

                case 1:
                case 'end':
                  return _context30.stop();
              }
            }
          }, _callee30, _this);
        }));

        return function getSentinelDeviceTraffic(_x42, _x43) {
          return _ref30.apply(this, arguments);
        };
      }(),
      getSentinelDeviceSettings: function () {
        var _ref31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31(id, device_id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  return _context31.abrupt('return', makeCall('GET', '/sentinels/' + id + '/devices/' + device_id + '/settings'));

                case 1:
                case 'end':
                  return _context31.stop();
              }
            }
          }, _callee31, _this);
        }));

        return function getSentinelDeviceSettings(_x44, _x45) {
          return _ref31.apply(this, arguments);
        };
      }(),
      setSentinelDeviceSettings: function () {
        var _ref32 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32(id, device_id, data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  return _context32.abrupt('return', makeCall('POST', '/sentinels/' + id + '/devices/' + device_id + '/settings', data));

                case 1:
                case 'end':
                  return _context32.stop();
              }
            }
          }, _callee32, _this);
        }));

        return function setSentinelDeviceSettings(_x46, _x47, _x48) {
          return _ref32.apply(this, arguments);
        };
      }(),

      getAllEvents: function () {
        var _ref33 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  return _context33.abrupt('return', makeCall('GET', '/sentinels/events'));

                case 1:
                case 'end':
                  return _context33.stop();
              }
            }
          }, _callee33, _this);
        }));

        return function getAllEvents() {
          return _ref33.apply(this, arguments);
        };
      }(),
      getSentinelEvents: function () {
        var _ref34 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  return _context34.abrupt('return', makeCall('GET', '/sentinels/' + id + '/events'));

                case 1:
                case 'end':
                  return _context34.stop();
              }
            }
          }, _callee34, _this);
        }));

        return function getSentinelEvents(_x49) {
          return _ref34.apply(this, arguments);
        };
      }(),
      getSentinelEventsByType: function () {
        var _ref35 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35(id, type) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  return _context35.abrupt('return', makeCall('GET', '/sentinels/' + id + '/events/type/' + type));

                case 1:
                case 'end':
                  return _context35.stop();
              }
            }
          }, _callee35, _this);
        }));

        return function getSentinelEventsByType(_x50, _x51) {
          return _ref35.apply(this, arguments);
        };
      }(),
      getSentinelEventsByDevice: function () {
        var _ref36 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36(id, device) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  return _context36.abrupt('return', makeCall('GET', '/sentinels/' + id + '/events/device/' + device));

                case 1:
                case 'end':
                  return _context36.stop();
              }
            }
          }, _callee36, _this);
        }));

        return function getSentinelEventsByDevice(_x52, _x53) {
          return _ref36.apply(this, arguments);
        };
      }(),

      getSentinelNetworkSettings: function () {
        var _ref37 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee37(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  return _context37.abrupt('return', makeCall('GET', '/sentinels/' + id + '/settings/network'));

                case 1:
                case 'end':
                  return _context37.stop();
              }
            }
          }, _callee37, _this);
        }));

        return function getSentinelNetworkSettings(_x54) {
          return _ref37.apply(this, arguments);
        };
      }(),
      setSentinelNetworkSettings: function () {
        var _ref38 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee38(id, settings) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  return _context38.abrupt('return', makeCall('POST', '/sentinels/' + id + '/settings/network', settings));

                case 1:
                case 'end':
                  return _context38.stop();
              }
            }
          }, _callee38, _this);
        }));

        return function setSentinelNetworkSettings(_x55, _x56) {
          return _ref38.apply(this, arguments);
        };
      }(),
      getSentinelMonitoringSettings: function () {
        var _ref39 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee39(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  return _context39.abrupt('return', makeCall('GET', '/sentinels/' + id + '/settings/monitoring'));

                case 1:
                case 'end':
                  return _context39.stop();
              }
            }
          }, _callee39, _this);
        }));

        return function getSentinelMonitoringSettings(_x57) {
          return _ref39.apply(this, arguments);
        };
      }(),
      setSentinelMonitoringSettings: function () {
        var _ref40 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee40(id, settings) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  return _context40.abrupt('return', makeCall('POST', '/sentinels/' + id + '/settings/monitoring', settings));

                case 1:
                case 'end':
                  return _context40.stop();
              }
            }
          }, _callee40, _this);
        }));

        return function setSentinelMonitoringSettings(_x58, _x59) {
          return _ref40.apply(this, arguments);
        };
      }(),
      getSentinelAlarmsSettings: function () {
        var _ref41 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee41(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  return _context41.abrupt('return', makeCall('GET', '/sentinels/' + id + '/settings/alarms'));

                case 1:
                case 'end':
                  return _context41.stop();
              }
            }
          }, _callee41, _this);
        }));

        return function getSentinelAlarmsSettings(_x60) {
          return _ref41.apply(this, arguments);
        };
      }(),
      setSentinelAlarmsSettings: function () {
        var _ref42 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee42(id, settings) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  return _context42.abrupt('return', makeCall('POST', '/sentinels/' + id + '/settings/alarms', settings));

                case 1:
                case 'end':
                  return _context42.stop();
              }
            }
          }, _callee42, _this);
        }));

        return function setSentinelAlarmsSettings(_x61, _x62) {
          return _ref42.apply(this, arguments);
        };
      }(),

      getSentinelsTickets: function () {
        var _ref43 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee43() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  return _context43.abrupt('return', makeCall('GET', '/sentinels/tickets'));

                case 1:
                case 'end':
                  return _context43.stop();
              }
            }
          }, _callee43, _this);
        }));

        return function getSentinelsTickets() {
          return _ref43.apply(this, arguments);
        };
      }(),
      getSentinelsTicketsArchive: function () {
        var _ref44 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee44() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  return _context44.abrupt('return', makeCall('GET', '/sentinels/tickets/archive'));

                case 1:
                case 'end':
                  return _context44.stop();
              }
            }
          }, _callee44, _this);
        }));

        return function getSentinelsTicketsArchive() {
          return _ref44.apply(this, arguments);
        };
      }(),
      getSentinelsTicketsData: function () {
        var _ref45 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee45() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
            while (1) {
              switch (_context45.prev = _context45.next) {
                case 0:
                  return _context45.abrupt('return', makeCall('GET', '/sentinels/tickets/data'));

                case 1:
                case 'end':
                  return _context45.stop();
              }
            }
          }, _callee45, _this);
        }));

        return function getSentinelsTicketsData() {
          return _ref45.apply(this, arguments);
        };
      }(),
      createSentinelsTicket: function () {
        var _ref46 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee46(ticket_data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  return _context46.abrupt('return', makeCall('POST', '/sentinels/tickets/create', ticket_data));

                case 1:
                case 'end':
                  return _context46.stop();
              }
            }
          }, _callee46, _this);
        }));

        return function createSentinelsTicket(_x63) {
          return _ref46.apply(this, arguments);
        };
      }(),

      getSentinelTickets: function () {
        var _ref47 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee47(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  return _context47.abrupt('return', makeCall('GET', '/sentinels/' + id + '/tickets'));

                case 1:
                case 'end':
                  return _context47.stop();
              }
            }
          }, _callee47, _this);
        }));

        return function getSentinelTickets(_x64) {
          return _ref47.apply(this, arguments);
        };
      }(),
      getSentinelTicket: function () {
        var _ref48 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee48(id, ticket_id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  return _context48.abrupt('return', makeCall('GET', '/sentinels/' + id + '/tickets/' + ticket_id));

                case 1:
                case 'end':
                  return _context48.stop();
              }
            }
          }, _callee48, _this);
        }));

        return function getSentinelTicket(_x65, _x66) {
          return _ref48.apply(this, arguments);
        };
      }(),
      updateSentinelTicket: function () {
        var _ref49 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee49(id, ticket_id, ticket_data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  return _context49.abrupt('return', makeCall('POST', '/sentinels/' + id + '/tickets/' + ticket_id, ticket_data));

                case 1:
                case 'end':
                  return _context49.stop();
              }
            }
          }, _callee49, _this);
        }));

        return function updateSentinelTicket(_x67, _x68, _x69) {
          return _ref49.apply(this, arguments);
        };
      }(),
      getSentinelTicketsArchive: function () {
        var _ref50 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee50(id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50) {
            while (1) {
              switch (_context50.prev = _context50.next) {
                case 0:
                  return _context50.abrupt('return', makeCall('GET', '/sentinels/' + id + '/tickets/archive'));

                case 1:
                case 'end':
                  return _context50.stop();
              }
            }
          }, _callee50, _this);
        }));

        return function getSentinelTicketsArchive(_x70) {
          return _ref50.apply(this, arguments);
        };
      }()
    };
  },


  /**
   * Attach to current Vue instance
   * @param Vue
   * @param options
   */
  install: function install(Vue, options) {
    if (options.baseURL) {
      console.log('[apiclient] Setting base URL to ' + options.baseURL);
      Vue.axios.defaults.baseURL = options.baseURL;
    }
    Vue.prototype.$apiclient = this.calls(Vue);
    Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__authManager__["a" /* default */].getToken();

    __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].watch(function (state) {
      return state.auth.user;
    }, function (user) {
      // sending command to web socket when ot session is ready
      if (user !== null) {
        console.log('Updating user token: ' + __WEBPACK_IMPORTED_MODULE_4__authManager__["a" /* default */].getToken());
        Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__authManager__["a" /* default */].getToken();
      }
    });

    // errors interceptor
    Vue.axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (!error.response) {
        Vue.$router.push('/error');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      }

      console.info('Http Call Response. Status: ' + error.response.status);

      switch (error.response.status) {
        case 401:
          console.warn('Auth token expired, redirect to login');
          __WEBPACK_IMPORTED_MODULE_4__authManager__["a" /* default */].logout();
          break;
      }

      // Do something with response error
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
    });

    // Setting loading on request, then close it
    Vue.axios.interceptors.request.use(function (config) {
      NProgress.start();
      return config;
    }, function (error) {
      NProgress.done();
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    Vue.axios.interceptors.response.use(function (response) {
      NProgress.done();
      return response;
    }, function (error) {
      NProgress.done();
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (apiClient);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1252)))

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isLogged', 'beUser']))
});

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Index',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isLogged']))
});

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "attiva"
});

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      login: {
        username: null,
        password: null
      },
      e1: true,
      error: null
    };
  },

  computed: {
    formFilled: function formFilled() {
      return this.login.username && this.login.password;
    }
  },
  mounted: function mounted() {
    return this.initData();
  },


  methods: {
    initData: function initData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$apiclient.getLoginData();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkAuth: function checkAuth() {
      var _this2 = this;

      this.$validator.validateAll();

      if (!this.errors.any()) {
        var credentials = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.login);

        var loader = this.$loading.show();
        this.$store.dispatch("loginByUsernamePassword", credentials).then(function () {
          console.log("Logged with success");
          loader.hide();
          _this2.$router.push("/area-riservata/piani");
        }).catch(function (err) {
          console.log("Wrong credentials..", err);
          loader.hide();
          _this2.error = "Nome utente o password errate.";
        });
      }
    }
  }
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(1285);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Recover',
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      login: {
        username: '',
        password: ''
      },
      e1: true,
      error: null
    };
  },


  methods: {
    onSubmit: function onSubmit() {
      console.log('onSubmit');
      //this.$refs.recaptcha.execute();
      this.onVerify();
    },
    onVerify: function onVerify(recaptchaToken) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('onCaptchaVerified', recaptchaToken);

                _context.prev = 1;
                _context.next = 4;
                return _this.$apiclient.recoverPassword({ username: _this.login.username, recaptchaToken: recaptchaToken });

              case 4:
                res = _context.sent;
                _context.next = 7;
                return _this.$swal('Recupero password', 'La password è stata resettata con successo: controlla la tua mail e/o cellulare.', 'success');

              case 7:
                _this.$router.push('/login');
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.log('password recover error', _context.t0);
                _this.$swal('Recupero password', 'Non è stato possibile recuperare la password. Assicurarsi di aver inserito uno username valido o che siano trascorsi almeno 10 minuti dall\'ultimo reset. ', 'error');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    },


    onExpired: function onExpired() {
      console.log('Expired');
      this.$refs.recaptcha.reset();
    },
    resetRecaptcha: function resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    }
  }
});

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(49);



//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.logout();
              _this.$router.push('/login');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['logout']))
});

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Download'
});

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(49);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Base',
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    plans: function plans(state) {
      return state.plans;
    },
    devices: function devices(state) {
      return state.devices;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['isAdmin', 'isProfileConfirmed'])),

  mounted: function mounted() {
    this.getData();
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getProfile', 'getDevices', 'getPlans', 'getTickets']), {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = _this.$loading.show();
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.getProfile(), _this.getDevices(), _this.getPlans(), _this.getTickets()]);

              case 4:

                loader.hide();
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                loader.hide();
                _this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    }
  })
});

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutationTypes__ = __webpack_require__(240);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PNF = __webpack_require__(89).PhoneNumberFormat;
var phoneUtil = __webpack_require__(89).PhoneNumberUtil.getInstance();


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Conferma',
  data: function data() {
    return {
      pass: {
        password: null,
        confirm: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.user;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['isAdmin', 'isProfileConfirmed'])),

  mounted: function mounted() {
    this.getData();
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getProfile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
    saveUserData: __WEBPACK_IMPORTED_MODULE_5__store_mutationTypes__["c" /* UPDATE_USER */]
  }), {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = _this.$loading.show();
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.getProfile()]);

              case 4:

                loader.hide();
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                loader.hide();
                _this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    phoneNumberFormatter: function phoneNumberFormatter(value, event) {
      var phoneNumber = phoneUtil.parse(value, 'IT');
      var formatted = phoneUtil.format(phoneNumber, PNF.E164);
      return formatted;
    },
    updateUser: function updateUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                if (!_this2.errors.any()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return _this2.$apiclient.updateProfile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                  first_name: _this2.user.first_name,
                  last_name: _this2.user.last_name,
                  email: _this2.user.email,
                  phone_number: _this2.user.phone_number
                }, _this2.pass));

              case 7:
                data = _context2.sent;


                _this2.saveUserData(data, null);
                _this2.$router.push('/area-riservata/piani');
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](4);

                console.log(_context2.t0);
                _this2.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 12]]);
      }))();
    },
    resetProfile: function resetProfile() {
      this.getProfile();
      this.$validator.reset('profile');
    }
  })
});

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutationTypes__ = __webpack_require__(240);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PNF = __webpack_require__(89).PhoneNumberFormat;
var phoneUtil = __webpack_require__(89).PhoneNumberUtil.getInstance();


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profilo',
  data: function data() {
    return {
      plansFields: [{
        key: 'code',
        label: 'Piano',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return row.plan.code + ': ' + (row.plan.name || row.plan.description || '-');
        }
      }, {
        key: 'devices_max',
        label: 'Dispositivi inclusi',
        sortable: true,
        formatter: function formatter(value, key, row) {
          if (row.plan.devices_max === 9999) return 'Illimitati';else if (row.plan.devices_max < 0) return 'N/A';
          return row.plan.devices_max;
        }
      }, {
        key: 'ticket_per_cycle',
        label: 'Interventi inclusi',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return '' + (row.ticket_per_cycle === 9999 || row.ticket_per_cycle === -1 ? 'Illimitati' : row.ticket_per_cycle);
        }
      }, { key: 'status', label: 'Stato', sortable: true }, {
        key: 'date_start',
        label: 'Attivazione',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }, {
        key: 'date_expiration',
        label: 'Scadenza',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }],
      devicesFields: [{ key: 'type', label: 'Tipo', sortable: true }, { key: 'device_name', label: 'Dispositivo', sortable: true }, { key: 'phone_number', label: 'Numero di telefono', sortable: true }, {
        key: 'last_access_time',
        label: 'Ultimo accesso',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }, {
        key: 'created_at',
        label: 'Primo accesso',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }],
      pass: {
        password: null,
        confirm: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    plans: function plans(state) {
      return state.plans;
    },
    devices: function devices(state) {
      return state.devices;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['isAdmin', 'isProfileConfirmed'])),

  mounted: function mounted() {
    this.getData();
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getProfile', 'getDevices', 'getPlans', 'getTickets']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
    saveUserData: __WEBPACK_IMPORTED_MODULE_5__store_mutationTypes__["c" /* UPDATE_USER */] // map `this.add()` to `this.$store.commit('increment')`
  }), {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = _this.$loading.show();
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.getProfile(), _this.getDevices(), _this.getPlans(), _this.getTickets()]);

              case 4:

                loader.hide();
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                loader.hide();
                _this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    phoneNumberFormatter: function phoneNumberFormatter(value, event) {
      var phoneNumber = phoneUtil.parse(value, 'IT');
      var formatted = phoneUtil.format(phoneNumber, PNF.E164);
      return formatted;
    },
    updateUser: function updateUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$validator.validateAll('profile');

              case 2:
                if (!_this2.errors.any()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return _this2.$apiclient.updateProfile({
                  first_name: _this2.user.first_name,
                  last_name: _this2.user.last_name,
                  email: _this2.user.email,
                  phone_number: _this2.user.phone_number
                });

              case 7:
                data = _context2.sent;


                _this2.saveUserData(data, null);
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                console.log(_context2.t0);
                _this2.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 11]]);
      }))();
    },
    updatePassword: function updatePassword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$validator.validateAll('password');

              case 2:
                if (!_this3.errors.any()) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return _this3.$apiclient.updateProfile(_this3.pass);

              case 7:
                _this3.user = _context3.sent;

                _this3.$toastr.info('Password aggiornata con successo');
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](4);

                console.log(_context3.t0);
                _this3.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 11]]);
      }))();
    },
    resetPassword: function resetPassword() {
      this.pass.password = null;
      this.pass.password_confirm = null;
      this.$validator.reset('password');
    },
    resetProfile: function resetProfile() {
      this.getProfile();
      this.$validator.reset('profile');
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_eventbus__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_plans_Schedule__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(49);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Piani',
  components: {
    Schedule: __WEBPACK_IMPORTED_MODULE_6__components_plans_Schedule__["a" /* default */]
  },
  data: function data() {
    return {
      user: {},
      plans: [],
      devices: [],

      plansFields: [{
        key: 'code',
        label: 'Piano',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return row.plan.code + ': ' + row.plan.name;
        }
      }, {
        key: 'devices_max',
        label: 'Dispositivi inclusi',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return '' + row.plan.devices_max;
        }
      }, {
        key: 'ticket_per_cycle',
        label: 'Interventi inclusi',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return '' + row.ticket_per_cycle;
        }
      }, { key: 'status', label: 'Stato', sortable: true }, {
        key: 'date_start',
        label: 'Attivazione',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }, {
        key: 'date_expiration',
        label: 'Scadenza',
        sortable: true,
        formatter: function formatter(value, key, row) {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    otherPlans: function otherPlans() {
      return this.plans.filter(function (p) {
        return p.plan.code.indexOf('SKC') < 0 && p.plan.code.indexOf('SKT') < 0;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.user;
    }
  })),

  mounted: function mounted() {
    this.getData();

    __WEBPACK_IMPORTED_MODULE_5__services_eventbus__["a" /* default */].$on('refresh_data', this.getData);
  },


  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loader, _ref, _ref2, user, devices, sub;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = _this.$loading.show();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.$apiclient.getProfile(), _this.$apiclient.getDevices(), _this.$apiclient.getPlans()]);

              case 3:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                user = _ref2[0];
                devices = _ref2[1];
                sub = _ref2[2];


                _this.user = user;
                _this.devices = devices;
                _this.plans = _this.mergePlansAndTickets(sub.plans, sub.tickets);

                loader.hide();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergePlansAndTickets: function mergePlansAndTickets(plans, tickets) {
      var res = [];

      plans.forEach(function (p) {
        var t = _.find(tickets, function (t) {
          return t.id === p.id;
        });
        p.ticket_used = t ? t.ticket_used : 0;
        res.push(p);
      });

      return res;
    },
    startSchedule: function startSchedule(category, sub) {
      console.log('Avvio prenotazione', sub);

      __WEBPACK_IMPORTED_MODULE_5__services_eventbus__["a" /* default */].$emit('schedule', {
        category: category,
        subcategory: sub.plan.name,
        phone_number: this.user.phone_number,
        email: this.user.email,
        name: this.user.first_name,
        subscription_id: sub.id
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_eventbus__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Schedule',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      step: 0,
      show: false,
      success: false,
      ticket_id: null,
      week: 0,
      hours: ['09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
      schedule: {
        type: 'Assistenza',
        category: null,
        subcategory: null,
        phone_number: null,
        email: null,
        onsite: false,
        product: 'google',
        product_dest: 'google',
        options: [],
        day: null,
        hour: null,
        customer_notes: '',
        name: '',
        subscription_id: null
      },

      services: {
        google: {
          name: 'G Suite',
          icon: 'google.svg',
          options: ['Gmail', 'Calendar', 'Google+', 'Hangout Chat', 'Hangout Meet', 'Documenti', 'Fogli', 'Moduli', 'Presentazioni', 'Sites', 'Keep', 'Drive', 'Google Cloud Search', 'Vault']
        },
        office365: {
          name: 'Office 365',
          icon: 'office.svg',
          options: ['Outlook', 'Onedrive', 'Word', 'Excel', 'Powerpoint', 'Onenote', 'Sharepoint', 'Teams', 'Staffhub', 'PowerApps', 'Forms', 'Delve', 'Dinamics365']
        },
        microsoft365: {
          name: 'Microsft 365',
          icon: 'microsoft_365.svg',
          options: ['Office applications', 'Collaboration services', 'Business Applications', 'Security', 'Device Management']
        },
        microsoft_ems: {
          name: 'Microsft EMS',
          icon: 'microsoft.svg',
          options: ['Azure Active Directory', 'Azure Information Protection', 'Microsoft Intune', 'Microsoft Cloud App Security', 'Microsoft Advanced Threat Analytics', 'Microsoft Identity Manager', 'Azure Advanced Threat Protection']
        }
      }
    };
  },

  computed: {
    collaborationServices: function collaborationServices() {
      return {
        google: this.services.google,
        office365: this.services.office365
      };
    },
    calendarDays: function calendarDays() {
      __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('it');
      var max_days = 5;
      var days = [];

      var m = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1 + this.week * 7, 'day').startOf('day');
      days.push(m.clone()); // add first day

      while (days.length < max_days) {
        m.add(1, 'day');

        // escludo sabato e domenica
        if (m.format('e') !== "5" && m.format('e') !== "6") days.push(m.clone());
      }
      return days;
    },
    eventTitle: function eventTitle() {
      return 'Skillo ' + this.schedule.category + ' - ' + this.schedule.subcategory;
    },
    eventStart: function eventStart() {
      var m = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.schedule.day);
      m.set('hour', this.schedule.hour);

      return m;
    },
    eventEnd: function eventEnd() {
      var m = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.schedule.day);
      m.set('hour', this.schedule.hour);
      m.add(2, 'hours');

      return m;
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__services_eventbus__["a" /* default */].$on('schedule', this.onSchedule);
    __WEBPACK_IMPORTED_MODULE_2__services_eventbus__["a" /* default */].$on('reschedule', this.onReschedule);
  },


  methods: {
    onSchedule: function onSchedule(data) {
      this.ticket_id = null;
      this.show = true;
      this.success = false;
      this.step = 0;
      this.product = 'google';
      this.product_dest = 'google';
      this.schedule.category = data.category;
      this.schedule.subcategory = data.subcategory;
      this.schedule.email = data.email;
      this.schedule.name = data.name;
      this.schedule.subscription_id = data.subscription_id;
      this.schedule.phone_number = data.phone_number;
      this.schedule.customer_notes = '';
      this.schedule.options = [];
      this.schedule.day = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'day').startOf('day');
      this.schedule.hour = '09';
    },
    onReschedule: function onReschedule(data) {
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var day = void 0;

      if (data.day.isBefore(now)) {
        day = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'day').startOf('day');
      } else {
        day = data.day;
      }

      this.ticket_id = data.id;
      this.show = true;
      this.step = 0;
      this.success = false;
      this.schedule.product = data.product;
      this.schedule.product_dest = data.product_dest;
      this.schedule.category = data.category;
      this.schedule.subcategory = data.subcategory;
      this.schedule.email = data.email;
      this.schedule.name = data.name;
      this.schedule.subscription_id = null;
      this.schedule.phone_number = data.phone_number;
      this.schedule.customer_notes = data.customer_notes;
      this.schedule.options = data.options;
      this.schedule.day = day;
      this.schedule.hour = data.hour;
    },
    currentStep: function currentStep(step) {
      return this.step === step;
    },
    nextStep: function nextStep() {
      this.step += 1;
    },
    prevStep: function prevStep() {
      if (!this.step) return;
      this.step -= 1;
    },
    nextWeek: function nextWeek() {
      if (this.week > 8) return;
      this.week += 1;
    },
    prevWeek: function prevWeek() {
      if (!this.week) return;

      this.week -= 1;
    },
    sendRequest: function sendRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var confirm, loader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$swal({
                  title: "Procedere con l'invio?",
                  text: "Procedendo, la richiesta verrà inviata e processata dal nostro back-office.",
                  icon: "warning",
                  buttons: ["Indietro", "INVIA RICHIESTA"]
                });

              case 2:
                confirm = _context.sent;

                if (confirm) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                _this.schedule.schedule_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.schedule.day);
                _this.schedule.schedule_date.set('hour', _this.schedule.hour);
                loader = _this.$loading.show();
                _context.prev = 8;

                if (!_this.ticket_id) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return _this.$apiclient.updateTicket(_this.ticket_id, _this.schedule);

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return _this.$apiclient.createTicket(_this.schedule);

              case 16:

                _this.nextStep();
                _this.success = true;

                loader.hide();
                __WEBPACK_IMPORTED_MODULE_2__services_eventbus__["a" /* default */].$emit('refresh_data');
                _context.next = 28;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](8);
                _context.next = 26;
                return _this.$swal("Errore Invio richiesta", _context.t0.message, "error");

              case 26:
                loader.hide();
                console.log(_context.t0);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 22]]);
      }))();
    }
  }
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_eventbus__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plans_Schedule__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateTicket__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Richieste',
  components: {
    Schedule: __WEBPACK_IMPORTED_MODULE_4__components_plans_Schedule__["a" /* default */], CreateTicket: __WEBPACK_IMPORTED_MODULE_5__CreateTicket__["a" /* default */]
  },
  props: {
    create: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      tickets: [],
      ticketToEdit: null,
      fields: [{
        key: 'num',
        label: 'Num.',
        sortable: true
      }, {
        key: 'status',
        label: 'Stato',
        sortable: true
      }, {
        key: 'category',
        label: 'Categoria',
        sortable: true
      }, {
        key: 'subcategory',
        label: 'Sub',
        sortable: true
      }, {
        key: 'slot',
        label: 'Appuntamento',
        sortable: true
      }, {
        key: 'created_at',
        label: 'Creato',
        sortable: true
      }, {
        key: 'closed_at',
        label: 'Chiuso',
        sortable: true
      }, {
        key: 'id',
        label: 'Gestisci',
        sortable: false
      }]
    };
  },

  mounted: function mounted() {
    this.getData();
    __WEBPACK_IMPORTED_MODULE_3__services_eventbus__["a" /* default */].$on('refresh_data', this.getData);
  },


  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$apiclient.getTickets();

              case 2:
                _this.tickets = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createTicket: function createTicket() {
      this.create = true;
      this.ticketToEdit = null;
    },
    editTicket: function editTicket(ticket) {
      this.ticketToEdit = ticket;
      this.create = true;
    },
    onTicketCreated: function onTicketCreated() {
      this.create = false;
      this.getData();
    },
    undoTicket: function undoTicket(ticket) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var confirm;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$swal({
                  icon: 'info',
                  title: 'Cancellazione Richiesta',
                  text: 'Procedere con la cancellazione della richiesta?',
                  buttons: ['Annulla', 'Procedi']
                });

              case 2:
                confirm = _context2.sent;

                if (confirm) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return _this2.$apiclient.createTicket({
                  ticket: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ticket, {
                    revoked: true,
                    status: 'Revocato'
                  })
                });

              case 8:

                _this2.$swal({
                  icon: 'success',
                  title: 'Cancellazione Richiesta',
                  text: 'Richiesta annullata correttamente.'
                });

                _this2.getData();
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](5);

                console.log('Creazione ticket', _context2.t0);
                _this2.$swal('Oops', 'Si è verificato un errore nella modifica del ticket.', 'error');

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 12]]);
      }))();
    },
    checkDisabled: function checkDisabled(item) {
      return item.closed || item.revoked || __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.slot.start).isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(3, 'days'));
    }
  }
});

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicket_vue__ = __webpack_require__(640);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328ba0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicket_vue__ = __webpack_require__(1320);
function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3328ba0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328ba0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(49);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateTicket",
  props: {
    edit: {
      type: Object,
      default: null,
      required: false
    }
  },
  data: function data() {
    return {
      calendarConfig: {
        timezone: "Europe/Rome",
        selectable: false,
        editable: false,
        defaultView: "agendaWeek",
        nowIndicator: true,
        header: {
          left: "prev,next today",
          center: "",
          right: "title"
        },
        themeSystem: "bootstrap4",
        locale: "it",
        allDaySlot: false,
        scrollTime: "09:00",
        minTime: "09:00",
        maxTime: "19:00"
      },
      devices: [],
      ticket: {
        type: null,
        customer_id: null,
        user_id: null,
        slot_id: null,
        device_id: null,
        device_serial: null,
        status: "Nuovo",
        customer_notes: "",
        activity: "Sostituzione Smartphone Aziendale",
        category: "Assistenza",
        subcategory: "Sostituzione Smartphone Aziendale",
        onsite_info: null
      },
      agendas: [],
      activities: [],
      slots: [],
      ticketTypes: [],
      ticketAcitivities: [{
        name: "Malfunzionamento: Hardware",
        category: "Malfunzionamento",
        subcategory: "Hardware"
      }, {
        name: "Malfunzionamento: Software",
        category: "Malfunzionamento",
        subcategory: "Software"
      }, {
        name: "Assistenza: Configurazioni generali",
        category: "Assistenza",
        subcategory: "Configurazioni generali"
      }, {
        name: "Assistenza: Ritiro Dispositivi",
        category: "Assistenza",
        subcategory: "Ritiro Dispositivi"
      }],
      selected: {
        day: null,
        slots: [],
        assistance: null,
        customer: null,
        user: null,
        device: null,
        slot: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    devices: function devices(state) {
      return state.devices;
    }
  }), {
    eventSources: function eventSources() {
      return [{
        events: this.getCalendareEvents
      }];
    }
  }),

  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.restoreData();
              _context.next = 3;
              return _this.getData();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$apiclient.getAgendas();

              case 2:
                _this2.ticketTypes = _context2.sent;


                if (_this2.ticketTypes.length > 0) {
                  _this2.onCalendarSelected(0);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onCalendarSelected: function onCalendarSelected(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.info('Selezionata agenda: ' + _this3.ticketTypes[id].code);

                _this3.ticket.type = _this3.ticketTypes[id].id;
                _this3.selected.slot = null;

                _this3.ticket.slot_id = null;

                _context3.next = 6;
                return _this3.$apiclient.getSlots(_this3.ticketTypes[id].id, moment().format("YYYY-MM-DD"), moment().add(30, 'days').endOf('week').format("YYYY-MM-DD"), "list");

              case 6:
                _this3.slots = _context3.sent;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onDaySelected: function onDaySelected(day) {
      this.ticket.slot_id = null;
      this.selected.slots = this.slots.find(function (d) {
        return d.day === day;
      }).slots;
    },
    createTicket: function createTicket() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var confirm, ticket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$validator.validateAll();

              case 2:
                if (!_this4.errors.any()) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return _this4.$swal({
                  icon: "info",
                  title: "Apertura Richiesta",
                  text: "Procedere con l'apertura della richiesta?",
                  buttons: ["Annulla", "Procedi"]
                });

              case 6:
                confirm = _context4.sent;

                if (confirm) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return");

              case 9:
                _context4.prev = 9;
                _context4.next = 12;
                return _this4.$apiclient.createTicket({
                  ticket: _this4.ticket
                });

              case 12:
                ticket = _context4.sent;


                _this4.$swal({
                  icon: "success",
                  title: "Apertura Richiesta",
                  text: "Richiesta aperta correttamente. Verrai ricontattato da uno dei nostri tecnici nello slot concordata."
                });

                _this4.$emit("ticket-created");
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](9);

                console.log("Creazione ticket", _context4.t0);
                _this4.$swal("Oops", "Non è stato possibile inviare la richiesta: " + _context4.t0.message, "error");

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[9, 17]]);
      }))();
    },
    undoCreation: function undoCreation() {
      this.$emit("ticket-created");
    },
    restoreData: function restoreData() {
      if (!this.edit) return;

      this.ticket.id = this.edit.id;
      this.ticket.type = this.edit.type;
      this.ticket.num = this.edit.num;
      this.ticket.activity = this.edit.activity;
      this.ticket.category = this.edit.category;
      this.ticket.subcategory = this.edit.subcategory;
      this.ticket.onsite_info = this.edit.onsite_info;
      this.ticket.customer_notes = this.edit.customer_notes;
      this.selected.slot = this.$moment(this.edit.slot.start).format("DD/MM/YYYY HH:mm");
      this.ticket.slot_id = this.edit.slot_id;
    },
    updateAgenda: function updateAgenda(agenda) {
      var _this5 = this;

      console.log("updateAgenda", agenda);

      // TODO: make it dynamic
      this.selected.assistance = agenda;
      this.selected.slot = null;
      this.ticket.slot_id = null;
      this.$nextTick(function () {
        return _this5.reloadEvents();
      });
    },
    getCalendareEvents: function getCalendareEvents(start, end, timezone, callback) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, slots;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.selected.assistance) {
                  _context5.next = 3;
                  break;
                }

                _this6.$toastr.warning("Selezionare una tipologia di slot");
                return _context5.abrupt("return", callback([]));

              case 3:
                _context5.next = 5;
                return _this6.$apiclient.getSlots(_this6.selected.assistance, start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"), "list");

              case 5:
                data = _context5.sent;
                slots = data.map(function (s) {
                  return {
                    id: s.id,
                    start: s.start,
                    end: moment(s.start).add(s.duration, "minutes")
                  };
                });


                console.log("slots", slots);

                return _context5.abrupt("return", callback(data));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    selectedActivity: function selectedActivity(selected) {
      var activity = _.find(this.ticketAcitivities, function (a) {
        return a.name === selected;
      });
      this.ticket.activity = selected;
      this.ticket.category = activity.category;
      this.ticket.subcategory = activity.subcategory;
    },
    reloadEvents: function reloadEvents() {
      this.$refs.calendar.$emit("refetch-events");
    },
    slotSelected: function slotSelected(slot) {
      this.ticket.slot_id = slot.id;
      this.selected.slot = this.$moment(slot.start).format("DD/MM/YYYY HH:mm");
    },
    getAddressData: function getAddressData(addressData) {
      console.log(addressData);
      this.ticket.onsite_info = this.parseAddressData(addressData);
    },
    parseAddressData: function parseAddressData(place) {
      if (!place.geometry) {
        return null;
      }

      var addressComponents = {
        formatted_address: "formatted_address",
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        administrative_area_level_2: "short_name",
        country: "long_name",
        postal_code: "short_name"
      };

      var returnData = {};
      returnData.formatted_address = place.formatted_address;

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData.latitude = place.geometry.location.lat();
        returnData.longitude = place.geometry.location.lng();

        return returnData;
      }
      return null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_eventbus__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plans_Schedule__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateTicket__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Richieste',
  components: {
    Schedule: __WEBPACK_IMPORTED_MODULE_3__components_plans_Schedule__["a" /* default */], CreateTicket: __WEBPACK_IMPORTED_MODULE_4__CreateTicket__["a" /* default */]
  },
  props: {
    create: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      tickets: [],
      ticketToEdit: null,
      fields: [{
        key: 'user',
        label: 'Dipendente',
        sortable: true
      }, {
        key: 'status',
        label: 'Stato',
        sortable: true
      }, {
        key: 'activity',
        label: 'Attività',
        sortable: true
      }, {
        key: 'slot',
        label: 'Appuntamento',
        sortable: true
      }, {
        key: 'created_at',
        label: 'Creato',
        sortable: true
      }, {
        key: 'managed_at',
        label: 'Preso in carico',
        sortable: true
      }, {
        key: 'closed_at',
        label: 'Chiuso',
        sortable: true
      }, {
        key: 'sla',
        label: 'SLA',
        sortable: true
      }]
    };
  },

  computed: {
    tickets_export: function tickets_export() {
      return this.tickets.map(function (t) {
        return {
          num: t.num,
          dipendente_nome: t.user.full_name,
          dipendente_mail: t.user.email,
          dipendente_phone: t.user.phone_number,
          dispositivo: t.device && t.device.os_name || '-',
          attivita: t.activity,
          stato: t.status,
          esito: t.resolution,
          creazione: __WEBPACK_IMPORTED_MODULE_5_moment___default()(t.created_at).format('LLL'),
          appuntamento: __WEBPACK_IMPORTED_MODULE_5_moment___default()(t.slot.start).format('LLL'),
          gestione: t.managed_at && __WEBPACK_IMPORTED_MODULE_5_moment___default()(t.managed_at).format('LLL') || '-',
          chiusura: t.closed_at && __WEBPACK_IMPORTED_MODULE_5_moment___default()(t.closed_at).format('LLL') || '-',
          sla_1: t.sla.sla_1,
          tempo_sla_1: t.sla.duration_sla_1,
          sla_2: t.sla.sla_2,
          tempo_sla_2: t.sla.duration_sla_2
        };
      });
    }
  },

  mounted: function mounted() {
    this.getData();
    __WEBPACK_IMPORTED_MODULE_2__services_eventbus__["a" /* default */].$on('refresh_data', this.getData);
  },


  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$apiclient.getCustomerTickets();

              case 2:
                _this.tickets = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createTicket: function createTicket() {
      this.create = true;
      this.ticketToEdit = null;
    },
    onTicketCreated: function onTicketCreated() {
      this.create = false;
      this.getData();
    }
  }
});

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_config__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chart_js__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_it__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_locale_en_gb__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_locale_en_gb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment_locale_en_gb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chart_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_it__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate_dist_locale_en__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate_dist_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vee_validate_dist_locale_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_google_maps__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_i18n__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_scrollto__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plugins_vue_components__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plugins_vue_toastr__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__plugins_vue_swal__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__plugins_vue_utils__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plugins_validators__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_modules_cosmo_css__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_modules_cosmo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_modules_cosmo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_modules_custom_css__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_modules_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_modules_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_vendors_font_icomoon_style_css__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_vendors_font_icomoon_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_vendors_font_icomoon_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__fortawesome_fontawesome_free_webfonts_css_fontawesome_css__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__fortawesome_fontawesome_free_webfonts_css_fontawesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__fortawesome_fontawesome_free_webfonts_css_fontawesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__fortawesome_fontawesome_free_webfonts_css_fa_regular_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__fortawesome_fontawesome_free_webfonts_css_fa_regular_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__fortawesome_fontawesome_free_webfonts_css_fa_regular_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__fortawesome_fontawesome_free_webfonts_css_fa_solid_css__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__fortawesome_fontawesome_free_webfonts_css_fa_solid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__fortawesome_fontawesome_free_webfonts_css_fa_solid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__fortawesome_fontawesome_free_webfonts_css_fa_brands_css__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__fortawesome_fontawesome_free_webfonts_css_fa_brands_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__fortawesome_fontawesome_free_webfonts_css_fa_brands_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__App__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__router__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__store__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__apiClient__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__authManager__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__filters__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__config__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__locales_it__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__locales_en__ = __webpack_require__(1330);
// import '@babel/polyfill';
// import 'mutationobserver-shim';
























































Object(__WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.silent = true;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_7_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26__plugins_vue_toastr__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__plugins_vue_swal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_chart_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28__plugins_vue_utils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__plugins_vue_components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_scrollto___default.a);

_.forOwn(__WEBPACK_IMPORTED_MODULE_45__filters__["a" /* default */], function (value, key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter(key, value);
});

__WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale('it');

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a, { moment: __WEBPACK_IMPORTED_MODULE_12_moment___default.a });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_config___default.a, __WEBPACK_IMPORTED_MODULE_46__config__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43__apiClient__["a" /* default */], {
  baseURL: __WEBPACK_IMPORTED_MODULE_46__config__["a" /* default */].API_BASE_URL + '/api/v1/'
});

__WEBPACK_IMPORTED_MODULE_17_vee_validate__["a" /* Validator */].localize('it', __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_it___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vee_validate__["b" /* default */], {
  locale: 'it',
  fieldsBagName: 'b-form-input',
  classNames: {
    touched: 'has-focused',
    untouched: 'untouched',
    valid: 'has-success',
    invalid: 'has-danger',
    pristine: '',
    dirty: 'has-warning'
  }

});

__WEBPACK_IMPORTED_MODULE_29__plugins_validators__["a" /* default */].register(__WEBPACK_IMPORTED_MODULE_17_vee_validate__["b" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_analytics___default.a, {
  id: 'UA-88845439-5',
  router: __WEBPACK_IMPORTED_MODULE_41__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue2_google_maps__, {
  load: {
    key: 'AIzaSyC5Hze25LKLcIhEpkkoVZtxutj4cJu_xfY',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_22_vue_i18n__["a" /* default */]({
  locale: 'it',
  messages: { it: __WEBPACK_IMPORTED_MODULE_47__locales_it__["a" /* default */], en: __WEBPACK_IMPORTED_MODULE_48__locales_en__["a" /* default */] },
  silentTranslationWarn: true
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  http: __WEBPACK_IMPORTED_MODULE_4_axios___default.a,
  auth: __WEBPACK_IMPORTED_MODULE_44__authManager__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_41__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_40__App__["a" /* default */] }
});

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 313,
	"./af.js": 313,
	"./ar": 314,
	"./ar-dz": 315,
	"./ar-dz.js": 315,
	"./ar-kw": 316,
	"./ar-kw.js": 316,
	"./ar-ly": 317,
	"./ar-ly.js": 317,
	"./ar-ma": 318,
	"./ar-ma.js": 318,
	"./ar-sa": 319,
	"./ar-sa.js": 319,
	"./ar-tn": 320,
	"./ar-tn.js": 320,
	"./ar.js": 314,
	"./az": 321,
	"./az.js": 321,
	"./be": 322,
	"./be.js": 322,
	"./bg": 323,
	"./bg.js": 323,
	"./bm": 324,
	"./bm.js": 324,
	"./bn": 325,
	"./bn.js": 325,
	"./bo": 326,
	"./bo.js": 326,
	"./br": 327,
	"./br.js": 327,
	"./bs": 328,
	"./bs.js": 328,
	"./ca": 329,
	"./ca.js": 329,
	"./cs": 330,
	"./cs.js": 330,
	"./cv": 331,
	"./cv.js": 331,
	"./cy": 332,
	"./cy.js": 332,
	"./da": 333,
	"./da.js": 333,
	"./de": 334,
	"./de-at": 335,
	"./de-at.js": 335,
	"./de-ch": 336,
	"./de-ch.js": 336,
	"./de.js": 334,
	"./dv": 337,
	"./dv.js": 337,
	"./el": 338,
	"./el.js": 338,
	"./en-au": 339,
	"./en-au.js": 339,
	"./en-ca": 340,
	"./en-ca.js": 340,
	"./en-gb": 194,
	"./en-gb.js": 194,
	"./en-ie": 341,
	"./en-ie.js": 341,
	"./en-il": 342,
	"./en-il.js": 342,
	"./en-nz": 343,
	"./en-nz.js": 343,
	"./eo": 344,
	"./eo.js": 344,
	"./es": 345,
	"./es-do": 346,
	"./es-do.js": 346,
	"./es-us": 347,
	"./es-us.js": 347,
	"./es.js": 345,
	"./et": 348,
	"./et.js": 348,
	"./eu": 349,
	"./eu.js": 349,
	"./fa": 350,
	"./fa.js": 350,
	"./fi": 351,
	"./fi.js": 351,
	"./fo": 352,
	"./fo.js": 352,
	"./fr": 353,
	"./fr-ca": 354,
	"./fr-ca.js": 354,
	"./fr-ch": 355,
	"./fr-ch.js": 355,
	"./fr.js": 353,
	"./fy": 356,
	"./fy.js": 356,
	"./gd": 357,
	"./gd.js": 357,
	"./gl": 358,
	"./gl.js": 358,
	"./gom-latn": 359,
	"./gom-latn.js": 359,
	"./gu": 360,
	"./gu.js": 360,
	"./he": 361,
	"./he.js": 361,
	"./hi": 362,
	"./hi.js": 362,
	"./hr": 363,
	"./hr.js": 363,
	"./hu": 364,
	"./hu.js": 364,
	"./hy-am": 365,
	"./hy-am.js": 365,
	"./id": 366,
	"./id.js": 366,
	"./is": 367,
	"./is.js": 367,
	"./it": 195,
	"./it.js": 195,
	"./ja": 368,
	"./ja.js": 368,
	"./jv": 369,
	"./jv.js": 369,
	"./ka": 370,
	"./ka.js": 370,
	"./kk": 371,
	"./kk.js": 371,
	"./km": 372,
	"./km.js": 372,
	"./kn": 373,
	"./kn.js": 373,
	"./ko": 374,
	"./ko.js": 374,
	"./ky": 375,
	"./ky.js": 375,
	"./lb": 376,
	"./lb.js": 376,
	"./lo": 377,
	"./lo.js": 377,
	"./lt": 378,
	"./lt.js": 378,
	"./lv": 379,
	"./lv.js": 379,
	"./me": 380,
	"./me.js": 380,
	"./mi": 381,
	"./mi.js": 381,
	"./mk": 382,
	"./mk.js": 382,
	"./ml": 383,
	"./ml.js": 383,
	"./mn": 384,
	"./mn.js": 384,
	"./mr": 385,
	"./mr.js": 385,
	"./ms": 386,
	"./ms-my": 387,
	"./ms-my.js": 387,
	"./ms.js": 386,
	"./mt": 388,
	"./mt.js": 388,
	"./my": 389,
	"./my.js": 389,
	"./nb": 390,
	"./nb.js": 390,
	"./ne": 391,
	"./ne.js": 391,
	"./nl": 392,
	"./nl-be": 393,
	"./nl-be.js": 393,
	"./nl.js": 392,
	"./nn": 394,
	"./nn.js": 394,
	"./pa-in": 395,
	"./pa-in.js": 395,
	"./pl": 396,
	"./pl.js": 396,
	"./pt": 397,
	"./pt-br": 398,
	"./pt-br.js": 398,
	"./pt.js": 397,
	"./ro": 399,
	"./ro.js": 399,
	"./ru": 400,
	"./ru.js": 400,
	"./sd": 401,
	"./sd.js": 401,
	"./se": 402,
	"./se.js": 402,
	"./si": 403,
	"./si.js": 403,
	"./sk": 404,
	"./sk.js": 404,
	"./sl": 405,
	"./sl.js": 405,
	"./sq": 406,
	"./sq.js": 406,
	"./sr": 407,
	"./sr-cyrl": 408,
	"./sr-cyrl.js": 408,
	"./sr.js": 407,
	"./ss": 409,
	"./ss.js": 409,
	"./sv": 410,
	"./sv.js": 410,
	"./sw": 411,
	"./sw.js": 411,
	"./ta": 412,
	"./ta.js": 412,
	"./te": 413,
	"./te.js": 413,
	"./tet": 414,
	"./tet.js": 414,
	"./tg": 415,
	"./tg.js": 415,
	"./th": 416,
	"./th.js": 416,
	"./tl-ph": 417,
	"./tl-ph.js": 417,
	"./tlh": 418,
	"./tlh.js": 418,
	"./tr": 419,
	"./tr.js": 419,
	"./tzl": 420,
	"./tzl.js": 420,
	"./tzm": 421,
	"./tzm-latn": 422,
	"./tzm-latn.js": 422,
	"./tzm.js": 421,
	"./ug-cn": 423,
	"./ug-cn.js": 423,
	"./uk": 424,
	"./uk.js": 424,
	"./ur": 425,
	"./ur.js": 425,
	"./uz": 426,
	"./uz-latn": 427,
	"./uz-latn.js": 427,
	"./uz.js": 426,
	"./vi": 428,
	"./vi.js": 428,
	"./x-pseudo": 429,
	"./x-pseudo.js": 429,
	"./yo": 430,
	"./yo.js": 430,
	"./zh-cn": 431,
	"./zh-cn.js": 431,
	"./zh-hk": 432,
	"./zh-hk.js": 432,
	"./zh-tw": 433,
	"./zh-tw.js": 433
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 976;

/***/ })

},[642]);


// WEBPACK FOOTER //
// static/js/app.e253794e0d81f9a10874.js